window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value;
  },

  /**
   * Constructs an object of key / value pairs out of the parameters of the query string
   *
   * @return {Object}
   */
  getQueryParams: function() {
    var queryString = location.search && location.search.substr(1) || '';
    var queryParams = {};

    queryString
      .split('&')
      .filter(function (element) {
        return element.length;
      })
      .forEach(function (paramValue) {
        var splitted = paramValue.split('=');

        if (splitted.length > 1) {
          queryParams[splitted[0]] = splitted[1];
        } else {
          queryParams[splitted[0]] = true;
        }
      });

    return queryParams;
  },

  /**
   * Returns empty string or query string with '?' prefix
   *
   * @return (string)
   */
  getQueryString: function() {
    var queryString = location.search && location.search.substr(1) || '';

    // Add the '?' prefix if there is an actual query
    if(queryString.length){
      queryString = '?' + queryString;
    }

    return queryString;
  },

  /**
   * Constructs a version of the current URL with the passed in key value pair as part of the query string
   * Will also remove the key if an empty value is passed in
   * See: https://gist.github.com/niyazpk/f8ac616f181f6042d1e0
   *
   * @param {String} key
   * @param {String} value
   * @param {String} uri - optional, defaults to window.location.href
   * @return {String}
   */
  getUrlWithUpdatedQueryStringParameter: function(key, value, uri) {

    uri = uri || window.location.href;

    // remove the hash part before operating on the uri
    var i = uri.indexOf('#');
    var hash = i === -1 ? ''  : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);

    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";

    if (!value) {
      // remove key-value pair if value is empty
      uri = uri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), '');
      if (uri.slice(-1) === '?') {
        uri = uri.slice(0, -1);
      }
      // replace first occurrence of & by ? if no ? is present
      if (uri.indexOf('?') === -1) uri = uri.replace(/&/, '?');
    } else if (uri.match(re)) {
      uri = uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
      uri = uri + separator + key + "=" + value;
    }
    return uri + hash;
  },

  /**
   * Constructs a version of the current URL with the passed in parameter key and associated value removed
   *
   * @param {String} key
   * @return {String}
   */
  getUrlWithRemovedQueryStringParameter: function(parameterKeyToRemove, uri) {
    uri = uri || window.location.href;

    var rtn = uri.split("?")[0],
        param,
        params_arr = [],
        queryString = (uri.indexOf("?") !== -1) ? uri.split("?")[1] : "";

    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === parameterKeyToRemove) {
                params_arr.splice(i, 1);
            }
        }
         if (params_arr.length > 0) {
          rtn = rtn + "?" + params_arr.join("&");
        }
    }

    return rtn;
  },

  /**
   * Check if we're running the theme inside the theme editor
   *
   * @return {bool}
   */
  isThemeEditor: function() {
    return location.href.match(/myshopify.com/) !== null && location.href.match(/theme_id/) !== null;
  },

  /**
   * Get the name of the correct 'transitionend' event for the browser we're in
   *
   * @return {string}
   */
  whichTransitionEnd: function() {
    var t;
    var el = document.createElement('fakeelement');
    var transitions = {
      'transition':'transitionend',
      'OTransition':'oTransitionEnd',
      'MozTransition':'transitionend',
      'WebkitTransition':'webkitTransitionEnd'
    };

    for(t in transitions){
      if( el.style[t] !== undefined ){
        return transitions[t];
      }
    }
  },

  /**
   * Adds user agent classes to the document to target specific browsers
   *
   */
  userAgentBodyClass: function() {
    var ua = navigator.userAgent,
        d = document.documentElement,
        classes = d.className,
        matches;

    // Detect iOS (needed to disable zoom on form elements)
    // http://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
    if ( /iPad|iPhone|iPod/.test(ua) && !window.MSStream ) {
      classes += ' ua-ios';

      // Add class for version of iOS
      matches = ua.match(/((\d+_?){2,3})\slike\sMac\sOS\sX/);
      if ( matches ) {
        classes += ' ua-ios-' + matches[1];// e.g. ua-ios-7_0_2
      }

      // Add class for Twitter app
      if ( /Twitter/.test(ua) ) {
        classes += ' ua-ios-twitter';
      }

      // Add class for Chrome browser
      if ( /CriOS/.test(ua) ) {
        classes += ' ua-ios-chrome';
      }
    }

    // Detect Android (needed to disable print links on old devices)
    // http://www.ainixon.me/how-to-detect-android-version-using-js/
    if ( /Android/.test(ua) ) {
      matches = ua.match(/Android\s([0-9\.]*)/);
      classes += matches ? ' ua-aos ua-aos-' + matches[1].replace(/\./g,'_') : ' ua-aos';
    }

    // Detect webOS (needed to disable optimizeLegibility)
    if ( /webOS|hpwOS/.test(ua) ) {
      classes += ' ua-webos';
    }

    // Detect Samsung Internet browser
    if ( /SamsungBrowser/.test(ua) ) {
      classes += ' ua-samsung';
    }

    d.className = classes;
  },

  /**
   * Generates a 32 bit integer from a string
   * Reference - https://stackoverflow.com/a/7616484
   *
   * @param {string}
   * @return {int}
   */
  hashFromString: function(string) {
    var hash = 0, i, chr;
    if (string.length === 0) return hash;
    for (i = 0; i < string.length; i++) {
      chr   = string.charCodeAt(i);
      hash  = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  },

  chosenSelects: function($container) {
    var $selects = $container ? $('select.form-control', $container) : $('select.form-control');
    $selects.not('[data-no-chosen]').chosen();

    // Allows browser autofill to function properly
    $selects.on('change', function() {
      $(this).trigger('chosen:updated');
    });
  },

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  },

  /**
   * Pluralizes the unit for the nuber passed in.
   * Usage mirrors the Shopify "pluralize" string filter
   *
   * @param {Number} number
   * @param {String} singular
   * @param {String} plural
   * @return {String}
   */
  pluralize: function(number, singular, plural)  {
    var output = '';

    number = parseInt(number);

    if(number == 1) {
      output = singular;
    }
    else {
      output = plural;
      if (typeof plural == "undefined") {
        output = singular + 's'; // last resort, turn singular into a plural
      }
    }
    return output;
  }

};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {

  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTables: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;
    
    options.$tables.addClass('table');
    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },  

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
    
    if (evt.target.id.includes('header_card_showcase') || evt.target.id.includes('header_rebuy_widget')) {
      evt.target.classList.add('active');
    }
    
    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
    
    if (evt.target.id.includes('header_card_showcase') || evt.target.id.includes('header_rebuy_widget')) {
      evt.target.classList.remove('active');
    }

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  /**
   * Removes '.00' if found at the end of the string
   *
   * @param  {string} value - formatted price (see above)
   * @return {string} value - formatted value
   */
  function stripZeroCents(string) {
    return string.replace(/\.00$/,'');
  }

  return {
    formatMoney: formatMoney,
    stripZeroCents: stripZeroCents
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */
  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      // js event dispatch
      const jsEvent = new CustomEvent("variantChange", { detail: variant });
      document.body.dispatchEvent(jsEvent);

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/**
 * AJAX Klaviyo Library
 * -----------------------------------------------------------------------------
 * Handles AJAX form submission and callback event
 *
 * Usage:
 *
 *   var $form = $('form');
 *   var listId = $form.data('list-id');
 *   var source = $form.data('source');
 *
 *   var options = {
 *     listId: listId,
 *     source: source,
 *     onSubscribeSuccess: function() { .. },
 *     onSubmitFail: function(){ .. }
 *   };
 *
 *   var ajaxKlaviyoForm = new slate.AjaxKlaviyoForm($form, options);
 *
 * @namespace ajaxKlaviyoForm
 */


slate.AjaxKlaviyoForm = (function($) {
  var classes = {
    checkboxHasError: 'has-error',
    formGroupHasError: 'alert-info'
  };

 /**
  * AJAX Klaviyo Form Constructor
  *
  * @param {HTMLElement | jQuery} form - Form element
  * @param {Object} options
  * @param {String} options.listId - Klaviyo List ID
  * @param {String} options.source - Klaviyo custom $source property
  * @param {String} options.newsletter - Klaviyo custom $newsletter property
  * @param {Function} options.onInit
  * @param {Function} options.onBeforeSend - Prevent AJAX submission by returning false here
  * @param {Function} options.onSubmitFail
  * @param {Function} options.onSubscribeSuccess
  * @param {Function} options.onSubscribeFail
  * @return {self}
  */
  function AjaxKlaviyoForm(form, options) {

    this.name = 'ajaxKlaviyoForm';
    this.namespace = '.' + this.name;
    this.events = {
      SUBMIT: 'submit' + this.namespace,
      CLICK: 'click' + this.namespace
    };

    var _this = this;
    var defaults = {
      source: "Shopify Form",
      onInit: $.noop,
      onBeforeSend: $.noop,
      onSubmitFail: $.noop,
      onSubscribeSuccess: $.noop,
      onSubscribeFail: $.noop
    };

    if (form.length === 0) {
      return false;
    }

    this.$form    = form instanceof jQuery ? form : $(form);
    this.$input   = this.$form.find('input[type="email"]');
    this.$newsletter = this.$form.find('[data-klaviyo-select-newsletter]');
    this.$checkboxes = this.$form.find('input[type="checkbox"]');
    this.$submit  = this.$form.find('[type="submit"]');
    this.settings = $.extend({}, defaults, options);

    if(!this.settings.listId) {
      console.warn('['+this.name+'] - Valid Klaviyo List ID required to initialize');
      return;
    }

    this.$form.on(this.events.SUBMIT, this.onFormSubmit.bind(_this));
    this.$checkboxes.on(this.events.CLICK, this.onCheckboxClick.bind(this));

    this.settings.onInit();

    return this;
  }

  AjaxKlaviyoForm.prototype = $.extend({}, AjaxKlaviyoForm.prototype, {
    logErrors: function(errors) {
      if(Array.isArray(errors) && errors.length) {
        for (var i = errors.length - 1; i >= 0; i--) {
          console.warn('['+this.name+'] - onSubmitFail error: "' + errors[i] + '"');
        }
      }
    },
    addCheckboxError: function ($checkbox) {
      $checkbox.parents('.checkbox').addClass(classes.checkboxHasError);
    },
    removeCheckboxError: function ($checkbox) {
      $checkbox.parents('.checkbox').removeClass(classes.checkboxHasError);
    },
    validateForm: function () {
      var self = this;
      var formValididation = true;

      // Need an email
      if (!this.$input.val() || this.$input.val().length == 0) {
        this.$input.parents('.form-group').addClass(classes.formGroupHasError);
        formValididation = false;
      }

      // Need all required checkboxes to be checked
      this.$checkboxes.each(function (i, check) {
        var $check = $(check);
        if ($check.is(':required') && !$check.is(":checked")) {
          self.addCheckboxError($check);
          formValididation = false;
        }
      });

      return formValididation;
    },
    onBeforeSend: function() {

      if(this.settings.onBeforeSend() == false) {
        return false;
      }

      if (this.$input.val() && this.$input.val().length) {
        this.$submit.prop('disabled', true);
        return true;
      } else {
        this.$input.parents('.form-group').addClass('alert-info');
      }

      return false;
    },
    onSubmitDone: function(response) {

      this.$submit.prop('disabled', false);

      if(response.success) {
        this.settings.onSubscribeSuccess(response);
      }
      else {
        this.logErrors(response.errors);
        this.settings.onSubscribeFail(response);
      }
    },
    onSubmitFail: function(errors) {

      this.$submit.prop('disabled', false);

      this.logErrors(errors);
      this.settings.onSubmitFail(errors);
    },
    onFormSubmit: function(e) {
      this.$newsletter.trigger('chosen:updated');
      
      e.preventDefault();
      var _this = this;

      $.ajax({
          async: true,
          crossDomain: true,
          url: "//manage.kmail-lists.com/ajax/subscriptions/subscribe",
          method: "POST",
          headers: {
              "content-type": "application/x-www-form-urlencoded",
              "cache-control": "no-cache"
          },
          data: {
              "g": this.settings.listId,
              "$fields": "$source, $newsletter",
              "email": this.$input.val(),
              "$source": this.settings.source,
              "$newsletter": this.$newsletter.find(':selected').val()
          },
          beforeSend: _this.onBeforeSend.bind(_this)
        })
        .done(function(response) {
          _this.onSubmitDone(response);
        })
        .fail(function(jqXHR, textStatus) {
          var errors = [];
          if(jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.hasOwnProperty('errors')) {
            errors = jqXHR.responseJSON.errors;
          }

          _this.onSubmitFail(errors);
        });

      return false;
    },
    onCheckboxClick: function (e) {
      this.removeCheckboxError($(e.currentTarget));
    }
  });

  return AjaxKlaviyoForm;
})(jQuery);

/**
 * Animation Helper Functions / constants
 * -----------------------------------------------------------------------------
 * A collection of functions that help with animations in javascript
 *
 */

slate.animations = (function($) {

  // First add some extra easing equations
  // To add more see the full library - https://github.com/danro/jquery-easing/blob/master/jquery.easing.js
  $.extend( $.easing, {
    // t: current time, b: begInnIng value, c: change In value, d: duration
    easeInQuint: function (x, t, b, c, d) {
      return c*(t/=d)*t*t*t*t + b;
    },
    easeOutQuint: function (x, t, b, c, d) {
      return c*((t=t/d-1)*t*t*t*t + 1) + b;
    },
    easeInOutQuint: function (x, t, b, c, d) {
      if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
      return c/2*((t-=2)*t*t*t*t + 2) + b;
    }
  });

  // Match those set in variables.scss
  var _transitionTimingDurations = {
    base:     300,
    fast:     150,
    fastest:  50,
    slow:     600,
    medium:   400,
    none:     0
  };

  var _transitionTimingFunctions = {
    base:      'ease-in-out',
    in:        'ease-out',
    out:       'ease-in',
    inOutUI:   'cubic-bezier(0.42, 0, 0.13, 1.04)'
  };

 /**
  * Get one of the durations stored in the variable defined above
  * If the requested duration doesn't exist, fallback to the base
  *
  * @param {string} key - string matching one of the key names
  * @return {int} - duration in ms
  */
  function getTransitionTimingDuration(key) {
    var k = 'base';
    if(_transitionTimingDurations.hasOwnProperty(key)) {
      k = key;
    }
    return _transitionTimingDurations[k];
  }

 /**
  * Get one of the timing functions stored in the variable defined above
  * If the requested function doesn't exist, fallback to the base
  *
  * @param {string} key - string matching one of the key names
  * @return {string} - valid css timing function
  */
  function getTransitionTimingFunction(key) {
    var k = 'base';
    if(_transitionTimingFunctions.hasOwnProperty(key)) {
      k = key;
    }
    return _transitionTimingFunctions[k];
  }

  return {
    getTransitionTimingDuration: getTransitionTimingDuration,
    getTransitionTimingFunction: getTransitionTimingFunction
  };

}(jQuery));
/**
 * User Scripts
 * -----------------------------------------------------------------------------
 * Mostly handles cookie setting / removal, logic around user sessions
 *
 * @namespace user
 */

slate.user = (function(Cookies) {

  var cookiePrefix = '_sunbum_';

 /**
  * User constructor
  */
  function User() {
    this.name = 'user';
    this.namespace = '.' + this.name;

    // Do any initialization here
    // For instance, you could increment a cookie that tracks visits to the site

    return this;
  }

  User.prototype = $.extend({}, User.prototype, {

   /**
    * Library of cookies to use throughout the site.
    * Use the `generateCookie` method below to create your own copies of these.  Don't access these directly.
    */
    _cookies: {
      siteVisit: {
        name: cookiePrefix + 'site_visit',
        value: true
      },
      subscriptionSlideupSeen: {
        name: 'subscriptionSlideup_seen',
        value: true
      },
      subscriptionModalSeen: {
        name: 'subscriptionModal_seen',
        value: true
      },
      emailCollected: {
        name: 'emailCollected',
        value: true
      }
    },

   /**
    * Creates and returns a copy of one of the cookies available above
    *
    * @param {String} key
    * @return {Object | undefined}
    */
    generateCookie: function(key) {
      var c;
      if(this._cookies.hasOwnProperty(key)) {
        c = $.extend(true, {}, this._cookies[key]);
        c.name = cookiePrefix + c.name;
      }
      else {
        console.warn('['+this.name+'] - Cannot create cookie.  Key "' + key + '" not found.' );
      }
      return c;
    },

   /**
    * Sets a browser cookie
    *
    * @param {Object} cookie
    * @param {String} cookie.name
    * @param {String} cookie.value
    * @param {Number} cookie.expiration - Time to expire in days, expires after session if left blank
    */
    setCookie: function(cookie) {
      if(this.hasCookie(cookie.name) && this.getCookieValue(cookie.name) != cookie.value){
        this.removeCookie(cookie.name);
      }

      var opts = cookie.hasOwnProperty('expiration') ? { expires : cookie.expiration } : {};
      Cookies.set( cookie.name, cookie.value, opts );

      return this;
    },

   /**
    * Checks for the presence of a browser cookie by name (doesn't check for value equality)
    *
    * @param {String} cookieName
    * @return {Boolean}
    */
    hasCookie: function(cookieName) {
      return typeof Cookies.get( cookieName ) !== "undefined";
    },

   /**
    * Returns value of browser cookie by name
    *
    * @param {String} cookieName
    * @return {String | Undefined}
    */
    getCookieValue: function(cookieName) {
      return this.hasCookie( cookieName ) ? Cookies.get( cookieName ) : undefined;
    },

   /**
    * Removes a cookie by name
    *
    * @param {String} cookieName
    * @return {Self}
    */
    removeCookie: function(cookieName) {
      Cookies.remove( cookieName );
      return this;
    }
  });

  return new User();

}(Cookies));

/**
 * AJAX Cart scripts
 * ------------------------------------------------------------------------------
 *
 * This is a bare-bones but completely usable implementation of an AJAX enabled cart
 * 
 * Usage: slate.AjaxCart.init(options);
 *
 *
 */

(function($, slate) {

  if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

  /*============================================================================
    API Functions
  ==============================================================================*/

  /**
   * AJAX submit an 'add to cart' form
   *
   * @param {jQuery} $form - jQuery instance of the form
   * @return {Promise} - Resolve returns JSON cart | Reject returns an error message
   */
  ShopifyAPI.addItemFromForm = function($form, sampleProduct, matchingProductType) {
    var promise = $.Deferred();

    function addSampleProduct() {
      var sampleProductContain = sampleProduct.toString();

      var sampleProductObject = {}

      if (sampleProductContain.indexOf(',') > 1){
        sampleProductObject['items']= [];
        var  myArray = sampleProduct.split(",");
        for (let i = 0; i < myArray.length; i++) {
          sampleProductObject['items'][i]= {}
          sampleProductObject['items'][i]['quantity'] = 1;
          sampleProductObject['items'][i]['id'] = myArray[i];
        }
      }else{
        sampleProductObject['quantity'] = 1;
        sampleProductObject['id'] = sampleProduct;
      }

      
      $.ajax({
        type: 'post',
        dataType: 'json',
        url: '/cart/add.js',
        data: sampleProductObject,
        success: function() {
          ShopifyAPI.getCart().then(function(data) {
            promise.resolve(data);   
          });         		
        },
        error: function(xhr) {
          promise.reject({
            message: xhr.message
          });
        }
      });
    }

    $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/add.js',
      data: $form.serialize(),
      success: function(response) {
        ShopifyAPI.getCart().then(function(cart) {
          var productTypeQty = 0;
          var sampleAlreadyOnCart = false

          cart.items.forEach(function(item) {
//             if (item.product_type == matchingProductType) {
              if (matchingProductType.indexOf(item.product_type) > -1) { 
              
              productTypeQty = productTypeQty + item.quantity;

            }
         var sampleProductContain = sampleProduct.toString();
 if (sampleProductContain.indexOf(item.variant_id) > -1){
//             if (item.variant_id == sampleProduct) {
              sampleAlreadyOnCart = true;
            }
          })
          if (productTypeQty >= 1 && sampleProduct && !sampleAlreadyOnCart) {
            addSampleProduct();
          } else {
            ShopifyAPI.getCart().then(function(cart) {
              promise.resolve(cart);
            });
          }
        });
        
        var p_title = response.product_title;
        var p_img = response.featured_image.url;
        if(response.options_with_values[0]){
          var p_varTitle1 = response.options_with_values[0]["name"];
          var p_p_varVal1 = response.options_with_values[0]["value"];
        }
        if(response.options_with_values[1]){
          var p_varTitle2 = response.options_with_values[1]["name"];
          var p_p_varVal2 = response.options_with_values[1]["value"];
        }
        if(response.options_with_values[2]){
          var p_varTitle3 = response.options_with_values[2]["name"];
          var p_p_varVal3 = response.options_with_values[2]["value"];
        }
        var p_price = slate.Currency.formatMoney(response.price, theme.moneyFormat); 
        $('.mini-cart-main').fadeIn();
        $('html').addClass('mini-popup-open');
        $('.ItemImg img').attr('src', p_img);
        $('.ItemTitle').text(p_title);
        $('.ItemPrice').text(p_price);
        if(p_varTitle1 != undefined && p_p_varVal1 != "Default Title" ){
          $('.ItemVariant1Name').text(p_varTitle1 + ':');
          $('.ItemVariant1Property').html(p_p_varVal1);
        }
        if(p_varTitle2 != undefined){
          $('.ItemVariant2Name').text(p_varTitle2 + ':');
          $('.ItemVariant2Property').html(p_p_varVal2);
        }
        if(p_varTitle3 != undefined){
          $('.ItemVariant3Name').text(p_varTitle3 + ':');
          $('.ItemVariant3Property').html(p_p_varVal3);
        }
        
      },
      error: function() {
        promise.reject({
          message: 'The quantity you entered is not available.'
        });
      }
    });

    return promise;
  };

  /**
   * Retrieve a JSON respresentation of the users cart
   *
   * @return {Promise} - JSON cart
   */
  ShopifyAPI.getCart = function() {
    var promise = $.Deferred();

    var url = slate.utils.isThemeEditor() ? '/cart.js' : '/cart?view=json'; // Theme editor inserts HTML comments in custom templates and breaks JSON response

    $.ajax({
      type: 'get',
      url: url,
      success: function(data) {
        var cart = JSON.parse(data);
        promise.resolve(cart);
      },
      error: function() {
        promise.reject({
          message: 'Could not retrieve cart items'
        });
      }
    });

    return promise;
  };

  /*============================================================================
    Ajax Shopify Add To Cart
  ==============================================================================*/
  slate.Cart = (function() {

    var $body = $('body');

    var selectors = {
      sampleProduct: '[data-sample-product]',
      addForm: 'form[action^="/cart/add"]',
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]'
    };

    /**
     * AjaxCart constructor
     *
     * Adds an `init` method with access to private variables inside the contructor
     */
    function Cart() {
      this.name = 'cart';
      this.namespace = '.' + this.name;

      var initialized = false;

      this.requestInProgress = false;

      /**
       * Initialize the cart
       *
       */
      this.init = function() {
        if (initialized) return;

        this.$sampleProduct = $(selectors.sampleProduct);
        this.sampleProduct = this.$sampleProduct.data('sample-product');
        this.matchingProductType = this.$sampleProduct.data('matching-product-type');

        this._formOverride();

        initialized = true;

        return initialized;
      };

      return this;
    }

    Cart.prototype = $.extend({}, Cart.prototype, {

      /**
       * Call this function to AJAX-ify any add to cart forms on the page
       */
      _formOverride: function() {
        $body.on('submit', selectors.addForm, function(e) {
          e.preventDefault();

          if (this.requestInProgress) return;

          var $submitButton = $(e.target).find(selectors.addToCart);
          var $submitButtonText = $submitButton.find(selectors.addToCartText);

          // Update the submit button text and disable the button so the user knows the form is being submitted
          $submitButton.prop('disabled', true);
          //$submitButtonText.html(theme.strings.adding);

          this._onRequestStart();

          ShopifyAPI.addItemFromForm($(e.target), this.sampleProduct, this.matchingProductType)
            .then(function(data) {
              this._onRequestFinish();
              // Reset button state
              $submitButton.prop('disabled', false);
              $submitButtonText.html(theme.strings.addToCart);
            //  window.location.replace("/cart");
            }.bind(this)).fail(function(data) {
              this._onRequestFinish();
              // Reset button state
              $submitButton.prop('disabled', false);
              $submitButtonText.html(theme.strings.addToCart);
            }.bind(this));
        }.bind(this));
      },

      _onRequestStart: function() {
        this.requestInProgress = true;
      },

      _onRequestFinish: function() {
        this.requestInProgress = false;
      },
    });

    return Cart;
  })();

})(jQuery, slate);

/**
 * Breakpoint Helper Functions / constants
 * -----------------------------------------------------------------------------
 * A collection of functions that help with dealing with site breakpoints in JS
 * All breakpoint properties should be defined here
 *
 */

slate.breakpoints = (function($) {

  var $window = $(window);
  var cachedWindowWidth = $window.width(); 

  // Match those set in variables.scss
  var _breakpointMinWidths = {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1480
  };

  var events = {
    BREAKPOINT_CHANGE: 'breakpointChange',
  };


 /**
  * Get one of the widths stored in the variable defined above
  *
  * @param {string} key - string matching one of the key names
  * @return {int} - pixel width
  */
  function getBreakpointMinWidth(key) {
    if(!key) return;

    if(_breakpointMinWidths.hasOwnProperty(key)) {
      return _breakpointMinWidths[key];
    }
  }

 /**
  * Gets the key for one of the breakpoint widths, whichever is closest but smaller to the passed in width
  * So if we pass in a width between 'sm' and 'md', this will return 'sm'
  *
  * @param {int} w - width
  * @return {undefined|string} foundKey
  */
  function getBreakpointMinWidthKeyForWidth(w) {
    w = w != undefined ? w : $window.width();
    
    var foundKey;

    $.each(_breakpointMinWidths, function(k, bpMinWidth) {
      if(w >= bpMinWidth) {
        foundKey = k;
      }
    });

    return foundKey;
  }

 /**
  * Triggers a window event when a breakpoint is crossed, passing the new minimum breakpoint width key as an event parameter
  *
  */
  function onResize() {
    var newWindowWidth = $window.width();

    $.each(_breakpointMinWidths, function(k, bpMinWidth) {
      if( (newWindowWidth >= bpMinWidth && cachedWindowWidth < bpMinWidth) || (cachedWindowWidth >= bpMinWidth && newWindowWidth < bpMinWidth) ) {
        
        var bpMinWidthKey = getBreakpointMinWidthKeyForWidth(newWindowWidth);
        var e = $.Event(events.BREAKPOINT_CHANGE, { bpMinWidthKey: bpMinWidthKey });
        $window.trigger(e);
        return false;

      }
    });

    cachedWindowWidth = $window.width();
  }

  $window.on('resize', $.throttle(20, onResize) );

  return {
    getBreakpointMinWidth: getBreakpointMinWidth,
    getBreakpointMinWidthKeyForWidth: getBreakpointMinWidthKeyForWidth
  };

}(jQuery));

/**
 * Product Card Scripts
 * -----------------------------------------------------------------------------
 * Handles any events associated with the product card html (see snippets/product-card.liquid)
 */

slate.productCard = (function() {

  var selectors = {
    el: '[data-product-card]',
    gallery: '[data-product-card-gallery]',
    mainLazyImg: '[data-product-card-main-lazy]',
    altLazyImg: '[data-product-card-alt-lazy]'
  };

  var classes = {
    mainLoaded: 'is-loaded',
    altLoaded: 'alt-loaded' // added to the product card once the alt image is loaded to avoid a flash of white while loading
  };
 
  var events = window.PointerEvent ? {
              end:   "pointerup",
              enter: "pointerenter",
              leave: "pointerleave"
            } : {
              end: "touchend",
              enter: "mouseenter",
              leave: "mouseleave"
            };

  function onEnter(e) {
    var $productCard = $(e.currentTarget);
    var $lazyImg = $productCard.find( selectors.altLazyImg );

    if($lazyImg.length) {
      $lazyImg.on('load', function() {
        $productCard.addClass(classes.altLoaded);
      });
      $lazyImg.attr('src', $lazyImg.data('src'));
      $lazyImg.removeAttr('data-src');
    }
  }

  $(document).ready(function() {

    var $productCards = $(selectors.el);

    if(!$productCards.length) {
      return;
    }

    $productCards.one(events.enter, onEnter);

    // Unveil plugin to lazy load main product card images
    $(selectors.mainLazyImg).unveil(200, function() {
      var $img = $(this);
      $img.on('load', function() {
        $img.parents(selectors.gallery).addClass(classes.mainLoaded);
      });
    });
  });

  

}());
/**
 * Product Detail Form Script
 * ------------------------------------------------------------------------------
 *
 * Handles all functionality related to contents of snippets/product-detail-form.liquid
 * Core functionality includes:
 *  - Variant selecting + callbacks
 *  - Variant galleries + slideshow initializing
 *
 * Requires:
 *  - jQuery
 *  - Modernizr (for Modernizr.touchevents)
 *  - Slate (for slate.Currency)
 */

// Requires slate for slate.Currency

slate.ProductDetailForm = (function($, Modernizr, slate) {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    mediaStack: '[data-pdp-media-stack]',
    mediaStackMedia: '[data-pdp-media-stack] [data-product-varient]',
    mediaStackControl: '[data-pdp-media-stack-controls]',
    mediaDots: '[data-pdp-media-dots] [data-product-varient]',
    mediaDotsWrapper: '[data-pdp-media-dots]',
    productDetailGrid: '[data-product-details-grid]',
    productDetailMedia: '[data-product-details-media]',
    productDetailHeader: '[data-product-details-header]',
    productDetailFooter: '[data-product-details-footer]',
    productZoomButton: '[data-zoom-button]',
    productGallery: '[data-product-gallery]',
    productGallerySlideshow: '[data-product-gallery-slideshow]',
    productGallerySlideLink: '[data-product-gallery-slide-link]',
    productGalleryThumbnails: '[data-product-gallery-thumbnails]',
    productGalleryThumbnailsSlide: '[data-product-gallery-thumbnails-slide]',
    initialSlide: '[data-initial-slide]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    singleOptionSelector: '[data-single-option-selector]',
    variantOptionValueList: '[data-variant-option-value-list][data-option-position]',
    variantOptionValue: '[data-variant-option-value]',
    quantitySelect: '[data-product-quantity-select]',
    fullDetailsLink: '[data-full-details-link]',
    videoPlayer: '[data-video-player]',
    oosButton: '[data-oos-cta]',
    addToCartForm: '[data-add-to-cart-form]'
  };


  var classes = {
    hide: 'hide',
    variantOptionValueActive: 'is-active',
    zoomReady: 'is-zoomable',
    zoomedIn: 'is-zoomed'
  };

  var $window = $(window);

  /**
   * ProductDetailForm constructor
   *
   * @param { Object } config
   * @param { jQuery } config.$el - Main element, see snippets/product-detail-form.liquid
   * @param { jQuery } config.$container - Container to listen to scope events / element to listen to events on.  Defaults to config.$el
   * @param { Boolean } config.enableZoom - Toggle zoom capabilities on / off
   * @param { Boolean } config.enableHistoryState - If set to "true", turns on URL updating when switching variants
   * @param { Function } config.onReady -  Called after the product form is initialized.
   */
  function ProductDetailForm(config) {

    this.settings = {};
    this.name = 'productDetailForm';
    this.namespace = '.' + this.name;

    this.events = {
      RESIZE: 'resize' + this.namespace,
      CLICK: 'click' + this.namespace,
      READY: 'ready' + this.namespace
    };

    var ready = false;
    var options = options || {};
    var defaults = {
      enableZoom: true,
      enableHistoryState: true
    };

    this.initialize = function() {
      if (ready) {
        return;
      }

      this.settings = $.extend({}, defaults, config);

      if (!this.settings.$el || this.settings.$el == undefined) {
        console.warn('[' + this.name + '] - $el required to initialize');
        return;
      }

      this.$el = this.settings.$el;
      this.$container = this.settings.$container;

      if (!this.$container || this.$container == undefined) {
        this.$container = this.$el;
      }

      this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

      var variantOptions = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(variantOptions);

      // See slate.Variants
      this.$container.on('variantChange' + this.namespace, this.onVariantChange.bind(this));

      this.initGalleries();
      this.initMediaStack();
      this.initStickyScroll();

      this.$container.on(this.events.CLICK, selectors.variantOptionValue, this.onVariantOptionValueClick.bind(this));

      // Out Of Stock Dialog Pop Up
      this.$container.on(this.events.CLICK, selectors.oosButton, (e) => {
        const {variants:{product, currentVariant}} = this;
        window.dialog_oos?.open(product.title,null,currentVariant.id);
      })

      var e = $.Event(this.events.READY);
      this.$el.trigger(e);

      ready = true;
    };

    return this;
  }

  ProductDetailForm.prototype = $.extend({}, ProductDetailForm.prototype, {

    initMediaStack: function() {
      const {matches} = window.matchMedia("(max-width: 991px)");
      if (!matches) return;
      // manage dots for slideshow
      const container = this.$container[0]; // only use of jQuery - keep vanilla below
      const media = container.querySelectorAll(selectors.mediaStackMedia);
      const wrapper = container.querySelector(selectors.mediaStack);
      const options = { root: wrapper, rootMargin: "0px 40% 0px 40%", threshold: 1 };
      const callback = (entries, observer) => {
        entries.forEach(({intersectionRatio, target}) => {
          if (intersectionRatio === 0) return;
          const mediaID = target.dataset.mediaId;
          const dot = container.querySelector(`.media-slide-dot[data-media-id="${mediaID}"]`);
          if (intersectionRatio === 1){
            dot.classList.add('is-visible');
          } else {
            dot.classList.remove('is-visible');
          }
        })
      }
      // click handling with event delegation
      const clickHandler = (event) => {
        const target = event.target.nodeName === 'BUTTON' ? event.target.parentElement : event.target;
        const mediaID = target.dataset.mediaId;
        if (!mediaID) return;
        const match = [...media].find(item => item.dataset.mediaId === mediaID);
        wrapper.scrollTo({
          top: 0,
          left: match.offsetLeft,
          behavior: 'smooth'
        });
      }
      const observer = new IntersectionObserver(callback, options);
      media.forEach((item) => observer.observe(item));
      container.querySelector(selectors.mediaDotsWrapper)?.addEventListener('click', clickHandler);
    },

    initStickyScroll: function() {
      const container = this.$container[0]; // only use of jQuery - keep vanilla below
      const detailGrid = container.querySelector(selectors.productDetailGrid);
      if (!detailGrid || detailGrid.children.length === 0) return;
      if (detailGrid.classList.contains('product-details--compact')) return;
      const footer = container.querySelector(selectors.productDetailFooter);
      const media = container.querySelector(selectors.productDetailMedia);
      const resize = () => {
        detailGrid.style.setProperty('--resize-padding-bottom',`${footer.offsetHeight}px`);
        detailGrid.style.setProperty('--resize-top',`calc(-${media.offsetHeight}px + 100vh)`);
        detailGrid.style.setProperty('--resize-height',`${media.offsetHeight +  footer.offsetHeight}px`);
      }
      const resizeObserver = new ResizeObserver(() => resize());
      resizeObserver.observe(footer);
      resizeObserver.observe(media);
      window.addEventListener("resize", () => {resize()});
      resize();
    },

    initGalleries: function() {
      var self = this;
      var $galleries = $(selectors.productGallery, this.$container);
      var ambassadorCardParent = this.$container.closest($(".product-card--ambassador"));
      if (ambassadorCardParent.length > 0) {
        hasAmbassadorCardParent = true;
      } else {
        hasAmbassadorCardParent = false;
      }

      // Lifecycle methods for handling slideshow changes + hoverzoom initialization
      function initHoverZoom($zoomTarget) {
        var opts = {
          url: $zoomTarget.find(selectors.productGallerySlideLink).attr('href'),
          on: 'click',
          touch: false,
          escToClose: true,
          magnify: 0.8,
          duration: 300,
          callback: function() {
            $zoomTarget.addClass(classes.zoomReady);
          },
          onZoomIn: function() {
            $zoomTarget.addClass(classes.zoomedIn);
            $zoomTarget.find(selectors.productGallerySlideLink).hide();
          },
          onZoomOut: function() {
            $zoomTarget.removeClass(classes.zoomedIn);
            $zoomTarget.find(selectors.productGallerySlideLink).show();
          }
        };

        $zoomTarget.zoom(opts);

        $zoomTarget.find(selectors.productZoomButton).on('click', function(e) {
          $zoomTarget.trigger('click');
          return false;
        });

      }

      function destroyHoverZoom($zoomTarget) {
        $zoomTarget.trigger('zoom.destroy');
        $zoomTarget.find(selectors.productZoomButton).off('click');
      }

      function onSlideshowSlickBeforeChange(e, slick) {
        var $zoomTarget = $(slick.$slides[slick.currentSlide]);
        if (self.settings.enableZoom) {
          destroyHoverZoom($zoomTarget);
        }
        slate.videoPlayer.pauseVideosInContainer($(slick.$slides[slick.currentSlide]));
      }

      function onSlideshowSlickAfterChange(e, slick) {
        var $zoomTarget = $(slick.$slides[slick.currentSlide]);
        if (self.settings.enableZoom) {
          initHoverZoom($zoomTarget);
        }
      }

      function onSlideshowSlickInit(e, slick) {
        var $zoomTarget = $(slick.$slides[slick.currentSlide]);
        if (self.settings.enableZoom) {
          initHoverZoom($zoomTarget);
        }

        slate.videoPlayer.reInitVideoPlayers();
      }

      $galleries.each(function() {
        var $slideshow = $(this).find(selectors.productGallerySlideshow);
        var $thumbnails = $(this).find(selectors.productGalleryThumbnails);

        // Look for element with the initialSlide selector.
        var initialSlide = $(this).find(selectors.initialSlide).length ? $(this).find(selectors.initialSlide).index() : 0;

        var thumbnailsSlidesToShow;
        var thumbnailsSlidesCount = $thumbnails.children().length;
        var hasThumbnailSlideshow = thumbnailsSlidesCount > 4 ? true : false;

        // Slick has trouble when slideToShow == slideCount
        if (thumbnailsSlidesCount < 4) {
          thumbnailsSlidesToShow = Math.max(thumbnailsSlidesCount - 1, 1);
        } else {
          thumbnailsSlidesToShow = thumbnailsSlidesCount == 4 ? 3 : 4;
        }

        if (hasAmbassadorCardParent) {
          thumbnailsSlidesToShow = 4;
          $thumbnails.addClass('product-gallery__thumbnails-wrapper--is-ambassador');
        }

        $slideshow.on({
          init: onSlideshowSlickInit,
          beforeChange: onSlideshowSlickBeforeChange,
          afterChange: onSlideshowSlickAfterChange
        });
        var slideshowOptions = {
          speed: 600,
          dots: (thumbnailsSlidesCount > 1 ? true : false),
          arrows: false,
          infinite: false,
          swipe: Modernizr.touchevents,
          initialSlide: initialSlide,
          draggable: true,
          accessibility: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                arrows: true,
                appendDots: $('.product-gallery--mobile__dots'),
                nextArrow: $('.product-gallery--mobile__arrow-next'),
                prevArrow: $('.product-gallery--mobile__arrow-prev')
              }
            }
          ]
        };
        if (hasThumbnailSlideshow) {
          slideshowOptions.asNavFor = "#" + $thumbnails.attr("id");
        }
        $slideshow.slick(slideshowOptions);

        if (thumbnailsSlidesCount > 4) {
          $thumbnails.slick({
            speed: 600,
            slidesToShow: thumbnailsSlidesToShow,
            slidestoScroll: 1,
            infinite: false,
            arrows: thumbnailsSlidesCount > 4 ? true : false,
            prevArrow: $('.product-gallery__thumbnails-arrow--prev'),
            nextArrow: $('.product-gallery__thumbnails-arrow--next'),
            asNavFor: "#" + $slideshow.attr("id"),
            initialSlide: initialSlide,
            accessibility: false,
            draggable: false,
            vertical: true,
            verticalSwiping: true,
            dots: false
          });

          $thumbnails.addClass('product-gallery__thumbnails-wrapper--has-arrows');
        } else {
          $('.product-gallery__thumbnails-arrow').hide();
        }

        $thumbnails.on('click', selectors.productGalleryThumbnailsSlide, function(e) {
          $slideshow.slick('slickGoTo', $(e.currentTarget).index());
        });

      });

      // Because slick can get weird on initialization, make sure we call `refresh` on any visible galleries
      $galleries.not('.hide').each(function() {
        var $variantGallery = $(this);
        $variantGallery.find(selectors.productGallerySlideshow).slick('getSlick').refresh();

        var $thumbnails = $(
          selectors.productGalleryThumbnails,
          $variantGallery
        )
        var hasThumbnailSlideshow = $thumbnails.length > 4 ? true : false;
        if (hasThumbnailSlideshow) {
          $variantGallery.find(selectors.productGalleryThumbnails).slick('getSlick').refresh();
        }
      });
    },

    /**
     * Slick sliders are annoying and sometimes need an ass kicking
     *
     */
    resizeGalleries: function() {
      $('.slick-slider', this.$container).resize();
    },


    onVariantChange: function(evt) {
      var variant = evt.variant;

      this.updateProductPrices(variant);
      this.updateAddToCartState(variant);
      this.updateQuantityDropdown(variant);
      this.updateVariantOptionValues(variant);
      this.updateFullDetailsLink(variant);
      this.updateGalleries(variant);
      this.updateMediaStack(variant);

      $(selectors.singleOptionSelector, this.$container).trigger('chosen:updated');
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {Object} variant - Shopify variant object
     */
    updateAddToCartState: function(variant) {

      var $addToCartBtn = $(selectors.addToCart, this.$container);
      var $addToCartBtnText = $(selectors.addToCartText, this.$container);
      var $priceWrapper = $(selectors.priceWrapper, this.$container);
      var $form = $(selectors.addToCartForm, this.$container);

      if (variant) {
        $priceWrapper.removeClass(classes.hide);
      } else {
        $addToCartBtn.prop('disabled', true);
        $addToCartBtnText.html(theme.strings.unavailable);
        $priceWrapper.addClass(classes.hide);
        return;
      }

      if (variant.available) {
        $addToCartBtn.prop('disabled', false);
        $addToCartBtnText.html(theme.strings.addToCart);
        $form.removeClass('product-detail-form--not-available');
      } else {
        $addToCartBtn.prop('disabled', true);
        $addToCartBtnText.html(theme.strings.soldOut);
        $form.addClass('product-detail-form--not-available');
      }
    },

    /**
     * Updates the disabled property of the quantity select based on the availability of the selected variant
     *
     * @param {Object} variant - Shopify variant object
     */
    updateQuantityDropdown: function(variant) {

      var $select = $(selectors.quantitySelect, this.$container);

      // Close the dropdown while we make changes to it
      $select.trigger('chosen:close');

      if (variant && variant.available) {
        $select.prop('disabled', false);
      }
      else {
        $select.prop('disabled', true);
      }

      $select.trigger('chosen:updated');

    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {Object} variant - Shopify variant object
     */
    updateProductPrices: function(variant) {
      var $productPrice = $(selectors.productPrice, this.$container);
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add($(selectors.comparePriceText, this.$container));

      if (variant) {
        $productPrice.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

        if (variant.compare_at_price > variant.price) {
          $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
          $compareEls.removeClass(classes.hide);
        } else {
          $comparePrice.html('');
          $compareEls.addClass(classes.hide);
        }
      }
    },

    /**
     * Updates the DOM state of the elements matching the variantOption Value selector based on the currently selected variant
     *
     * @param {Object} variant - Shopify variant object
     */
    updateVariantOptionValues: function(variant) {
      if (variant) {
        // Loop through all the options and update the option value
        for (var i = 1; i <= 3; i++) {
          var variantOptionValue = variant['option' + i];

          if (!variantOptionValue) break; // Break if the product doesn't have an option at this index

          // Since we are finding the variantOptionValueUI based on the *actual* value, we need to scope to the correct list
          // As some products can have the same values for different variant options (waist + inseam both use "32", "34", etc..)
          var $variantOptionValueList = $(selectors.variantOptionValueList, this.$container).filter('[data-option-position="' + i + '"]');
          var $variantOptionValueUI = $('[data-variant-option-value="' + variantOptionValue + '"]', $variantOptionValueList);

          $variantOptionValueUI.addClass(classes.variantOptionValueActive);
          $variantOptionValueUI.siblings().removeClass(classes.variantOptionValueActive);
        }
      }
    },

    /**
     * Used on quick view, updates the "view full details" link to point to the currently selected variant
     *
     * @param {Object} variant - Shopify variant object
     */
    updateFullDetailsLink: function(variant) {
      var $fullDetailsLink = $(selectors.fullDetailsLink, this.$container);
      var updatedUrl;

      if (variant && $fullDetailsLink.length) {
        updatedUrl = slate.utils.getUrlWithUpdatedQueryStringParameter('variant', variant.id, $fullDetailsLink.attr('href'));
        $fullDetailsLink.attr('href', updatedUrl);
      }
    },

    updateMediaStack: function(variant) {
      const {matches} = window.matchMedia("(max-width: 991px)");
      const {id:variantId, featured_image:{id:imageId}} = variant;
      const container = this.$container[0]; // only use of jQuery - keep vanilla below
      const media = container.querySelectorAll(selectors.mediaStackMedia);
      const mediaWrapper = container.querySelector(selectors.mediaStack);
      const dots = container.querySelectorAll(selectors.mediaDots);
      let mediaCount = 0;
      if (!mediaWrapper) return;
      // toggle the display of product image based on variant
      media.forEach((item) => {
        const dataVariant = Number(item.dataset.productVarient);
        const dataImage = Number(item.dataset.productVarientImageId);
        // 3 conditional cases: variants have images, all varients use same image, no variant has an image
        if (dataVariant === variantId || dataImage === imageId || dataImage === dataVariant) {
          item.classList.add('is-active');
          mediaCount = mediaCount + 1;
          if (item.children[0].tagName === 'IMG') item.children[0].setAttribute('loading','eager');
        } else {
          item.classList.remove('is-active');
        }
      })
      // if mobile - update the dots
      if (matches) {
        dots.forEach((item) => {
          const dataVariant = Number(item.dataset.productVarient);
          if (dataVariant === variant.id) {
            item.classList.add('is-active');
          } else {
            item.classList.remove('is-active');
          }
          item.classList.remove('is-visible');
        })
      }
      // reset the scroll position
      if (!matches) {
        window.scrollTo(0,0);
      } else {
        mediaWrapper.scrollTo(0,0);
      }
    },

    /**
     * Look for a gallery matching one of the selected variant's options and switch to that gallery
     * If a matching gallery doesn't exist, look for the variant's featured image in the main gallery and switch to that
     *
     * @param {Object} variant - Shopify variant object
     */
    updateGalleries: function(variant) {

      var $galleries = $(selectors.productGallery, this.$container);

      function getVariantGalleryForOption(option) {
        return $galleries.filter(function() {
          return $(this).data('variant-gallery') == option;
        });
      }

      if (variant) {
        if ($galleries.length > 1) {
          for (var i = 3; i >= 1; i--) {
            var $variantGallery = getVariantGalleryForOption(variant['option' + i]);

            if ($variantGallery.length && $variantGallery.hasClass(classes.hide)) {
              $galleries.not($variantGallery).addClass(classes.hide);
              $variantGallery.removeClass(classes.hide);
              // Slick needs to make a lot of measurements in order to work, calling `refresh` forces this to happen
              $variantGallery.find(selectors.productGallerySlideshow).slick('getSlick').refresh();
              // $variantGallery.find(selectors.productGalleryThumbnails).slick('getSlick').refresh();
            }
          }
        }
        else {
          // $galleries is just a single gallery
          // Slide to featured image for selected variant but only if we're not already on it.
          // Have to check this way because slick clones slides so even if we're currently on it, there can be a cloned slide that also has the correct data-image attribute
          if (variant.featured_image && $galleries.find('.slick-current').data('image') != variant.featured_image.id) {
            var $imageSlide = $galleries.find('[data-image="' + variant.featured_image.id + '"]').first();

            if ($imageSlide.length) {
              $galleries.find(selectors.productGallerySlideshow).slick('slickGoTo', $imageSlide.data('slick-index'));
            }
          }
        }
      }
      else {
        // No variant - Don't do anything?
      }
    },

    /**
     * Handle variant option value click event.
     * Update the associated select tag and update the UI for this value
     *
     * @param {event} evt
     */
    onVariantOptionValueClick: function(e) {

      var $option = $(e.currentTarget);

      if ($option.hasClass(classes.variantOptionValueActive)) {
        return;
      }

      var value = $option.data('variant-option-value');
      var position = $option.parents(selectors.variantOptionValueList).data('option-position');
      var $selector = $(selectors.singleOptionSelector, this.$container).filter('[data-index="option' + position + '"]');

      $selector.val(value);
      $selector.trigger('change');

      $option.addClass(classes.variantOptionValueActive);
      $option.siblings().removeClass(classes.variantOptionValueActive);

    }
  });

  return ProductDetailForm;

})(jQuery, Modernizr, slate);

/**
 * Quantity Adjuster Scripts
 * -----------------------------------------------------------------------------
 * Handles any events associated with the quantity adjuster component
 *
 *  [data-quantity-adjuster]
 *    [data-increment]
 *    input[type="number"]
 *    [data-decrement]
 *
 */

slate.quantityAdjuster = (function() {

  var selectors = {
    adjuster: '[data-quantity-adjuster]',
    increment: '[data-increment]',
    decrement: '[data-decrement]',
    input: 'input[type="number"]'
  };

  var classes = {

  };

  /**
   * Quantity Adjuster Constructor
   *
   * @param {HTMLElement | jQuery} el - element, either matching selectors.adjuster or a child element
   */
  function QuantityAdjuster(el) {

    this.name = 'quantityAdjuster',
    this.namespace = '.'+this.name;

    this.$el = $(el).is(selectors.adjuster) ? $(el) : $(el).parents(selectors.adjuster);

    if(!this.$el) {
      console.warn('['+this.name+'] - Element required to initialize');
      return;
    }

    this.$increment = $(selectors.increment, this.$el);
    this.$decrement = $(selectors.decrement, this.$el);
    this.$input     = $(selectors.input, this.$el);

    this.$increment.on('click', this.onIncrementClick.bind(this));
    this.$decrement.on('click', this.onDecrementClick.bind(this));
    this.$input.on('change', this.onInputChange.bind(this));

    this._addMutationObserver(this.$input.get(0));

    this._updateDisabledState();
  }

  QuantityAdjuster.prototype = {

    _getMin: function() {
      return parseInt(this.$input.attr('min')) || 0;
    },

    _getMax: function() {
      return parseInt(this.$input.attr('max')) || 999;
    },

    _addMutationObserver: function(el) {
      if(!el) return;

      var observer;
      var config = { attributes: true };
      var self = this;

      observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if(mutation.type == "attributes") {
            if(mutation.attributeName == "max" || mutation.attributeName == "min") {
              self.onMinMaxAttributeChange();
            }
            else if(mutation.attributeName == "disabled") {
              self.onDisabledAttributeChange();
            }
          }
        });
      });

      observer.observe(el, config);
    },

    _updateDisabledState: function() {
      var val = parseInt(this.$input.val());

      if(this.$input.is(':disabled')) {
        this.$increment.prop('disabled', true);
        this.$decrement.prop('disabled', true);
      }
      else {
        if (val == this._getMax() && val == this._getMin()) {
          this.$increment.prop('disabled', true);
          this.$decrement.prop('disabled', true);
        }
        else if(val >= this._getMax()) {
          this.$increment.prop('disabled', true);
          this.$decrement.prop('disabled', false);
        }
        else if(val <= this._getMin()) {
          this.$increment.prop('disabled', false);
          this.$decrement.prop('disabled', true);
        }
        else {
          this.$increment.prop('disabled', false);
          this.$decrement.prop('disabled', false);
        }
      }
    },

    _changeValue: function(amount) {

      if(this.$input.is(':disabled') || typeof amount == "undefined") return;

      amount = parseInt(amount);

      var val = parseInt(this.$input.val());
      var newVal = val + amount;

      // Don't change if the value is the same or invalid
      if(newVal == val || newVal > this._getMax() || newVal < this._getMin()) return;

      this.$input.val(newVal);
      this.$input.trigger('change');
    },

    _clampInputVal: function() {
      var currVal = parseInt(this.$input.val());
      var max = this._getMax();
      var min = this._getMin();

      if(currVal > max) {
        this.$input.val(max);
      }
      else if(currVal < min) {
        this.$input.val(min);
      }
    },

    onDisabledAttributeChange: function() {
      this._updateDisabledState();
    },

    onMinMaxAttributeChange: function() {
      this._clampInputVal();
      this._updateDisabledState();
    },

    onInputChange: function() {
      this._clampInputVal();
      this._updateDisabledState();
    },

    onIncrementClick: function(e) {
      e.preventDefault();
      this._changeValue(1);
    },

    onDecrementClick: function(e) {
      e.preventDefault();
      this._changeValue(-1);
    }
  };

  // End prototype

  // QA DATA-API
  // ===========

  var dataKey = 'quantity-adjuster';

  function ensureQuantityAdjuster(el) {
    var $el =  $(el);

    if(!$el.is(selectors.adjuster)) {
      $el = $el.parents(selectors.adjuster);
    }

    var data = $el.data(dataKey);

    if(!data) {
      $el.data(dataKey, (data = new QuantityAdjuster($el)));
    }

    return data;
  }

  // Check all adjuster elements on the page and initialize them if necessary
  function refresh() {
    $(selectors.adjuster).each(function(i, el) {
      ensureQuantityAdjuster(el);
    });
  }

  $(function() {

    refresh();

    $(document)
      .on('shopify:section:load', refresh)
      .on('shopify:section:unload', refresh)
      .on('shopify:section:select', refresh)
      .on('shopify:section:deselect', refresh)
      .on('shopify:section:reorder', refresh)
      .on('shopify:block:select', refresh)
      .on('shopify:block:deselect', refresh);
  });

  return {
    refresh: refresh
  };

}());

/**
 * Forms Scripts
 * -----------------------------------------------------------------------------
 * Handles any events associated with forms on the site
 */

slate.forms = (function($) {

  var selectors = {
    formControl: '.form-control',
    formGroup: '.form-group'
  };

  var classes = {
   formGroupIsFocused: 'is-focused',
   formGroupHasError: 'has-error'
  };

  var $body = $(document.body);
 
  var initialized = false;

  function onFormControlFocus(e) {
    var $formControl = $(e.currentTarget);
    var $formGroup   = $formControl.parents(selectors.formGroup);

    $formGroup.addClass(classes.formGroupIsFocused);
  }

  function onFormControlBlur(e) {
    var $formControl = $(e.currentTarget);
    var $formGroup   = $formControl.parents(selectors.formGroup);

    $formGroup.removeClass(classes.formGroupIsFocused);    
  }

  function removeFormControlErrorState(e) {
    var $formControl = $(e.currentTarget);
    var $formGroup   = $formControl.parents(selectors.formGroup);

    $formGroup.removeClass(classes.formGroupHasError);
  }

  function initialize() {
    if(initialized) return;

    $body.on('focus', selectors.formControl, onFormControlFocus);
    $body.on('blur',  selectors.formControl, onFormControlBlur);
    $body.on('change keydown', selectors.formControl, removeFormControlErrorState);

    initialized = true;
    
    return initialized;
  }

  return {
    initialize: initialize
  };

}(jQuery));
/**
 * Video Player Script
 * -----------------------------------------------------------------------------
 *
 * Creates a YouTube player out of basic markup
 * Requires some basic styling to make things work correctly - see components/video-player.scss
 *
 * Mark up looks like...
 *
    <div id="video-player-{{ yt_video_id }}" class="video-player" data-video-id="{{ yt_video_id }}" data-video-type="vimeo / youtube" data-video-player>
      <a href="#"  class="video-player__cover" data-video-player-cover>
        <div class="video-player__cover-still" style="background-image: url(...);"></div>
        <span class="video-player__cover-play">{% include 'icon-play-button' %}</span>
      </a>
      <div class="video-player__embed" data-video-player-embed></div>
    </div>
 *
 */

slate.videoPlayer = (function($, Vimeo) {

  var selectors = {
    videoPlayer: '[data-video-player]',
    videoPlayerEmbed: '[data-video-player-embed]',
    videoPlayerCover: '[data-video-player-cover]',
    youtubeVideo: '.video-player__embed'
  };

  var classes = {
    state: {
      playing:  'video-player--playing',
      finished: 'video-player--finished',
      paused:   'video-player--paused',
    }
  };

  function VideoPlayer(el) {
    this.name = 'videoPlayer',
    this.namespace = '.'+this.name;

    this.$el = $(el);

    if(!this.$el.is(selectors.videoPlayer)) {
      console.warn('['+this.name+'] - Element matching ' + selectors.videoPlayer + ' required to initialize');
      return;
    }

    this.VIDEO_TYPES = {
      VIMEO: 'vimeo',
      YOUTUBE: 'youtube'
    };

    this.player    = null;
    this.state     = null;
    this.videoType = this.$el.data('video-type').toLowerCase();
    this.videoId   = this.$el.data('video-id');
    this.background = this.$el.data('background');

    if(!this.videoId || !(this.videoType == "vimeo" || this.videoType == "youtube") ) {
      console.warn('['+this.name+'] - Video ID and valid video type required to initialize');
      return;
    }

    this.$embed = this.$el.find(selectors.videoPlayerEmbed);
    this.$cover = this.$el.find(selectors.videoPlayerCover);
    this.$cover.attr('title', 'Click to play');

    // We bind vimeo videos up front because the API can't be loaded async
    // So it's already on the page
    // And it does a weird thing where it pauses if you play immediately after ready
    if(this.videoType == this.VIDEO_TYPES.VIMEO) {
      this.bindVimeoPlayer();
    }

    this.$cover.on('click', this.onCoverClick.bind(this));
  }

  VideoPlayer.prototype = {

    _getClassForCurrentState: function() {
      if(this.state && classes.state.hasOwnProperty(this.state)) {
        return classes.state[this.state];
      }
    },

    bindVimeoPlayer() {
      const opts = {
        id: this.videoId,
        color: '00A4E3' // brand primary
      };

      opts.background = this.background || false;
      opts.muted      = this.background;
      opts.autoplay   = this.background;

      this.player = new Vimeo.Player(this.$embed, opts);

      this.player.on('ended', this.onEnded.bind(this));
      this.player.on('play',  this.onPlay.bind(this));
      this.player.on('pause', this.onPaused.bind(this));
      this.player.on('bufferstart', this.onBuffering.bind(this));

      if (!this.background && !this.$cover.length ) {
        this.$cover.on('click', this.onCoverClick.bind(this));
      }
    },

    switchToState(state) {
      this.$el.removeClass(classes.state[this.state]);
      this.$el.addClass(classes.state[state]);
      
      this.state = state;
    },

    onPlay() {
      this.switchToState('playing');
    },

    onEnded() {
      this.switchToState('ended');
    },

    onPaused() {
      this.switchToState('paused');
    },

    onBuffering() {
      this.switchToState('buffering');
    },

    bindYTPlayer: function() {
      var self = this;
      var uniqID = this.$el.attr('id') + '-player';

      this.$embed.attr('id', uniqID);
      this.player = new YT.Player(uniqID, {
          videoId: this.videoId,
          playerVars: {
            rel: 0,
            autohide: 1,
            controls: 2,
            playsinline: 1,
            modestbranding: 1,
            wmode: "transparent",
          },
          events: {
            onReady: function(e) {
              e.target.playVideo();
            },
            onStateChange: function(e) {
              switch (e.data) {
              case YT.PlayerState.PLAYING:
                  self.onPlaying();
                  break;
              case YT.PlayerState.PAUSED:
                  self.onPaused();
                  break;
              case YT.PlayerState.ENDED:
                  self.onFinished();
              }
            }
          }
        });

      window.videoList = window.videoList || [];

      window.videoList.push({
        dataKey: this.videoId,
        player: this
      });
    },

    switchToState: function(state) {
      this.$el.removeClass( this._getClassForCurrentState());

      this.state = state;

      this.$el.addClass(this._getClassForCurrentState());
    },

    play: function() {
      if(this.videoType == this.VIDEO_TYPES.YOUTUBE) {
        this.player.playVideo();
      }
      else if (this.videoType == this.VIDEO_TYPES.VIMEO) {
        this.player.play().then(this.onPlaying.bind(this));
      }
    },

    pause: function() {
      if(this.videoType == this.VIDEO_TYPES.YOUTUBE) {
        this.player.pauseVideo();
      }
      else if (this.videoType == this.VIDEO_TYPES.VIMEO) {
        this.player.pause().then(this.onPaused.bind(this));
      }
    },


    onPlaying: function() {
      this.switchToState('playing');
    },

    onFinished: function() {
      this.switchToState('finished');
    },

    onPaused: function() {
      this.switchToState('paused');
    },

    onCoverClick: function(e) {
      e.preventDefault();

      if(this.player) {
        this.play();
      }
      else {

        if(this.videoType == this.VIDEO_TYPES.YOUTUBE) {
          if(typeof window.YT == "undefined") {

            window.onYouTubeIframeAPIReady = this.bindYTPlayer.bind(this);

            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
          }
          else {
            this.bindYTPlayer();
          }
        }
        // else if (this.videoType == this.VIDEO_TYPES.VIMEO) {
        //   this.bindVimeoPlayer();
        // }
      }

      return false;
    }
  };

  // DATA-API
  // ========

  var dataKey = 'video-player-instance';

  $(function() {
    $(selectors.videoPlayer).each(function(i, el) {
      var $el =  $(el);

      var data = $el.data(dataKey);

      if(!data) {
        $el.data(dataKey, (data = new VideoPlayer($el)));
      }

      window.videoList = window.videoList || [];

      window.videoList.push({
        dataKey: $el.data('video-id'),
        player: data
      })

      return data;
    });
  });


  // Returned Module
  return {
    getDataKey: function() {
      return dataKey;
    },
    reInitVideoPlayers: function() {
      $(selectors.videoPlayer).each(function(i, el) {
        var $el =  $(el);
  
        var data = $el.data(dataKey);
  
        if(!data) {
          $el.data(dataKey, (data = new VideoPlayer($el)));
        }
  
        return data;
      });
    },
    pauseVideosInContainer: function($el) {
      $el.find(selectors.videoPlayer).each(function(index, videoContainer) {
        var videoId = $(videoContainer).data('video-id');
        $.each(window.videoList, function(index, val) {
           if (val.dataKey === videoId) {
            val.player.pause();
           }
        });

      });
    }
  };

}(jQuery, Vimeo));

/**
 * Model - Dropdown
 * -----------------------------------------------------------------------------
 * Dropdowns are just elements that respond to a visibility class in order to hide and show
 *
 * @namespace models.dropdown
 */

 slate.models = slate.models || {};

 slate.models.Dropdown = (function($) {

  var classes = {
    open: 'is-open',
    forcedOpen: 'is-forced-open'
  };

  /**
   * Dropdown - Exposes methods for opening and closing the dropdown.  All logic is handled externally
   *
   * @constructor
   * @param {jQuery} $trigger - Element with attributes 'data-dropdown-trigger' and 'data-block'
   */
  function Dropdown($trigger) {
    this.$trigger = $trigger;
    this.$el      = $( this.$trigger.data('dropdown-trigger') );
    this.blockId  = this.$trigger.data('block').toString();
  }

  Dropdown.prototype = {

    isOpen: function() {
      return this.$el.hasClass( classes.open );
    },

    open: function() {
      this.$el.addClass( classes.open );
      this.$trigger.addClass(classes.open);
    },

    close: function() {
      this.$el.removeClass( classes.open );
      this.$trigger.removeClass(classes.open);
    },

    /**
     * Dropdown manager doesn't use the forced open class
     * So we can use it in conjunction with the theme editor to ensure dropdowns are open while editing
     */
    forceOpen: function() {
      this.$el.addClass( classes.forcedOpen );
    },

    forceClose: function() {
      this.$el.removeClass( classes.forcedOpen );
    }

  };

  return Dropdown;

 }(jQuery));
/**
 * Model - DropdownManager
 * -----------------------------------------------------------------------------
 *
 * Requires:
 *  - slate.models.Dropdown
 *  - slate.utils
 *
 * @namespace models.DropdownManager
 */

 slate.models = slate.models || {};

 slate.models.DropdownManager = (function($) {

  /**
   * DropdownManager - Manages opening / closing of all dropdowns.  Makes sure only one shows at a time.
   *
   * @constructor
   * @param {function} dropdownConstructor
   */
  function DropdownManager() {

    this.closeDropdownTimeout = null;
    this.closeDropdownTimeoutDuration = 80;
    this.dropdowns = [];
    this.activeDropdown = undefined;

    this.events = window.PointerEvent ? {
                  end:   "pointerup",
                  enter: "pointerenter",
                  leave: "pointerleave"
                } : {
                  end: "touchend",
                  enter: "mouseenter",
                  leave: "mouseleave"
                };

  }

  DropdownManager.prototype = {
    register: function($trigger) {
      var dd = new slate.models.Dropdown($trigger);

      // Trigger events - the link that you interact with to display the dropdown
      dd.$trigger.on(this.events.enter,  this.onTriggerMouseEnter.bind(this, dd));
      dd.$trigger.on(this.events.leave,  this.onTriggerMouseLeave.bind(this, dd));
      dd.$trigger.on(this.events.end,    this.onTriggerTouchEnd.bind(this, dd));

      // Dropdown events - what happens when you interact with the dropdown itself
      dd.$el.on(this.events.leave, this.onDropdownMouseLeave.bind(this, dd));
      dd.$el.on(this.events.enter, this.onDropdownMouseEnter.bind(this, dd));
      dd.$el.on(this.events.end,   this.onDropdownTouchEnd.bind(this, dd));

      this.dropdowns.push(dd);
    },    
    getDropdownByBlockId: function(id) {
      return slate.utils.findInstance(this.dropdowns, 'blockId', id);
    },
    onTriggerMouseEnter: function(dd, e) {
      if(e.pointerType != "touch") {
        this.stopCloseTimeout();
        this.openDropdown(dd);
      }
    },
    onTriggerMouseLeave: function(dd, e) {
      if(e.pointerType != "touch") {
        this.startCloseTimeout(dd);
      }
    },
    onTriggerTouchEnd: function(dd, e) {
      e.preventDefault();
      e.stopPropagation();
      this.toggleDropdown(dd);
    },
    onDropdownMouseEnter: function(dd, e) {
      if(e.pointerType != "touch") {
        this.stopCloseTimeout();
      }
    },
    onDropdownMouseLeave: function(dd, e) {
      if(e.pointerType != "touch") {
        this.startCloseTimeout(dd);
      }
    },
    onDropdownTouchEnd: function(dd, e) {
      e.stopPropagation();
    },
    toggleDropdown: function(dd) {
      return this.activeDropdown == dd ? this.closeDropdown(dd) : this.openDropdown(dd);
    },
    openDropdown: function(dd) {
      if(this.activeDropdown !== dd) {
        this.activeDropdown = dd;
        this.closeAllDropdowns();
        dd.open();
      }
    },
    closeDropdown: function(dd) {
      dd.close();

      if(this.activeDropdown == dd) {
        this.activeDropdown = undefined;
      }
    },
    closeAllDropdowns: function() {
      $.each(this.dropdowns, function(i, dd) {
        if(dd.isOpen()) {
          dd.close();
        }
      });
      this.activeDropdown = undefined;
    },
    startCloseTimeout: function(dd) {
      this.closeDropdownTimeout = setTimeout(this.closeDropdown.bind(this, dd), this.closeDropdownTimeoutDuration);
    },
    stopCloseTimeout: function() {
      clearTimeout(this.closeDropdownTimeout);
    }
  };

  return DropdownManager;

 }(jQuery));
/**
 * Drawer
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - Modernizr
 *
 * @namespace - models.Drawer
*/

slate.models = slate.models || {};

slate.models.Drawer = (function($, Modernizr) {

  var $document = $(document);
  var $body     = $(document.body);

  var selectors = {
    close: '[data-drawer-close]',
    mobileSearch: '[data-mobile-search]'
  };

  var classes = {
    drawer: 'drawer',
    visible: 'is-visible',
    backdrop: 'drawer-backdrop',
    backdropVisible: 'is-visible',
    bodyDrawerOpen: 'drawer-open'    
  };

 /**
  * Drawer constructor
  *
  * @param {HTMLElement | $} el - The drawer element
  * @param {Object} options
  */
  function Drawer(el, options) {

    this.name = 'drawer';
    this.namespace = '.'+this.name;

    this.$el = $(el);
    this.$backdrop              = null;
    this.stateIsOpen            = false;
    this.transitionEndEvent     = slate.utils.whichTransitionEnd();
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;

    if(this.$el == undefined || !this.$el.hasClass(classes.drawer)) {
      console.warn('['+this.name+'] - Element with class `'+classes.drawer+'` required to initialize.');
      return;
    }     

    var defaults = {
      closeSelector: selectors.close,
      backdrop: false,
      backdropTarget: null
    };

    this.settings = $.extend({}, defaults, options);

    this.events = {
      HIDE:   'hide'   + this.namespace,
      HIDDEN: 'hidden' + this.namespace,
      SHOW:   'show'   + this.namespace,
      SHOWN:  'shown'  + this.namespace
    };    

    // check to see if we're on an ios device and using safari based on the presence of substrings in the user agent. 
    var ua = navigator.userAgent.toLowerCase();
    // If we're on an ios device the user agent will contain one of these three device identifiers
    if (ua.indexOf('iphone') != -1 || ua.indexOf('ipod') != -1 || ua.indexOf('ipad') != -1) {
      // If we're on safari the user agent will contain the strings 'safari' and not the substring 'chrome'
      if (ua.indexOf('safari') != -1 && ua.indexOf('chrome') == -1) {
        // we are on an ios device using safari

        // when tabbing out of the mobile search bar with the arrows in the keyboard close the drawer
        $(selectors.mobileSearch).on('blur', this.onCloseClick.bind(this));;
      }
    }

    this.$el.on('click', this.settings.closeSelector, this.onCloseClick.bind(this));

  }

  Drawer.prototype = $.extend({}, Drawer.prototype, {

    addBackdrop: function(callback) {
      var _this = this;
      var cb    = callback || $.noop;
      var $target = this.settings.backdropTarget || $body;

      if(this.stateIsOpen) {
        this.$backdrop = $(document.createElement('div'));

        this.$backdrop.addClass(classes.backdrop)
                      .appendTo($target);

        this.$backdrop.one(this.transitionEndEvent, cb);
        this.$backdrop.one('click', this.hide.bind(this));

        // debug this...
        setTimeout(function() {
          $target.addClass(classes.bodyDrawerOpen);          
          _this.$backdrop.addClass(classes.backdropVisible);
        }, 10);
      }
      else {
        cb();
      }
    },

    removeBackdrop: function(callback) {
      var _this = this;
      var cb    = callback || $.noop;
      var $target = this.settings.backdropTarget || $body;

      if(this.$backdrop) {
        this.$backdrop.one(this.transitionEndEvent, function(){
          _this.$backdrop && _this.$backdrop.remove();
          _this.$backdrop = null;
          cb();
        });

        setTimeout(function() {
          _this.$backdrop.removeClass(classes.backdropVisible);
          $target.removeClass(classes.bodyDrawerOpen);
        }, 10);
      }
      else {
        cb();
      }
    },
    
    /**
     * Called after the closing animation has run
     */    
    onHidden: function() {
      this.stateIsOpen = false;
      var e = $.Event(this.events.HIDDEN);
      this.$el.trigger(e);
    },

    /**
     * Called after the opening animation has run
     */
    onShown: function() {
      var e = $.Event(this.events.SHOWN);
      this.$el.trigger(e);
    },

    hide: function() {
      var e = $.Event(this.events.HIDE);
      this.$el.trigger(e);

      if(!this.stateIsOpen) return;

      this.$el.removeClass(classes.visible);
      $body.removeClass(`drawer-open-${this.$el.data('name') || 'generic'}`);

      if(this.settings.backdrop) {
        this.removeBackdrop();
      }        

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onHidden.bind(this));
      }
      else {
        this.onHidden();
      }
    },

    show: function() {
      var e = $.Event(this.events.SHOW);
      this.$el.trigger(e);

      if(this.stateIsOpen) return;

      this.stateIsOpen = true;

      this.$el.addClass(classes.visible);
      $body.addClass(`drawer-open-${this.$el.data('name') || 'generic'}`);

      if(this.settings.backdrop) {
        this.addBackdrop();
      }

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onShown.bind(this));
      }
      else {
        this.onShown();
      }
    },

    toggle: function() {
      return this.stateIsOpen ? this.hide() : this.show();
    },

    onCloseClick: function(e) {
      e.preventDefault();
      this.hide();
    }
  });

  // DRAWER DATA-API
  // ===============

  $document.on('click.drawer', '[data-toggle="drawer"]', function (e) {

    var $this   = $(this);
    var $target = $($this.attr('data-target'));
    var options = $.extend($target.data(), $this.data());
    var data    = $this.data('drawer');

    if ($this.is('a')) e.preventDefault();

    if(!data) {
      $this.data('drawer', (data = new Drawer($target, options)));
      data.show();
    }
    else {
      data.toggle();
    }

  });  

  return Drawer;
  
}(jQuery, Modernizr));
/**
 * Slideshow
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - slick.min.js
 *  - Modernizr
 *
 * - NOTE: Slideshow wrapper is *not* required to initialize, but it is required if you want to take advantage of the a11y code inside here
 *
 * @namespace - models.Slideshow
*/

slate.models = slate.models || {};

slate.models.Slideshow = (function($, Modernizr) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]'
  };

  var KEYS = {
    left: 37,
    right: 39
  };

 /**
  * Slideshow constructor
  *
  * @param {HTMLElement | $} el - The actual slideshow element
  * @param {Object} options - Options passed into the slider initialize function
  */
  function Slideshow(el, options) {

    var $el = $(el);

    this.$slideshow = $el;
    this.$wrapper   = $el.closest(selectors.slideShowWrapper);

    if(!this.$slideshow.length){
      console.warn('['+this.name+'] - Slideshow element required to initialize');
      return;
    }

    var fade = this.$slideshow.attr('data-fade') && this.$slideshow.attr('data-fade').length ? this.$slideshow.data('fade') : true; // Allows us to pass data-fade="false".  $.fn.attr coerces to string, $.fn.data does *not*

    var arrows = (this.$slideshow.data('arrows') !== undefined) ? this.$slideshow.data('arrows') : !Modernizr.touchevents;

    var a11y = this.$slideshow.data("accessibility") !== undefined ? this.$slideshow.data("accessibility") : false;

    var defaults = {
      accessibility: a11y, // prevents page from jumping on focus
      arrows: arrows,
      dots: this.$slideshow.data('dots'),
      fade: fade,
      draggable: true,
      touchThreshold: 20,
      slidesToShow: this.$slideshow.data('slides-to-show') || 1,
      slidesToScroll: this.$slideshow.data('slides-to-scroll') || 1,
      autoplay: this.$slideshow.data('autoplay') || false,
      autoplaySpeed: this.$slideshow.data('speed') || 5000,
      prevArrow: '<div class="slick-arrow slick-arrow--prev" aria-label="Previous Banner"><div class="earmark-arrow earmark-arrow--left"></div></div>',
      nextArrow: '<div class="slick-arrow slick-arrow--next" aria-label="Next Banner"><div class="earmark-arrow earmark-arrow--right"></div></div>',

      // Options below here are not used in slick
      equalHeightSlides: this.$slideshow.data('equal-heights') || false
    };

    this.settings = $.extend({}, defaults, options);

    // Turn off dots if there's only one slide
    if(this.$slideshow.children().length <= 1) {
      this.settings.dots = false;
    }

    // this.$slideshow.on('init', this.slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    if(this.settings.equalHeightSlides) {
      this.$slideshow.addClass('has-equal-height-slides');
    }

    $(window).on('resize', this.onResize.bind(this));

    this.onResize();
  }

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {
   /**
    * Adds events to the slideshow for improved accessibility
    *
    * @param {Event} evt - window event w/ type "init"
    * @param {Object} slick
    */
    slideshowA11y: function(evt, slick) {
      var self     = this;
      var $list    = slick.$list;
      var $dots    = slick.$dots;
      var $wrapper = this.$wrapper;
      var autoplay = this.settings.autoplay;

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused
      // pause slideshow and set aria-live.
      $wrapper.on('focusin', function(evt) {
        if (!$wrapper.has(evt.target).length) {
          return;
        }

        $list.attr('aria-live', 'polite');

        if (autoplay) {
          self.pause();
        }
      });

      // Resume autoplay
      $wrapper.on('focusout', function(evt) {
        if (!$wrapper.has(evt.target).length) {
          return;
        }

        $list.removeAttr('aria-live');

        if (autoplay) {
          self.play();
        }
      });

      // Add arrow key support when focused
      if ($dots) {
        $dots.on('keydown', function(evt) {
          if (evt.which === KEYS.left) {
            self.prev();
          }

          if (evt.which === KEYS.right) {
            self.next();
          }

          // Update focus on newly selected tab
          if ((evt.which === KEYS.left) || (evt.which === KEYS.right)) {
            $dots.find('.slick-active button').focus();
          }
        });
      }
    },

    next: function() {
      this.$slideshow.slick('slickNext');
    },

    prev: function() {
      this.$slideshow.slick('slickPrev');
    },

    pause: function() {
      this.$slideshow.slick('slickPause');
    },

    play: function() {
      this.$slideshow.slick('slickPlay');
    },

    unpause: function() {
      if(this.settings.autoplay) {
        this.play();
      }
    },

    onResize: function() {
      var slick = this.$slideshow.slick('getSlick');
      if(slick) {
        if (slick.options.slidesToShow > slick.slideCount){
          $('.slick-dots').hide();
        }
      }
    },

   /**
    * Finds and displays a slide associated with the blockId passed in.
    * Note:  Block IDs are not required on slides for the slideshow to work
    *        If used, the slide element must have the attribute - data-block-id="{{ block.id }}"
    *
    * @param {string} blockId
    */
    goToSlideByBlockId: function(blockId) {
      var slick = this.$slideshow.slick('getSlick');
      var $slide = slick.$slides.filter('[data-block-id="' + blockId + '"]:not(.slick-cloned)');

      this.$slideshow.slick('slickGoTo', $slide.data('slick-index') );
    }

  });

  return Slideshow;
}(jQuery, Modernizr));

/**
 * Product Carousel
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - slick.min.js
 *  - Modernizr
 *
 * - NOTE: Slideshow wrapper is *not* required to initialize, but it is required if you want to take advantage of the a11y code inside here
 *
 * @namespace - models.ProductCarousel
*/

slate.models = slate.models || {};

slate.models.ProductCarousel = (function($, Modernizr) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]',
    slides: '[data-slide]'
  };

 /**
  * ProductCarousel constructor
  *
  * @param {HTMLElement | $} el - The element containing the slideshow and buttons / arrows / dots, etc
  */
  function ProductCarousel(el) {

    this.name = 'productCarousel';

    if(!$(el).length){
      console.warn('['+this.name+'] - Carousel element required to initialize');
      return;
    }

    this.$el = $(el);
    this.$slideshowWrapper = this.$el.find(selectors.slideshowWrapper);
    this.$slideshow = this.$el.find(selectors.slideshow);
    this.$slides = this.$el.find(selectors.slides);

    var options = {
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: true,
      infinite: false,
      fade: false,
      arrows: true,
      prevArrow: $('.product-carousel__arrow-prev', this.$el),
      nextArrow: $('.product-carousel__arrow-next', this.$el),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: this.$slides.length > 16 ? false : true,
            appendDots: $('.product-carousel--mobile__dots', this.$el),
            appendArrows: $('.product-carousel--mobile__container', this.$el),
            arrows: true,
            prevArrow: $('.product-carousel--mobile__arrow-prev', this.$el),
            nextArrow: $('.product-carousel--mobile__arrow-next', this.$el),
          }
        }
      ]
    };

    if (this.$slides.length > 1) {
      this.slideshow = new slate.models.Slideshow(this.$slideshow, options);
    
      $(window).on('resize', this.onResize.bind(this));

      this.onResize();
    } else {
      console.warn('['+this.name+'] Slides required for this module to initialize');
    }
  }

  ProductCarousel.prototype = $.extend({}, ProductCarousel.prototype, {
    onResize: function() {
      var slick = this.slideshow.$slideshow.slick('getSlick');
      if(slick) {
        if (slick.options.slidesToShow >= slick.slideCount){
          $('.slick-dots').hide();
        }
      }
    }
  });

  return ProductCarousel;
}(jQuery, Modernizr));

/**
 * Article Carousel
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - slick.min.js
 *  - Modernizr
 *
 * - NOTE: Slideshow wrapper is *not* required to initialize, but it is required if you want to take advantage of the a11y code inside here
 *
 * @namespace - models.ArticleCarousel
*/

slate.models = slate.models || {};

slate.models.ArticleCarousel = (function($, Modernizr) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]',
    slide: '[data-slide]'
  };

 /**
  * ArticleCarousel constructor
  *
  * @param {HTMLElement | $} el - The element containing the slideshow and buttons / arrows / dots, etc
  */
  function ArticleCarousel(el) {
    this.name = 'articleCarousel';
    
    if(!$(el).length){
      console.warn('['+this.name+'] - Carousel element required to initialize');
      return;
    }
    
    this.$el = $(el);
    this.$slideshowWrapper = this.$el.find(selectors.slideshowWrapper);
    this.$slideshow = this.$el.find(selectors.slideshow);
    this.$slides = $(selectors.slide, this.$container);

    var options = {
      slidesToShow: ( this.$slides.length >= 3 ) ? 3 : 1,
      slidesToScroll: 3,
      dots: true,
      infinite: true,
      fade: false,
      arrows: false,
      appendDots: $('.article-carousel--mobile__dots', this.$el),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    this.slideshow = new slate.models.Slideshow(this.$slideshow, options);
    
    $(window).on('resize', this.onResize.bind(this));

    this.onResize();
  }

  ArticleCarousel.prototype = $.extend({}, ArticleCarousel.prototype, {
    onResize: function() {
      var slick = this.slideshow.$slideshow.slick('getSlick');
      if(slick) {
        if (slick.options.slidesToShow >= slick.slideCount){
          $('.slick-dots').hide();
        }
      }
    }
  });

  return ArticleCarousel;
}(jQuery, Modernizr));

/**
 * Video Carousel
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - slick.min.js
 *  - Modernizr
 *
 * - NOTE: Slideshow wrapper is *not* required to initialize, but it is required if you want to take advantage of the a11y code inside here
 *
 * @namespace - models.VideoCarousel
*/

slate.models = slate.models || {};

slate.models.VideoCarousel = (function($, Modernizr) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]'
  };

 /**
  * VideoCarousel constructor
  *
  * @param {HTMLElement | $} el - The element containing the slideshow and buttons / arrows / dots, etc
  */
  function VideoCarousel(el) {

    this.name = 'videoCarousel';

    if(!$(el).length){
      console.warn('['+this.name+'] - Carousel element required to initialize');
      return;
    }

    this.$el = $(el);
    this.$slideshowWrapper = this.$el.find(selectors.slideshowWrapper);
    this.$slideshow = this.$el.find(selectors.slideshow);

    var options = {
      accessibility: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinite: true,
      fade: false,
      arrows: true,
      prevArrow: $('.video-carousel__arrow-prev', this.$el),
      nextArrow: $('.video-carousel__arrow-next', this.$el),
      centerMode: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            appendDots: $('.video-carousel--mobile__dots', this.$el),
            appendArrows: $('.video-carousel--mobile__container', this.$el),
            arrows: true,
            prevArrow: $('.video-carousel--mobile__arrow-prev', this.$el),
            nextArrow: $('.video-carousel--mobile__arrow-next', this.$el),
          }
        }
      ]
    };

    this.slideshow = new slate.models.Slideshow(this.$slideshow, options);

    $(window).on('resize', this.onResize.bind(this));

    this.onResize();
  }

  VideoCarousel.prototype = $.extend({}, VideoCarousel.prototype, {
    onResize: function() {
      var slick = this.slideshow.$slideshow.slick('getSlick');
      if(slick) {
        if (slick.options.slidesToShow >= slick.slideCount){
          $('.slick-dots').hide();
        }
      }
    }
  });

  return VideoCarousel;
}(jQuery, Modernizr));

/**
 * Product Carousel
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - slick.min.js
 *  - Modernizr
 *
 * - NOTE: Slideshow wrapper is *not* required to initialize, but it is required if you want to take advantage of the a11y code inside here
 *
 * @namespace - models.CollectionCarousel
*/

slate.models = slate.models || {};

slate.models.CollectionCarousel = (function($, Modernizr) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]',
    slides: '[data-slide]'
  };

 /**
  * CollectionCarousel constructor
  *
  * @param {HTMLElement | $} el - The element containing the slideshow and buttons / arrows / dots, etc
  */
  function CollectionCarousel(el) {

    this.name = 'collectionCarousel';

    if(!$(el).length){
      console.warn('['+this.name+'] - Carousel element required to initialize');
      return;
    }

    this.$el = $(el);
    this.$slideshowWrapper = this.$el.find(selectors.slideshowWrapper);
    this.$slideshow = this.$el.find(selectors.slideshow);
    this.$slides = this.$el.find(selectors.slides);

    var options = {
        slidesToShow: 4,
        slidesToScroll: 4,
        nextArrow: $('.collection-carousel__arrow-next'),
        prevArrow: $('.collection-carousel__arrow-prev'),
        fade: false,
        dots: true,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      };
      
    if (this.$slides.length > 1) {
      this.slideshow = new slate.models.Slideshow(this.$slideshow, options);
        
      $(window).on('resize', this.onResize.bind(this));
      
    } else {
      console.warn('['+this.name+'] Slides required for this module to initialize');
    }
  }

  CollectionCarousel.prototype = $.extend({}, CollectionCarousel.prototype, {
    onResize: function() {}
  });

  return CollectionCarousel;
}(jQuery, Modernizr));

/**
 * Product Carousel
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - slick.min.js
 *  - Modernizr
 *
 * - NOTE: Slideshow wrapper is *not* required to initialize, but it is required if you want to take advantage of the a11y code inside here
 *
 * @namespace - models.BannerCarousel
*/

slate.models = slate.models || {};

slate.models.BannerCarousel = (function($, Modernizr) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]',
    slides: '[data-slide]'
  };

 /**
  * BannerCarousel constructor
  *
  * @param {HTMLElement | $} el - The element containing the slideshow and buttons / arrows / dots, etc
  */
  function BannerCarousel(el) {

    this.name = 'bannerCarousel';

    if(!$(el).length){
      console.warn('['+this.name+'] - Carousel element required to initialize');
      return;
    }

    this.$el = $(el);
    this.$slideshowWrapper = this.$el.find(selectors.slideshowWrapper);
    this.$slideshow = this.$el.find(selectors.slideshow);
    this.$slides = this.$el.find(selectors.slides);

    var options = {
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: false
      };
    
    if (this.$slides.length > 1) {
      this.slideshow = new slate.models.Slideshow(this.$slideshow, options);
        
      $(window).on('resize', this.onResize.bind(this));
      
    } else {
      console.warn('['+this.name+'] Slides required for this module to initialize');
    }
  }

  BannerCarousel.prototype = $.extend({}, BannerCarousel.prototype, {
    onResize: function() {}
  });

  return BannerCarousel;
}(jQuery, Modernizr));

/**
 * Slideup
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - Modernizr
 *
 * @namespace - models.Slideup
*/

slate.models = slate.models || {};

slate.models.Slideup = (function($, Modernizr) {

  var $document = $(document);

  var selectors = {
    close: '[data-slideup-close]',
  };

  var classes = {
    slideup: 'slideup',
    visible: 'is-visible'
  };

 /**
  * Slideup constructor
  *
  * @param {HTMLElement | $} el - The slideup element
  * @param {Object} options
  */
  function Slideup(el, options) {

    this.name = 'slideup';
    this.namespace = '.'+this.name;

    this.$el = $(el);
    this.stateIsOpen            = false;
    this.transitionEndEvent     = slate.utils.whichTransitionEnd();    
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;


    if (this.$el == undefined || !this.$el.hasClass(classes.slideup)) {
      console.warn('['+this.name+'] - Element with class `'+classes.slideup+'` required to initialize.');
      return;
    }    

    var defaults = {
      closeSelector: selectors.close
    };

    this.settings = $.extend({}, defaults, options);

    this.events = {
      HIDE:   'hide'   + this.namespace,
      HIDDEN: 'hidden' + this.namespace,
      SHOW:   'show'   + this.namespace,
      SHOWN:  'shown'  + this.namespace
    };    

    this.$el.on('click', this.settings.closeSelector, this.onCloseClick.bind(this));

  }

  Slideup.prototype = $.extend({}, Slideup.prototype, {
    
    /**
     * Called after the closing animation has run
     */    
    onHidden: function() {
      var e = $.Event(this.events.HIDDEN);
      this.$el.trigger(e);
    },

    /**
     * Called after the opening animation has run
     */
    onShown: function() {
      var e = $.Event(this.events.SHOWN);
      this.$el.trigger(e);
    },

    hide: function() {
      var e = $.Event(this.events.HIDE);
      this.$el.trigger(e);

      if(!this.stateIsOpen) return;

      this.stateIsOpen = false;

      this.$el.removeClass(classes.visible);

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onHidden.bind(this));
      }
      else {
        this.onHidden();
      }
    },

    show: function() {
      var e = $.Event(this.events.SHOW);
      this.$el.trigger(e);

      if(this.stateIsOpen) return;

      this.stateIsOpen = true;

      this.$el.addClass(classes.visible);

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onShown.bind(this));
      }
      else {
        this.onShown();
      }
    },

    toggle: function() {
      return this.stateIsOpen ? this.hide() : this.show();
    },    

    onCloseClick: function(e) {
      e.preventDefault();
      this.hide();
    }
  });

  // SLIDEUP DATA-API
  // ===============

  $document.on('click.slideup', '[data-toggle="slideup"]', function (e) {

    var $this   = $(this);
    var $target = $($this.attr('data-target'));
    var options = $.extend($target.data(), $this.data());
    var data    = $this.data('slideup');

    if ($this.is('a')) e.preventDefault();

    if(!data) {
      $this.data('slideup', (data = new Slideup($target, options)));
      data.show();
    }
    else {
      data.toggle();
    }

  });   

  return Slideup;
}(jQuery, Modernizr));

/**
 * Slideup Alert
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - snippets/slideup-template.liquid
 *
 * @namespace - models.SlideupAlert
*/

slate.models = slate.models || {};

slate.models.SlideupAlert = (function($) {

  var $body = $(document.body);

  var selectors = {
    template: 'script[data-slideup-template]'
  };  

 /**
  * Slideup Alert constructor
  *
  * @param {Object} options
  * @param {String} options.title - Title text of the slideup
  * @param {String} options.text - Body text of the slideup
  * @param {Integer} options.timeoutDuration - How long to display the alert before closing automatically (in ms)
  */
  function SlideupAlert(options) {

    this.name = 'slideupAlert';
    this.namespace = '.'+this.name;

    if(!$(selectors.template).length){
      console.warn('['+this.name+'] - Handlebars template required to initialize');
      return;
    }

    var template = Handlebars.compile($(selectors.template).html());
    var defaults = {
      title: null,
      text: null,
      timeoutDuration: 5000
    };
    
    this.settings = $.extend({}, defaults, options);
    this.interactionTimeout = false;

    this.$el = $(template(this.settings));

    this.$el.appendTo($body);

    this.$el.on('shown.slideup', this.onShown.bind(this));
    this.$el.on('hidden.slideup', this.onHidden.bind(this));
    this.$el.on('mouseenter', this.onMouseenter.bind(this));
    this.$el.on('mouseleave', this.onMouseleave.bind(this));    

    this.slideup = new slate.models.Slideup(this.$el);

    setTimeout(function() {
      this.slideup.show();
    }.bind(this), 10);

  }

  SlideupAlert.prototype = $.extend({}, SlideupAlert.prototype, {
    
    setInteractionTimeout: function() {
      this.interactionTimeout = setTimeout(function() {
        this.slideup.hide();
      }.bind(this), this.settings.timeoutDuration);
    },

    clearInteractionTimeout: function() {
      clearTimeout(this.interactionTimeout);
    },

    onMouseenter: function() {
      this.clearInteractionTimeout();
    },

    onMouseleave: function() {
      this.setInteractionTimeout();
    },

    onHidden: function() {
      this.clearInteractionTimeout();
      this.$el.remove();
    },

    onShown: function() {
      this.setInteractionTimeout();
    }

  });

  return SlideupAlert;
}(jQuery));

/**
 * Overlay
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - Modernizr
 *
 * @namespace - models.Overlay
*/

slate.models = slate.models || {};

slate.models.Overlay = (function($, Modernizr) {

  var $document = $(document);
  var $body     = $(document.body);

  var selectors = {
    close: '[data-overlay-close]'
  };

  var classes = {
    overlay: 'overlay',
    visible: 'is-visible',
    bodyOverlayOpen: 'overlay-open'
  };

 /**
  * Overlay constructor
  *
  * @param {HTMLElement | $} el - The overlay element
  * @param {Object} options
  */
  function Overlay(el, options) {

    this.name = 'overlay';
    this.namespace = '.'+this.name;

    this.$el      = $(el);

    this.stateIsOpen            = false;
    this.transitionEndEvent     = slate.utils.whichTransitionEnd();    
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;

    if (this.$el == undefined || !this.$el.hasClass(classes.overlay)) {
      console.warn('['+this.name+'] - Element with class `'+classes.overlay+'` required to initialize.');
      return;
    }    

    var defaults = {
      closeSelector: selectors.close
    };

    this.settings = $.extend({}, defaults, options);

    this.events = {
      HIDE:   'hide'   + this.namespace,
      HIDDEN: 'hidden' + this.namespace,
      SHOW:   'show'   + this.namespace,
      SHOWN:  'shown'  + this.namespace,
      FOCUS:  'focus'  + this.namespace,
      KEYDOWN_DISMISS: 'keydown.dismiss' + this.namespace
    };    

    this.$el.on('click', this.settings.closeSelector, this.onCloseClick.bind(this));

  }

  Overlay.prototype = $.extend({}, Overlay.prototype, {
    
    /**
     * Called after the closing animation has run
     */    
    onHidden: function() {
      $body.removeClass(classes.bodyOverlayOpen);

      var e = $.Event(this.events.HIDDEN);
      this.$el.trigger(e);
    },

    /**
     * Called after the opening animation has run
     */
    onShown: function() {
      this.enforceFocus();

      var e = $.Event(this.events.SHOWN);
      this.$el.trigger(e);
      this.$el.trigger('focus');
    },

    hide: function() {
      var e = $.Event(this.events.HIDE);
      this.$el.trigger(e);

      if(!this.stateIsOpen) return;

      this.stateIsOpen = false;

      this.updateEscapeHandler();

      $document.off(this.events.FOCUS);

      this.$el.removeClass(classes.visible);      

      if(this.supportsCssTransitions) {
        this.$el.one(this.transitionEndEvent, this.onHidden.bind(this));
      }
      else {
        this.onHidden();
      }
    },

    show: function() {
      var e = $.Event(this.events.SHOW);
      this.$el.trigger(e);

      if(this.stateIsOpen) return;

      this.stateIsOpen = true;

      this.updateEscapeHandler();

      $body.addClass(classes.bodyOverlayOpen);
      this.$el.addClass(classes.visible);

      if(this.supportsCssTransitions) {      
        this.$el.one(this.transitionEndEvent, this.onShown.bind(this));
      }
      else {
        this.onShown();
      }
    },

    enforceFocus: function() {
      $document.off(this.events.FOCUS);
      $document.on(this.events.FOCUS, $.proxy(function(e) {
        if (document !== e.target && this.$element[0] !== e.target && !this.$element.has(e.target).length) {
          this.$el.trigger('focus');
        }
      }, this));
    },

    updateEscapeHandler: function() {
      if(this.stateIsOpen) {
        this.$el.on(this.events.KEYDOWN_DISMISS, $.proxy(function(e) {
          e.which == 27 && this.hide();
        }, this));
      }
      else {
        this.$el.off(this.events.KEYDOWN_DISMISS);
      }
    },

    toggle: function() {
      return this.stateIsOpen ? this.hide() : this.show();
    },    

    onCloseClick: function(e) {
      e.preventDefault();
      this.hide();
    }
  });

  // OVERLAY DATA-API
  // ===============

  $document.on('click.overlay', '[data-toggle="overlay"]', function (e) {

    var $this   = $(this);
    var $target = $($this.attr('data-target'));
    var options = $.extend($target.data(), $this.data());
    var data    = $this.data('overlay');

    if ($this.is('a')) e.preventDefault();

    if(!data) {
      $this.data('overlay', (data = new Overlay($target, options)));
      data.show();
    }
    else {
      data.toggle();
    }

  });   

  return Overlay;
}(jQuery, Modernizr));

/**
 * Model - Collection Tag Filter Controller
 * ------------------------------------------------------------------------------
 *
 * @namespace - models.collectionTagFilterController
 */

slate.models = slate.models || {};

slate.models.CollectionTagFilterController = (function ($) {

  /**
   * CollectionTagFilterController constructor.
   * - Manages the tag filters applied to the collection page.
   * - All modifications to / queries for filters should go through this guy
   *
   */
  function CollectionTagFilterController() {

    this.name = 'collectionTagFilterController';
    this.cache = false;
    this.tagFilters = [];

    /**
     * Resets the instance's cache object.
     * Needs to be called whenever a tag filter is activated or deactivated to ensure we get fresh data
     *
     */
    this._bustCache = function () {
      this.cache = false;
      return this;
    };

    /**
     * Constructs an object of tag filter data to be consumed by other functions inside this controller
     *
     * @return {Object} obj
     * @return {Array}  obj.types
     * @return {Array}  obj.values
     * @return {Array}  obj.activeTypes
     * @return {Array}  obj.activeValues
     * @return {Array}  obj.inactiveFilters
     * @return {Object} obj.filtersForType
     */
    this._getTagFilterData = function () {

      var data = this.cache;

      if (!data) {

        data = {
          types: [],
          values: [],
          activeTypes: [],
          activeFilters: [],
          activeValues: [],
          inactiveFilters: [],
          filtersForType: {}
        };

        for (var i = this.tagFilters.length - 1; i >= 0; i--) {
          var tf = this.tagFilters[i];
          var val = tf.value;
          var type = tf.type;

          // Update data.types
          if (data.types.indexOf(type) == -1) {
            data.types.push(type);
          }

          // Update data.values
          if (data.values.indexOf(val) == -1) {
            data.values.push(val);
          }

          // Update data.filtersForType
          if (!data.filtersForType.hasOwnProperty(type)) {
            data.filtersForType[type] = [];
          }

          data.filtersForType[type].push(tf);

          // Update data.activeFilters / data.activeTypes / data.activeValues
          if (tf.active) {
            data.activeFilters.push(tf);
            if (data.activeTypes.indexOf(type) == -1) {
              data.activeTypes.push(type);
            }
            if (data.activeValues.indexOf(val) == -1) {
              data.activeValues.push(val);
            }
          }
          else {
            data.inactiveFilters.push(tf);
          }

        }

        this.cache = data;
      }

      return data;
    },

      /**
       * Register an instance of a TagFilter
       * Forloop ensures that we keep a unique list of tag filters based on type and value
       *
       * @param {TagFilter} tagFilter
       */
      this.registerTagFilter = function (tagFilter) {
        if (!(tagFilter instanceof slate.models.CollectionTagFilter)) return;

        for (var i = this.tagFilters.length - 1; i >= 0; i--) {
          if (this.tagFilters[i].type == tagFilter.type && this.tagFilters[i].value == tagFilter.value) {
            return;
          }
        }

        this.tagFilters.push(tagFilter);
      };

    this.activateTagFilterByValue = function (val) {
      var tf = this.getTagFilterByValue(val);

      if (tf) {
        tf.activate();
        this._bustCache();
      }
    };

    this.deactivateTagFilterByValue = function (val) {
      var tf = this.getTagFilterByValue(val);

      if (tf) {
        tf.deactivate();
        this._bustCache();
      }
    };

    this.toggleFilterByValue = function (val) {
      var tf = this.getTagFilterByValue(val);
      if (tf) {
        tf.active ? tf.deactivate() : tf.activate();
        this._bustCache();
      }
    };

    this.deactivateAllFilters = function () {
      $.each(this.getActiveTagFilters(), function (i, tf) {
        tf.deactivate();
      });
      this._bustCache();
    };

    this.getTagFilterTypes = function () {
      return this._getTagFilterData().types;
    };

    this.getActiveTagFilterTypes = function () {
      return this._getTagFilterData().activeTypes;
    };

    this.getActiveTagFilterValues = function () {
      return this._getTagFilterData().activeValues;
    };

    this.getTagFiltersForType = function (type) {
      var filterData = this._getTagFilterData();

      return filterData.filtersForType.hasOwnProperty(type) ? filterData.filtersForType[type] : [];
    };

    this.getActiveTagFilters = function () {
      return this._getTagFilterData().activeFilters;
    };

    this.getInactiveTagFilters = function () {
      return this._getTagFilterData().inactiveFilters;
    };

    this.getActiveTagFiltersForType = function (type) {
      var tfs = this.getTagFiltersForType(type);

      return tfs.filter(function (f) { return f.active; });
    };

    this.getActiveTagFilterValuesForType = function (type) {
      var tfs = this.getActiveTagFiltersForType(type);

      return tfs.map(function (tf) { return tf.value; });
    };

    this.getTagFilterByValue = function (val) {
      for (var i = this.tagFilters.length - 1; i >= 0; i--) {
        var tf = this.tagFilters[i];
        if (tf.value == val) {
          return tf;
        }
      }
    };

    this.getTagFilters = function () {
      return this.tagFilters;
    };
  }

  return CollectionTagFilterController;

})(jQuery);

/**
 * Model - Collection Tag Filter
 * ------------------------------------------------------------------------------
 *
 * @namespace - models.collectionTagFilter
 */

slate.models = slate.models || {};

slate.models.CollectionTagFilter = (function ($) {

  /**
   * CollectionTagFilter constructor.
   *
   * @param {String} type - Filter type (ex. "color", "size-group")
   * @param {String} value - Filter Value (ex. "color-blue", "size-group-small")
   * @param {String} title - Display title (ex. "Blue", "Extra Large")
   * @param {Bool} active - You can specify that the filter is active when you construct it
   */
  function CollectionTagFilter(type, value, title, active) {
    if (!type || !value) {
      return;
    }

    this.type = type;
    this.value = value;
    this.title = title.split(' ').map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); }).join(' ');
    this.niceType = this.type.split('-').map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); }).join(' ');
    this.active = active || false;

    return this;
  }

  CollectionTagFilter.prototype = {
    activate: function () {
      this.active = true;
      return this;
    },

    deactivate: function () {
      this.active = false;
      return this;
    },
    getLabel: function () {
      return this.title;
    }
  };

  return CollectionTagFilter;

})(jQuery);

/**
 * Model - Collection Sort
 * ------------------------------------------------------------------------------
 *
 * Dependencies
 *  - slate.utils
 *
 * @namespace - models.collectionSort
 */

 slate.models.CollectionSort = (function(){

  var $body = $(document.body);
  
  var selectors = {
    sortSelect: '[data-sort-select]'
  };

  /**
   * CollectionSort constructor
   *
   * @param {HTMLElement} container - Container element used for scoping any element selection
   * @param {Object} collectionData - see the bottom of `sections/collection.liquid`
   */
  function CollectionSort(container, collectionData) {
    this.$container = $(container);

    this.name = 'collectionSort';
    this.namespace = '.'+this.name;

    // Stop parsing if we don't have the collection data
    if (!collectionData) {
      return;
    }

    this.collectionData = collectionData;

    this.$container.on('change', selectors.sortSelect, this.applySort.bind(this));
  }

  CollectionSort.prototype = $.extend({}, CollectionSort.prototype, {
    applySort: function() {
      var sortBy = $(selectors.sortSelect, this.container).find('option:selected').val();
      var queryParams = slate.utils.getQueryParams();

      if(sortBy !== this.collectionData.sortDefault) {
        queryParams.sort_by = sortBy;
      }
      else {
        delete queryParams.sort_by;
      }

      location.search = $.param(queryParams);
    }
  });

  return CollectionSort;
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 * Uses slate.productDetailForm to handle core product form functionality.
 *
 * - Attaches the `Product` constructor to window.theme.Product.
 *
 * Requires:
 *  - jQuery
 *  - jQuery.fn.zoom - http://www.jacklmoore.com/zoom/
 *  - Slate
 *
 * See:
 * - product.liquid
 * - product-detail-form.liquid
 *
 * @namespace product
 */

theme.Product = (function($, slate) {

  var selectors = {
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    this.name = 'product';
    this.namespace = '.' + this.name;

    this.productDetailForm = new slate.ProductDetailForm({
      $el: this.$container,
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      enableZoom: this.$container.data('zoom-enabled') || false
    });

    this.productDetailForm.initialize();

    this.$container.on('hidden.bs.modal', '.product-video-banner', this.onVideoModalClose.bind(this));
  }

  Product.prototype = $.extend({}, Product.prototype, {
    onVideoModalClose: function(e) {
      slate.videoPlayer.pauseVideosInContainer(this.$container);
    },
  });

  return Product;
})(jQuery, slate);

/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace collection
 */

theme.Collection = (function ($, slate) {
  var $window = $(window);

  var selectors = {
    collectionJson: '[data-collection-json]',
    filterTag: '[data-filter-type][data-filter-tag]',
    clearAllFilters: '[data-clear-all-filters]',
    collectionProductCardGrid: '[data-collection-product-card-grid]',
    productCard: '[data-product-card]',
    contentBlockStore: '[data-content-block-store]',
    productGridItemProduct: '[data-product-grid-product]',
    productGridItemContentBlock: '[data-product-grid-content-block]',
    collectionProductCount: '[data-collection-product-count]',
    collectionProductCountLabel: '[data-collection-product-count-label]',
    activeFiltersSlot: '[data-active-filters-slot]',
    collectionFilterDrawer: '[data-collection-filter-drawer]',
    collectionFilterDrawerTrigger: '[data-collection-drawer-filters-trigger]',
    contentGridItem: '.content-grid__item',
    collectionGridEmptyMessage: '[data-collection-grid-empty-message]'
  };

  var classes = {
    filterTagActive: 'is-active',
    filterTagRemoveLink: 'filter-remove-link',
    collectionGridEmptyMessageVisible: 'is-visible'
  };

  function Collection(container) {

    var self = this;

    this.$container = $(container);

    this.name = 'collection';
    this.namespace = '.' + this.name;

    // Stop parsing if we don't have the collection json script tag
    if (!$(selectors.collectionJson, this.$container).html()) {
      console.warn('[' + this.name + '] - Element matching ' + selectors.collectionJson + ' required.');
      return;
    }

    this.transitionEndEvent = slate.utils.whichTransitionEnd();
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;
    this.queryStringFilterParamKey = 'filters';
    this.collectionData = JSON.parse($(selectors.collectionJson, this.$container).html());
    this.sort = new slate.models.CollectionSort(container, this.collectionData);
    this.tagFilterController = new slate.models.CollectionTagFilterController();

    // Elements we'll need
    this.$clearAllFilters = $(selectors.clearAllFilters, this.$container);
    this.$productCardGrid = $(selectors.collectionProductCardGrid, this.$container);
    this.$productCards = this.$productCardGrid.find(selectors.productCard); // Need to look inside of the grid because we can have other prroduct cards inside of the section (recently viewed etc..)
    this.$productCount = $(selectors.collectionProductCount, this.$container);
    this.$productCountLabel = $(selectors.collectionProductCountLabel, this.$container);
    this.$collectionGridEmptyMessage = $(selectors.collectionGridEmptyMessage, this.$container);
    this.$activeFiltersSlot = $(selectors.activeFiltersSlot, this.$container);
    this.$collectionFilterDrawer = $(selectors.collectionFilterDrawer, this.$container);
    this.$collectionFilterDrawerTrigger = $(selectors.collectionFilterDrawerTrigger, this.$container);
    this.$collectionFilterBackdropTarget = this.$collectionFilterDrawerTrigger.closest("section[data-section-id]");
    // Add To Cart dom binding
    this.$productATC = this.$productCards.each(self.productAddToCart);

    // Create the drawer functionality
    this.filterDrawer = new slate.models.Drawer(this.$collectionFilterDrawer, {backdrop:true, backdropTarget: this.$collectionFilterBackdropTarget });

    // Register all the tag filters
    $(selectors.filterTag, this.$container).each(function () {
      var $ft = $(this);
      var type = $ft.data('filter-type');
      var title = $ft.attr('title') || $ft.text();
      var value = $ft.data('filter-tag');

      self.tagFilterController.registerTagFilter(new slate.models.CollectionTagFilter(type, value, title));
    });

    // When we load the page, check for filter tag parameters in the URL
    var queryParams = slate.utils.getQueryParams();
    var queryParamFilters = [];

    if (queryParams.hasOwnProperty(this.queryStringFilterParamKey) && queryParams[this.queryStringFilterParamKey].length) {

      queryParamFilters = decodeURIComponent(queryParams[this.queryStringFilterParamKey]).split('+');

      $.each(queryParamFilters, function (i, param) {
        self.tagFilterController.activateTagFilterByValue(param);
      });
    }

    // If we have any active filters, hide all the content, apply the filters + place content blocks, and then fade in the content
    if (this.tagFilterController.getActiveTagFilters().length) {
      self.applyTagFilters();
    }

    // Add event handlers
    this.$container.on('click', selectors.filterTag, this.onFilterTagClick.bind(this));
    this.$clearAllFilters.on('click', this.onClearAllFiltersClick.bind(this));

    this.$collectionFilterDrawerTrigger.on('click', function (e) {
      e.preventDefault();
      this.filterDrawer.show();
    }.bind(this));

    this.placeContentBlocks();

    $window.on('resize', $.debounce(50, this.handleResize.bind(this)));
  }

  Collection.prototype = $.extend({}, Collection.prototype, {

    /**
     * Creates a remove link from a filterTag
     *
     * @param {Object} filterTag
     * @return {String}
     */
    _createTagRemoveLink: function (filterTag) {
      if (!(filterTag instanceof slate.models.CollectionTagFilter)) return;

      return '<a href="#" class="' + classes.filterTagRemoveLink + '" title="Remove filter" data-filter-type="' + filterTag.type + '" data-filter-tag="' + filterTag.value + '">' + filterTag.getLabel() + '</a>';
    },

    /**
     * Returns a jQuery set of product card elements that satisfy the currently applied filtering
     * If there are no filters, we return the entire set of cards
     *
     * @return {jQuery}
     */
    getPassingProductCards: function () {
      var self = this;
      var $productCardSetFilterOut = this.$productCards; // Start with all the cards, and filter out the ones that pass, leaving the ones that need to be hidden
      var activeFilterTypes = this.tagFilterController.getActiveTagFilterTypes();
      var activeTagFilters = this.tagFilterController.getActiveTagFilters();
      var filterTypes = this.tagFilterController.getTagFilterTypes();

      // We don't have active filters - show everything, nothing needs to be hidden!
      if (!activeFilterTypes.length) {
        return this.$productCards;
      }

      // We DO have active filters - Loop through each product card
      this.$productCards.each(function () {

        var passes = true; // If this is still "true" at the end of all this logic, then the product passes the applied filters and should be displayed
        var $productCard = $(this);
        var dataTags = $productCard.data('tags');

        // If there aren't any tags, return early
        if (!dataTags) {
          passes = false;
          return;
        }

        // Loop through each active filter
        for (var i = activeFilterTypes.length - 1; i >= 0; i--) {
          var activeFilterTypeMatch = false;
          var activeTagFiltersForType = self.tagFilterController.getActiveTagFiltersForType(activeFilterTypes[i]); // [TagFilter, TagFilter]
          var activeTagFilterValuesForType = self.tagFilterController.getActiveTagFilterValuesForType(activeFilterTypes[i]); // ["color-blue", "color-red"]

          for (var k = activeTagFilterValuesForType.length - 1; k >= 0; k--) {
            var activeTagFilterVal = activeTagFilterValuesForType[k]; // "color-blue"

            // as soon as we find a match for this filter type (doesn't matter which value), return it as a match
            // this is how we satisfy the requirement to match ANY filter for a particular filter type (match "red" OR "blue")
            if (dataTags.indexOf(activeTagFilterVal) != -1) {
              activeFilterTypeMatch = true;
              break;
            }
          }

          // Not a match :(
          if (activeFilterTypeMatch == false) {
            passes = false;
            break;
          }
        }

        if (passes) {
          $productCardSetFilterOut = $productCardSetFilterOut.not($productCard); // remove it from the matched set
        }
      });

      return this.$productCards.not($productCardSetFilterOut);
    },

    /**
     * Applies the currently active filters to the collection page
     *
     * @return {self}
     */
    applyTagFilters: function () {

      var $productGridItems = $(selectors.collectionProductCardGrid, this.$container).find(selectors.contentGridItem);
      var $passingProductCards = this.getPassingProductCards();

      // This function does the hiding / showing of the product cards
      var cb = function () {
        if ($passingProductCards.length == 0) {
          $productGridItems.hide();
          this.$collectionGridEmptyMessage.addClass(classes.collectionGridEmptyMessageVisible);
        }
        else if ($passingProductCards.length == this.$productCards.length) {
          $productGridItems.show();
          this.$collectionGridEmptyMessage.removeClass(classes.collectionGridEmptyMessageVisible);
        }
        else {
          $productGridItems.hide();
          $passingProductCards.parent(selectors.contentGridItem).show();
          this.$collectionGridEmptyMessage.removeClass(classes.collectionGridEmptyMessageVisible);
        }

        this.updateProductCountUI($passingProductCards.length);
        this.updateFilterUI();
        this.updateURL();

        $(window).trigger('lookup');
      };

      //. If the drawer is open, it blocks the main UI so we can run updates immediately
      if (this.filterDrawer.stateIsOpen) {
        setTimeout(cb.bind(this), 10);
      } else {
        cb.apply(this); // REVIEW
      }

      return this;
    },

    /**
     * Handle filter tag element click event.
     * Toggles the state of the filter that was clicked on and then applies the tag filters to the collection
     *
     * @param {event} evt
     */
    onFilterTagClick: function (e) {
      e.preventDefault();
      this.tagFilterController.toggleFilterByValue($(e.currentTarget).data('filter-tag'));
      this.applyTagFilters();
    },

    /**
     * Handle clear all element click event
     *
     * @param {event} evt
     */
    onClearAllFiltersClick: function (e) {
      e.preventDefault();
      this.tagFilterController.deactivateAllFilters();
      this.applyTagFilters();
    },

    /**
     * Updates the product count
     *
     * @param {integer} count
     */
    updateProductCountUI: function (count) {
      // Update the collection product count
      if (count == 0) {
        this.$productCount.text('');
        this.$productCountLabel.text('');
        // this.$productCountLabel.text(window.theme.strings.no_products || 'No Products');
      }
      else {
        this.$productCount.text(count);
        this.$productCountLabel.text(slate.utils.pluralize(count, (window.theme.strings.product || 'Product'), (window.theme.strings.products || 'Products')));
      }

    },

    /**
     * Updates the filter UI to reflect the state of active / deactive filters
     *
     */
    updateFilterUI: function () {
      var activeFilters = this.tagFilterController.getActiveTagFilters();
      var inactiveFilters = this.tagFilterController.getInactiveTagFilters();
      var activeFiltersSlotHTML = '';
      var $filterTagEls = $('[data-filter-tag]');

      $.each(activeFilters, function (i, f) {
        $filterTagEls.filter('[data-filter-tag="' + f.value + '"]').addClass(classes.filterTagActive);
      });

      $.each(inactiveFilters, function (i, f) {
        $filterTagEls.filter('[data-filter-tag="' + f.value + '"]').removeClass(classes.filterTagActive);
      });

      if (activeFilters.length) {
        activeFiltersSlotHTML = activeFilters.map(function (tf) { return this._createTagRemoveLink(tf); }.bind(this));
        this.$activeFiltersSlot.html(activeFiltersSlotHTML).slideDown(200);
        this.$clearAllFilters.fadeTo(200, 1);
      }
      else {
        this.$activeFiltersSlot.html('').slideUp(200);
        this.$clearAllFilters.fadeTo(200, 0);
      }
    },

    /**
     * Updates the current URL to reflect the state of the applied filters
     * Appends a query string like ?filter-tags={{ tag1 }}+{{ tag2 }}
     *
     */
    updateURL: function () {
      var queryStringFilterParamValues = this.tagFilterController.getActiveTagFilterValues().join('+');
      var updatedUrl;

      if (window.history) {
        if (queryStringFilterParamValues.length) {
          updatedUrl = slate.utils.getUrlWithUpdatedQueryStringParameter(this.queryStringFilterParamKey, queryStringFilterParamValues);
        }
        else {
          updatedUrl = slate.utils.getUrlWithRemovedQueryStringParameter(this.queryStringFilterParamKey);
        }

        window.history.replaceState({ path: updatedUrl }, '', updatedUrl);
      }

    },

    placeContentBlocks: function(sortNeeded) {
      var sortNeeded = slate.utils.defaultTo(sortNeeded, false);
      var desktop = $window.width() > slate.breakpoints.getBreakpointMinWidth('md');

      var $productGridProducts = $(selectors.productGridItemProduct, this.$container);
      var $productGridContentBlocks = $(selectors.productGridItemContentBlock);
      var $contentBlockStore = $(selectors.contentBlockStore);
      var outputtedContentBlockCount = 0;

      // debugger;
      var locationSearchParams = new URLSearchParams(window.location.search);
      var sortByValue = locationSearchParams.get('sort_by');
      var filterByValue = locationSearchParams.get('filters');

      // First put all the content blocks into the store
      $productGridContentBlocks.detach().appendTo($contentBlockStore);

      if (sortNeeded) {
        // Then sort them by index in case they get mixed up
        // Theme editor screws with the ordering
        $productGridContentBlocks.sort(function (a, b) {
          var aI = parseInt($(a).data('product-grid-content-block'));
          var bI = parseInt($(b).data('product-grid-content-block'));

          if (aI > bI) {
            return 1;
          }
          if (aI < bI) {
            return -1;
          }
          return 0;
        });
      }

      // insert a content block where needed until we run out of content blocks or places to put them
      $productGridContentBlocks.each(function(index){
        var $this = $(this);
        var insertIndex = $this.data('block-index') || (index + 1) * 5;
        var hideFiltered = $this.data('block-hide');

        if ($productGridProducts.length >= insertIndex) {
          if (filterByValue) return;
          if (hideFiltered && sortByValue !== null && sortByValue !== 'created-descending') return;
          $this.insertAfter($productGridProducts.eq(insertIndex - 1));
        }
      })

      //Then set a max-height = their initial height to prevent stretching due to the flexbox stuff
      this.calcContentBlocksMaxHeight();
    },

    handleResize: function(e){
      var desktop = $window.width() > slate.breakpoints.getBreakpointMinWidth('md');
      if (desktop){
        this.calcContentBlocksMaxHeight();
      } else {
        $(selectors.productGridItemContentBlock, this.$container).css({ maxHeight : 'none'});
      }
    },

    calcContentBlocksMaxHeight: function(){
      var $productGridProduct       = $(selectors.productGridItemProduct, this.$container).eq(0);
      var $productGridContentBlocks  = $(selectors.productGridItemContentBlock, this.$container);

      $productGridContentBlocks.css({ maxHeight : $productGridProduct.height() });
    },

    /**
     * Theme Editor section events below
     */
    onBlockDeselect: function () {
      this.placeContentBlocks(true);
    },

    productAddToCart: function () {
      var $this = $(this); // card
      var $submit = $('[data-variant-add-to-cart]', $this);
      var $select = $('[data-variant-option-select]', $this);
      var $showSelect = $('[data-variant-show-option]', $this);
      var $selectInput = $('select', $select);
      var $priceBlock = $('.product-card__info', $this);
      var $currentPrice = $('.product-card__info-price', $priceBlock);
      var $variantPrices = $('.product-card__variant-price', $priceBlock);

      $showSelect.on('click', function(event){
        var id = $selectInput.val();
        $this.addClass('atc-loaded');
        $currentPrice.hide();
        $variantPrices.filter(`[data-variant-id="${id}"]`).show();
        $(`.product-card__gallery-image--variant[data-variant-id="${id}"]`, $this).css('opacity',1);
        $showSelect.hide();
        $submit.show();
        $select.show();
      });

      $selectInput.on('change', function(event){
        var id = $selectInput.val();
        $variantPrices.hide();
        $variantPrices.filter(`[data-variant-id="${id}"]`).show();
        $(`.product-card__gallery-image--variant`, $this).css('opacity',0);
        $(`.product-card__gallery-image--variant[data-variant-id="${id}"]`, $this).css('opacity',1);
      })

      $submit.on('click', function(event){
        $this.removeClass('atc-loaded');
        $(`.product-card__gallery-image--variant`,$this).css('opacity',0);
        $showSelect.show();
        $variantPrices.hide();
        $currentPrice.show();
        $submit.hide();
        $select.hide();
      });
    }
  });

  return Collection;

})(jQuery, slate);


// BundleBuilder
theme.BundleBuilder = (function ($, slate) {
  var selectors = {
    toggleButton: '.bundle-display__toggle',
    priceEle: '.bundle-display .total',
    productsEle: '.bundle-display__items ul',
    productsEleWrapper: '.bundle-display__items',
    bundleActionEle: '.bundle-display__cart-action .btn',
    bundleInputs: 'input.rb-input',
    sectionTitles: '.rb-section-title',
    banners: '#banners > div',
    bundleForm: '#bundle-form',
    section: '.rb-section',
    addButton: '.rb-btn-qty-plus',
    drawerFilter: '[data-bundle-drawer-filters-trigger]',
    drawer: '[data-bundle-filter-drawer]',
    filters: '[data-active-filters-slot]',
    filterSubmit: '.drawer__footer-option',
    activeFilters: '[data-active-filters-slot] a.is-active',
    searchInput: '[data-product-search]',
    sortSelect: '[data-product-sort]',
    searchClear: '[data-search-clear]',
    activeSearch: '.rb-section:not(.hidden) .rb-item',
    searchOutput: '[data-results-output]',
    bundleApp: '.section-recharge-bundle__rc-bundle',
    progress: '.bundle-display__progress',
    bundleCart: 'aside'
  }

  // this class is the state managment
  class BundleState {
    constructor(id,max,updateCallback) {
      this.id = id;
      this.max = max;
      this.state = [];
      this.updateUI = updateCallback;
    }

    /**
     * convert card DOM into simple model for state
    */
    deconstructCard(cardEle) {
      const titleEle = cardEle.querySelector('.rb-title');
      const priceEle = cardEle.querySelector('.rb-price');
      const imgEle = cardEle.querySelector('.rb-img:not(.rb-hover-img) img');
      const discountEle = priceEle.querySelector('.rb-full-price');
      let price;

      if (discountEle) {
        price = Number(discountEle.textContent.replace('$',''));
      } else {
        price = Number(priceEle.textContent.replace('$',''));
      }

      return {
        id: cardEle.dataset.rbItemId,
        title: titleEle.textContent,
        price,
        img: imgEle.getAttribute('src')
      }
    }

    updateBagUI() {
      this.updateUI();
    }

    priceSum() {
      return this.state.reduce((sum, item) => sum + item.price, 0);
    }

    subtractPercentage() {
      const amount = this.priceSum();
      const percent = window.bundle_discount_value;
      // Ensure the inputs are numbers
      if (typeof percent !== 'number') {
        throw new Error('Both amount and percent must be numbers');
      }
      // Calculate the percentage to subtract
      const percentageToSubtract = (percent / 100) * amount;
      // Subtract the percentage from the original amount
      const newAmount = amount - percentageToSubtract;
      // Round up to the nearest penny
      const roundedAmount = Math.ceil(newAmount * 100) / 100;
      return roundedAmount;
    }

    get canSendToCart() {
      return this.state.length === this.max;
    }

    get sectionId() {
      return this.id;
    }

    get products() {
      return [...this.state];
    }

    get selectedProducts() {
      return [...this.state].filter(item => item.id);
    }

    get currentPrice() {
      return this.priceSum().toFixed(2);
    }

    get discountPrice() {
      return this.subtractPercentage().toFixed(2);
    }

    set change(product) {
      const qty = Number(product.qty);
      
      if (isNaN(qty)) {
        console.error('Error with recharge bundle - product quantitiy is NaN!');
        return;
      }

      const model = this.deconstructCard(product.card);
      const isModelInState = this.state.some(item => item.id === model.id);
      
      if (isModelInState) { // remove all current products from state
        this.state = this.state.filter(item => item.id !== model.id);
      }

      if (qty > 0) Array.from({ length: qty }, () => this.state.push(model));

      this.updateBagUI();
    }
  }

  function BundleBuilder(container) {
    this.inputDelay = 400;
    this.$container = $(container);
    this.bundleMaxCount = Number(container.dataset?.bundleCount || '2');
    this.productVariantId = container.dataset?.productVariant;
    this.svgIcon = container.dataset?.svgIcon;
    this.container = container;
    this.inputs = null;
    this.filterDrawer = null;
    this.priceEle = container.querySelector(selectors.priceEle);
    this.productsEle = container.querySelector(selectors.productsEle);
    this.productsEleWrapper = container.querySelector(selectors.productsEleWrapper);
    this.bundleActionEle = container.querySelector(selectors.bundleActionEle);
    this.toggleButton = container.querySelector(selectors.toggleButton);
    this.bundleCart = container.querySelector(selectors.bundleCart);
    this.bundleBuilderState = new BundleState(container.id, this.bundleMaxCount, this._updateBagUI.bind(this));
    this.$collectionFilterDrawer = $(selectors.drawer, this.$container);
    this.progress = container.querySelector(selectors.progress);
    this._initRebuy();
    this.searchTerm = '';
    this.sortTerm = 'default';
    this.isCartOpen = false;
  }

  BundleBuilder.prototype = $.extend({}, BundleBuilder.prototype, {
    // polling for rebuy to update DOM with inputs
    _initRebuy: function () {
      let intervalId;
      
      this.container.querySelector(selectors.bundleForm).addEventListener('submit', this._handleFormSubmit.bind(this));

      [...this.container.querySelectorAll(selectors.drawerFilter)].forEach(item => item.addEventListener('click', this._handleFilterDrawer.bind(this)));

      // Create the drawer functionality
      this.filterDrawer = new slate.models.Drawer(this.$collectionFilterDrawer, {backdrop:true, backdropTarget: this.$container });

      const checkInputs = () => {
        const check = this.container.querySelectorAll(selectors.bundleInputs);
        if (check.length === 0) return;
        this.inputs = check;
        clearInterval(intervalId);
        this._initInputs();
        this._initBanners();
        this._buildFilters();
        this._initSearchSort();
      };
      intervalId = setInterval(checkInputs, 500);
    },
    _initSearchSort: function () {
      const search = this.container.querySelector(selectors.searchInput);
      const sort = this.container.querySelector(selectors.sortSelect);
      const clearBtn = this.container.querySelector(selectors.searchClear);
      const newWrapper = this.container.querySelector(selectors.searchOutput);
      const _this = this;
      let delay;

      newWrapper.addEventListener('click', (e) => {
        const {target} = e;
        const button = target.nodeName === 'BUTTON' ? target : target.closest('button');
        if (button) {
          const temp = button.closest('.rb-item');
          const source = _this.container.querySelector(`${selectors.bundleApp} [data-rb-item-id="${temp.dataset.rbItemId}"] .rb-btn-qty-plus`)
          source.click();
          setTimeout(() => {
            _this._buildResults();
          }, 100)
        }
      })
      search.addEventListener('input',(e) => {
        clearBtn.style.display = search.value.length > 1 ? 'block' : 'none';
        if (search.value.length > 3) {
          this.searchTerm = search.value;
          clearTimeout(delay);
          delay = setTimeout(() => _this._buildResults(), this.inputDelay);
        }
      })
      clearBtn.addEventListener('click', (e) => {
        search.value = '';
        this.searchTerm = '';
        clearBtn.style.display = 'none';
        this._buildResults();
      })
      sort.addEventListener('change', (e) => {
        this.sortTerm = sort.value;
        clearTimeout(delay);
        delay = setTimeout(() => this._buildResults(), this.inputDelay);
      })
    },
    _buildResults: function () {
      const search = this.searchTerm;
      const sort = this.sortTerm;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const newWrapper = this.container.querySelector(selectors.searchOutput);
      if (search !== '' || sort !== 'default') {
        let products = [...this.container.querySelectorAll(selectors.activeSearch)].map(item => {
          return {
            sortables: {
              title: item.querySelector('.rb-title').textContent.toLowerCase(),
              price: Number(item.querySelector('.rb-price').textContent.replace('$',''))
            },
            node: item
          }
        });

        if (search.length) {
          products = products.filter(({sortables:{title}}) => title.includes(search.toLowerCase()))
        }
        if (sort !== 'default') {
          products = products.sort((a,b) => {
            switch (sort) {
              case 'title-asc':
                return a.sortables.title.localeCompare(b.sortables.title);
              case 'title-desc':
                return b.sortables.title.localeCompare(a.sortables.title);
              case 'price-asc':
                return a.sortables.price - b.sortables.price;
              case 'price-desc':
                return b.sortables.price - a.sortables.price;
            }
          })
        }

        if (products.length) {
          newWrapper.firstElementChild.innerHTML = '';
          products.forEach(({node}) => newWrapper.firstElementChild.appendChild(node.cloneNode(true)));
        } else {
          newWrapper.firstElementChild.innerHTML = `
            <div class="bundle-display__no-results">
              Sorry, nothing found for <strong>${search}</strong>.
            </div>
          `;
        }

        this.container.querySelector(selectors.bundleApp).style.display = 'none';
      } else {
        newWrapper.firstElementChild.innerHTML = '';
        this.container.querySelector(selectors.bundleApp).style.display = 'block';
      }

      window.scrollTo({
        top: this.container.getBoundingClientRect().top + scrollTop - 100,
        left: 0,
        behavior: 'smooth'
      });
    },
    _setHeight: function () {
      const height = this.productsEleWrapper.querySelector('.bundle-display__drawer').offsetHeight;
      this.productsEleWrapper.style.setProperty('--height', `${height}px`);
    },
    // add the banners to the sections
    _initBanners: function () {
      const headers = [...this.container.querySelectorAll(selectors.sectionTitles)];
      [...this.container.querySelectorAll(selectors.banners)].map(item => {
        const {title} = item.dataset;
        const pic = item.children[0].cloneNode(true);
        const targetHeader = headers.find(({textContent}) => textContent === title);
        if (!targetHeader) return;
        targetHeader.closest(selectors.section).prepend(pic);
      })
    },
    // after rebuy has injected widget
    _initInputs: function () {
      [...this.inputs].forEach(inputItem => {
        // set event on input and up/down buttons for each product card in widget
        // calls the handleInputUpdate with the input element as the argument
        [...inputItem.parentElement.children].filter(item => item.nodeName === 'BUTTON')
          .forEach(inputButton => {
            inputButton.addEventListener('click', (e) => this._handleInputUpdate(inputItem, e));
          });
        inputItem.addEventListener('change', (e) => this._handleInputUpdate(inputItem, e));
      })
      document.body.addEventListener('click', (e) => {
        if (this.isCartOpen) this._handleToggle();
      });
      this.bundleCart.addEventListener('click', (e) => { e.stopPropagation(); if (!this.isCartOpen) this._handleToggle()});
      this.toggleButton.addEventListener('click', (e) => this._handleToggle());
      this.productsEle.addEventListener('click', (e) => {
        const button = e.target === 'BUTTON' ? e.target : e.target.closest('button');
        if (button) this._handleRemoveProductById(button.dataset.id);
      })
    },
    // toggle action
    _handleToggle: function (isActive = null) {
      this._setHeight();
      const display = this.productsEle.closest('aside');
      if (isActive !== null && isActive) {
        if (isActive) {
          display.classList.add('active');
          this.isCartOpen = true;
        } else {
          display.classList.remove('active');
          this.isCartOpen = false;
        }
      } else {
        display.classList.toggle('active');
        this.isCartOpen = !this.isCartOpen;
      }
    },
    // remove product from bundle drawer
    _handleRemoveProductById: function (id) {
      this.container.querySelector(`[data-rb-item-id="${id}"] .rb-btn-qty-minus`)?.click();
    },
    // this funciton is called on input change and up/down button clicks
    _handleInputUpdate: function (inputEle, event) {
      const productAdded = event.target.classList.contains(selectors.addButton.replace('.',''));
      setTimeout(() => {
        const cardEle = inputEle.closest('div.rb-item');
        this.bundleBuilderState.change = { qty: inputEle.value, card: cardEle };
        
        // const animateThis = this.container.querySelector(selectors.productsEleWrapper);
        // const wrapper = animateThis.closest('.bundle-display');
        // if (productAdded && !this.bundleBuilderState.canSendToCart && !wrapper.classList.contains('active')) {
        //   this._setHeight();
        //   setTimeout(() => {
        //     animateThis.classList.remove('animate');
        //     void animateThis.offsetWidth;
        //     animateThis.classList.add('animate');
        //   }, 100);
        // }
      }, 100);
    },
    // show filter drawer
    _handleFilterDrawer: function (e) {
      e.preventDefault();
      this.filterDrawer.show();
    },
    // update the bag UI
    _updateBagUI: function () {
      const products = this.bundleBuilderState.products;
      const selectedProducts = this.bundleBuilderState.selectedProducts;
      const price = this.bundleBuilderState.currentPrice;
      const discountPrice = this.bundleBuilderState.discountPrice;
      const canSendToCart = this.bundleBuilderState.canSendToCart;
      if (products.length !== this.bundleMaxCount) {
        Array.from({ length: this.bundleMaxCount - products.length }, () => products.push({}));
        this.priceEle.innerHTML = `$${price}`;
      } else {
        if (window.bundle_discount_value) {
          this.priceEle.innerHTML = `<span class="tstrike"><span class="to-40">$${price}</span></span> $${discountPrice}`;
        } else {
          this.priceEle.innerHTML = `$${price}`;
        }
      }
      const remainingCount = products.length - selectedProducts.length;
      const productHTML = products.map((item,index) => this._buildProductHTML(item,index));

      // this.priceEle.innerHTML = `$${price}`;
      this.bundleActionEle.disabled = !canSendToCart;
      [...this.productsEle.querySelectorAll('li:not([data-product])')].forEach(item => item.remove());
      this.productsEle.insertAdjacentHTML('afterbegin', productHTML.join(''));
      this.bundleActionEle.querySelector('.count').innerHTML = remainingCount;
      this.progress.style.setProperty('--current-length', `${Math.floor(((selectedProducts.length - 1) / (products.length - 1)) * 100)}%`);
      [...this.progress.querySelectorAll('li')].map((item, index) => {
        // console.log(index, selectedProducts.length)
        if (index < selectedProducts.length) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      })


      if (remainingCount === 1) {
        this.bundleActionEle.querySelector('.plural').style.display = 'none';
      } else {
        this.bundleActionEle.querySelector('.plural').style.display = 'inline';
      }
      if (!remainingCount) this._handleToggle(true);
    },
    // build product item
    _buildProductHTML: function ({title,img,id}, index = 0) {
      const productTitle = title || ''; //`Item ${index + 1}`;
      const imgSrc = img || "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=";
      const imgAlt = productTitle;
      const className = title ? "" : "placeholder";
      
      return `
        <li class="${className}">
          <div class="img">
            <button data-id="${id}"><img src="${this.svgIcon}" alt=""></button>
            <img src="${imgSrc}" alt="${imgAlt}">
          </div>
          <div class="label">${productTitle}</div>
        </li>
      `;
    },
    _handleFormSubmit: async function (e) {
      e.preventDefault();
      const result = await fetch(`/cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          'items':[
            {
              'id': this.productVariantId,
              'quantity': 1,
              'properties': {
                '_random': (Math.random() + 1).toString(36).substring(7)
              }
            }
          ]
        })
      });
      // trigger the recharge add to cart button - adds the bundle products
      this.container.querySelector('#bundling-app form button').click();
      
    },
    _buildFilters: function () {
      const sections = [];
      [...this.container.querySelectorAll(selectors.sectionTitles)].map(item => {
        const wrapper = item.closest('.rb-section');
        sections.push({
          title: item.textContent,
          id: wrapper.id
        });
      });
      if (!sections.length) return;
      const filter = this.container.querySelector(selectors.filters);
      const group_title = 'Sections';

      const htmlString = `
      <div class="filter-block">
        <span class="filter-block__title">${group_title.replace('Build a Bag - ', '')}</span>
        <ul class="filter-block__tag-list">
          ${ sections.map(({title,id}) => `
        <li><a href="#" class="filter-block__tag-link" title="${title}" data-filter-id="${id}">
          <span class="checkbox-ui"></span>
          ${title.replace('Build a Bag - ', '')}
        </a></li>
          `).join('') }
        </ul>
      </div>
      `;

      filter.innerHTML = htmlString;

      filter.addEventListener('click', this._handleFilterSelect);
      this.container.querySelector(selectors.filterSubmit).addEventListener('click', this._handleFilterSubmit.bind(this));
    },
    _handleFilterSelect: function (e) {
      e.preventDefault();
      const {target} = e;
      const element = target.nodeName === 'A' ? target : target.closest('a');
      element.classList.toggle('is-active');
    },
    _handleFilterSubmit: function (e) {
      e.preventDefault();
      const {target} = e;
      const sections = this.container.querySelectorAll(selectors.section);
      const active = [...this.container.querySelectorAll(selectors.activeFilters)].map(item => item.dataset.filterId);
      if (active.length) {
        [...sections].map(item => {item.classList.add('hidden'); return item})
          .filter(item => active.includes(item.id))
          .map(item => item.classList.remove('hidden'));
      }else{
        [...sections].map(item => item.classList.remove('hidden'));
      }
      this._buildResults();
    }
  });

  return BundleBuilder;
})(jQuery, slate)

/**
 * Instagram Feed Section Script
 * ------------------------------------------------------------------------------
 * 
 * Uses Instafeed.js to interact with Instagram API
 *   - See instafeedjs.com for documentation
 *   - See scripts/vendor directory for source file
 *
 * @namespace - instagramFeed
 */

theme.InstagramFeed = (function($, Instafeed) {

  var selectors = {
    target: '[data-instagram-feed-target]',
    template: 'script[data-instagram-media-template]'
  };

  var classes = {

  };

  /**
   * Instagram Feed section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function InstagramFeed(container) {
    this.$container = $(container);

    this.name = 'instagramFeed';
    this.namespace = '.'+this.name;

    this.$target = $(selectors.target, this.$container);

    // Compile this once during initialization
    this.template = Handlebars.compile($(selectors.template).html());    

    this.settings = {
      accessToken: this.$container.attr('data-access-token'),
      get: 'user',
      mock: true,
      success: this.onInstafeedMockSuccess.bind(this),
      limit: this.$container.attr('data-limit') || 8
    };

    if(!this.settings.accessToken) {
      console.warn('[InstagramFeed] - An access token is required to interact with the Instagram API');
      return;
    }

    this.init();
  }

  InstagramFeed.prototype = $.extend({}, InstagramFeed.prototype, {

    /**
     * Kick off the network requests.  Retrieve the user profile from the API and then fire up the feed.
     *
     */
    init: function() {
      $.ajax({
        type: 'GET',
        url: 'https://api.instagram.com/v1/users/self?access_token=' + this.settings.accessToken,
        dataType: 'jsonp'
      })
      .then(function(response){
        
        // Handle invalid response
        if(response.meta.hasOwnProperty('error_message')){
          console.warn('['+this.name+'] - ' + response.meta.error_message);
          return;
        }

        this.settings.userId = response.data.id;

        /*
         *  Use this space to make any adjustments to the section now that you have access to the user profile object
         */

        this.feed = new Instafeed(this.settings);
        this.feed.run();
      }.bind(this));
    },

  /**
   * Callback that runs after Instafeed.run() if the 'mock' setting is set to true
   * Use this function to sort through images, select proper resolution, and construct a gallery of images to insert into the DOM
   *
   * @param {Object} feed - object returned from Instagram API
   * @param {Array} feed.data - Array of feed data objects containing images + info
   */
    onInstafeedMockSuccess: function(feed) {
      
      var self = this;

      feed.data.forEach(function(photo){

        var data = {
          url: photo.link,
          src: photo.images && photo.images.standard_resolution && photo.images.standard_resolution.url,
          caption: photo.caption && photo.caption.text || ''
        };

        self.$target.append(self.template(data));
      });

    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      console.log('['+this.name+'] - section:select');
    },

    onShow: function() {
      console.log('['+this.name+'] - section:show');
    },

    onLoad: function() {
      console.log('['+this.name+'] - section::load');
    },

    onUnload: function() {
      console.log('['+this.name+'] - section::unload');
    }
  });

  return InstagramFeed;
})(jQuery, Instafeed);

/**
 * Slideshow Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - Slideshow
 */

theme.Slideshow = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]',
  };

  var classes = {

  };
  
  /**
   * Slideshow section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function Slideshow(container) {
    this.$container = $(container);

    this.name = 'slideshow';
    this.namespace = '.'+this.name;

    var settings = {
      arrows: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false
          }
        }
      ]
    };

    this.slideshow = new slate.models.Slideshow( $(selectors.slideshow, this.$container), settings);

  }

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(evt) {
      this.slideshow.goToSlideByBlockId( evt.detail.blockId );
      this.slideshow.pause();
    }
  });

  return Slideshow;
})(jQuery);

/**
 * Footer Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - footer
 */

theme.Footer = (function($) {

  var $window = $(window);

  var selectors = {
    mobileMenuToggle: '[data-dropdown-toggle]',
    mobileMenu: '[data-mobile-menu-list]',
    klaviyoForm: 'form[data-klaviyo-list-id]',
    formContent: '[data-subscription-slideup-form-content]',
    formMessage: '[data-subscription-slideup-form-message]'
  };

  var classes = {
    showFormMessage: "is-visible",
    showMessage: "show-message"
  };

  function Footer(container) {

    this.$container = $(container);

    this.name = 'footer';
    this.namespace = '.'+this.name;

    this.$mobileMenu = $(selectors.mobileMenu, this.$container);
    // DOM elements we'll need
    this.$el          = $(selectors.slideup, this.$container);
    this.$formContent = $(selectors.formContent, this.$container);
    this.$formMessage = $(selectors.formMessage, this.$container);
    this.$klaviyoForm = $(selectors.klaviyoForm, this.$container);

    this.ajaxKlaviyoForm = new slate.AjaxKlaviyoForm(this.$klaviyoForm, {
      listId: this.$klaviyoForm.data("klaviyo-list-id"),
      source: this.$klaviyoForm.data("klaviyo-source"),
      onSubscribeSuccess: this.onSubscribeSuccess.bind(this),
      onSubscribeFail: this.onSubscribeFail.bind(this),
      onSubmitFail: this.onSubmitFail.bind(this)
    });

    this.$container.on('click', selectors.mobileMenuToggle, this.onToggleDropdownClicked.bind(this));
    $window.on('resize', $.throttle(50, this.onResize.bind(this)));

    this.transitionEndEvent     = slate.utils.whichTransitionEnd();
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;
  }

  Footer.prototype = $.extend({}, Footer.prototype, {

    onToggleDropdownClicked: function(e) {
      e.preventDefault();

      var $trigger = $(e.currentTarget);
      var submenuID = '#' + $trigger.data('dropdown-toggle');
      var plusIconID = '#indicator-plus-' + $trigger.data('dropdown-toggle');
      var minusIconID = '#indicator-minus-' + $trigger.data('dropdown-toggle');

      if ($trigger.hasClass('is-closed')) {
        $trigger.removeClass('is-closed');
      } else {
        $trigger.addClass('is-closed');
      }
      $(submenuID).toggle('hidden');
    },

    onSubscribeSuccess: function () {
      this.$formMessage.html(this.$formMessage.data('message-success'));
      this.$formContent.addClass(classes.showMessage);

      if (!slate.utils.isThemeEditor()) {
        slate.user.setCookie(this.cookies.emailCollected);
      }
    },

    onSubscribeFail: function () {
      this.$formMessage.html(this.$formMessage.data('message-fail'));
      this.$formContent.addClass(classes.showMessage);
      setTimeout(function () {
        this.$formContent.removeClass(classes.showMessage);
      }.bind(this), 5000);
    },

    onSubmitFail: function () {
      this.$formMessage.html(this.$formMessage.data('message-fail'));
      this.$formContent.addClass(classes.showMessage);
      setTimeout(function () {
        this.$formContent.removeClass(classes.showMessage);
      }.bind(this), 5000);
    },

    onResize: function () {
      // hide the popover so the content doesn't become misaligned onResize
      $('[data-toggle="popover"]').popover('hide');
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      console.log('['+this.name+'] - section:select');
    },

    onShow: function() {
      console.log('['+this.name+'] - section:show');
    },

    onLoad: function() {
      console.log('['+this.name+'] - section::load');
    },

    onUnload: function() {
      console.log('['+this.name+'] - section::unload');
    }
  });

  return Footer;
})(jQuery);

/**
 * Cart Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - cart
 */

theme.Cart = (function($) {

  var $body = $('body');

  var selectors = {
    form: '[data-cart-form]',
    item: '[data-cart-item][data-id][data-qty]',
    freeItem: '[data-free-product]',
    itemCartRemove: '[data-item-cart-remove]',
    sampleProduct: '[data-sample-product]',
    quantityAdjuster: '[data-quantity-adjuster][data-updates-key]',
    quantityAdjusterInput: '[data-quantity-adjuster] input[type="number"]',
    slideshow: '[data-slideshow]',
    gwpForm: '[data-gwp-form]',
    giftThreshold: '[data-gift-threshold]',
    removeGiftFromCart: '[data-remove-gift-product]'
  };

  function Cart(container) {

    this.$container = $(container);

    this.name = 'footer';
    this.namespace = '.' + this.name;

    this.$form = $(selectors.form, this.$container);
    this.$freeItem = $(selectors.freeItem, this.$container);
    this.$slideshow = $(selectors.slideshow, this.$container);
    this.$gwpForm = $(selectors.gwpForm, this.$container);
    this.giftThreshold = $(selectors.giftThreshold, this.$container).data('gift-threshold');
    this.$sampleProduct = $(selectors.sampleProduct);
    this.sampleProduct = this.$sampleProduct.data('sample-product');
    this.matchingProductType = this.$sampleProduct.data('matching-product-type');
    this.removeGiftFromCart = $(selectors.removeGiftFromCart, this.$container);

    $body.on('click', selectors.itemCartRemove, this.onItemRemoveClick.bind(this));
    this.$container.on('change', selectors.quantityAdjusterInput, this.onQuantityAdjusterInputChange.bind(this));

    if (this.removeGiftFromCart.length) {
      this.removeLeftOverGift();
    }

    this.giftSlideshow();
  }

  Cart.prototype = $.extend({}, Cart.prototype, {
    onQuantityAdjusterInputChange: function(e) {
      e.preventDefault();
      var $adjuster = $(e.currentTarget).parents(selectors.quantityAdjuster);
      var $itemQtyInput = $('[id="' + $adjuster.data('updates-key') + '"]'); // Have to do '[id=".."]' instead of '#id' because id is generated using {{ item.key }} which has semi-colons in it - breaks normal id select
      $itemQtyInput.val($(e.currentTarget).val());

      var attrs = this._getItemRowAttributes(e.target);

      this.changeLineItemQuantity(attrs.line, $(e.currentTarget).val()).then(this.getCart.bind(this)).then(this.checkSampleProduct.bind(this));
    },

    removeLeftOverGift: function() {
      const line = this.removeGiftFromCart.data('remove-gift-product');
      const giftID = this.removeGiftFromCart.data('gift-product-id'); 

      // Remove item form cart and then remove item from dom, 
      // We do this to prevent having to re-load the page multiple times
      this.changeLineItemQuantity(line, 0);
      $('[data-id="' + giftID + '"]').remove();
    },

    giftSlideshow: function() {
      var shouldSlick = this.$slideshow.children().length > 1 ? true : false;

      if (shouldSlick) {
        var settings = {
          fade: false,
          dots: false,
          arrows: true,
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          cssEase: slate.animations.getTransitionTimingFunction("inOutUI"),
          speed: slate.animations.getTransitionTimingDuration("slow"),
        };

        this.slideshow = new slate.models.Slideshow(this.$slideshow, settings);
      }
    },

    getCart: function() {
      var promise = $.Deferred();

      var url = slate.utils.isThemeEditor() ? '/cart.js' : '/cart?view=json'; // Theme editor inserts HTML comments in custom templates and breaks JSON response

      $.ajax({
        type: 'get',
        url: url,
        success: function(data) {
          var cart = JSON.parse(data);
          promise.resolve(cart);
        },
        error: function() {
          promise.reject({
            message: 'Could not retrieve cart items'
          });
        }
      });

      return promise;
    },

    changeLineItemQuantity: function(line, qty) {
      return new Promise(function(resolve) {
        $.ajax({
          type: 'post',
          dataType: 'json',
          url: '/cart/change.js',
          data: 'quantity=' + qty + '&line=' + line,
          success: function() {
            resolve(true);
          }
        })
      });
    },

    /**
       * Ensure we are working with a valid number
       *
       * @param {int|string} qty
       * @return {int} - Integer quantity.  Defaults to 1
       */
    _validateQty: function(qty) {
      return (parseFloat(qty) == parseInt(qty)) && !isNaN(qty) ? qty : 1;
    },

    /**
     * Ensure we are working with a valid number
     *
     * @param {element} el - cart item row or child element
     * @return {obj}
     */
    _getItemRowAttributes: function(el) {
      var $el = $(el);
      var $row = $el.is(selectors.item) ? $el : $el.parents(selectors.item);

      return {
        $row: $row,
        id: $row.data('id'),
        line: ($row.index() + 1),
        qty: this._validateQty($row.data('qty'))
      };
    },

    onItemRemoveClick: function(e) {
      e.preventDefault();
      var attrs = this._getItemRowAttributes(e.target);
      var thisElement = this;
      var lineNumber = attrs.line;
      var lineQuantity = attrs.qty;
      var matchProductType = $(document).find('[productsample]').data('sample-type');      
      var matchProductID = $(document).find('.mainCart').data('product-id');
      var dataTypeLength = $(document).find('[sampleProductRelated]').length;
      var productRemoveDataType = $(document).find('[data-line-item="'+lineNumber+'"]').data('type');
      var cartKey = $(document).find('[data-line-item="'+lineNumber+'"]').data('cart-key');
      if( matchProductType != undefined && productRemoveDataType != undefined ){
        if( matchProductType.indexOf(productRemoveDataType) > -1 && matchProductType != undefined ){
          if(dataTypeLength == 1){
            var removeProductObject = []
            $(document).find('[productsample]').each(function(){
              var removeProductId = $(this).data('id');
              removeProductObject.push(removeProductId)
            })
            var removeProductArray = removeProductObject.join(",")            
            function afterForloopAjax() {
              $.ajax({
                type: "POST",
                url: "/cart/change.js",
                dataType: "json",
                data: {
                  id: cartKey,
                  quantity: 0,
                },
                success:function(){
                  window.location.reload();
                }
              })
            }  
            function addAllItems(){
              Shopify.queue = [];
              var newArray = removeProductArray.split(',');
              for (var i = 0; i < newArray.length; i++) {
                product = newArray[i]
                Shopify.queue.push({
                  variantId: product,
                });
              }
              Shopify.moveAlong = function() {
                if (Shopify.queue.length){
                  var request = Shopify.queue.shift();
                  var data = 'id='+ request.variantId + '&quantity=0'
                  $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    dataType: 'json',
                    data: data,
                    success: function(res){;
                                           Shopify.moveAlong();
                                          },
                    error: function(){
                      location.reload();
                    }
                  });
                }
                else{

                  afterForloopAjax()
                  location.reload();

                }
              };
              Shopify.moveAlong();
            };
            addAllItems();

          }else{
            this.changeLineItemQuantity(attrs.line, 0).then(this.getCart.bind(this)).then(this.checkFreeProduct.bind(this));
          }
        }else{
          this.changeLineItemQuantity(attrs.line, 0).then(this.getCart.bind(this)).then(this.checkFreeProduct.bind(this));
        }
      }else{
        this.changeLineItemQuantity(attrs.line, 0).then(this.getCart.bind(this)).then(this.checkFreeProduct.bind(this));
      }
    },

    checkFreeProduct: function(cart) {
      if (cart.total_price < this.giftThreshold && this.$freeItem.length) {
        var attrs = this._getItemRowAttributes(selectors.freeItem);

        this.changeLineItemQuantity(attrs.line, 0).then(this.formSubmit());
      } else {
        this.formSubmit();
      }
    },

    checkSampleProduct: function(cart) {
     var productTypeQty = 0;
      var sampleAlreadyOnCart = false
      cart.items.forEach(function(item) {
        if(this.matchingProductType.indexOf(item.product_type) > -1){
          productTypeQty = productTypeQty + item.quantity;
        }
        if (this.sampleProduct.indexOf(item.variant_id) > -1){
//         if (item.variant_id == this.sampleProduct) {
          sampleAlreadyOnCart = true;
        }
      }.bind(this));

      if (productTypeQty >= 1 && this.sampleProduct && !sampleAlreadyOnCart) {
        this.addSampleProduct().then(this.formSubmit());
      } else {
        this.formSubmit();
      }
    },

    addSampleProduct: function() {
 var sampleProductContain = this.sampleProduct.toString();

 var sampleProductObject = {}
 sampleProductObject['items']= []
 
 
 if (sampleProductContain.indexOf(',') > 1){
   
 var  myArray = this.sampleProduct.split(",");
  
   for (let i = 0; i < myArray.length; i++) {
//      console.log(myArray[i]);
     sampleProductObject['items'][i]= {}
     sampleProductObject['items'][i]['quantity'] = 1;
     sampleProductObject['items'][i]['id'] = myArray[i];
   }
    console.log(sampleProductObject)
 }else{

     sampleProductObject['quantity'] = 1;
     sampleProductObject['id'] = this.sampleProduct;
 }
        console.log(sampleProductObject)

      var promise = $.Deferred();

      $.ajax({
        type: 'post',
        dataType: 'json',
        url: '/cart/add.js',
         data: sampleProductObject,
//         data: "quantity=1&id=" + this.sampleProduct,
        success: function() {
          promise.resolve();
        },
        error: function() {
          promise.reject({
            message: 'Error adding Sample'
          });
        }
      });

      return promise;
    },

    formSubmit: function() {
      this.$form.submit();
    }
  });

  return Cart;
})(jQuery);

/**
 * Blog Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - blog
 */

theme.Blog = (function($) {

  var selectors = {
    contentGrid: '[data-blog-list]',
    contentGridItem: '[data-blog-list-item]',
    pagination: '[data-pagination]',
    nextPageLink: '[data-next-page]',
    seasonLink: '[data-season]'
  };

  function Blog(container) {

    this.$container = $(container);

    this.name = 'blog';
    this.namespace = '.'+this.name;

    this.$container.on('click', selectors.nextPageLink, this.onNextPageLinkClick.bind(this));
    this.$container.on('click', selectors.seasonLink, this.onSeasonLinkClick.bind(this));
  }

  Blog.prototype = $.extend({}, Blog.prototype, {

    onNextPageLinkClick: function(e) {
      e.preventDefault();
      var self     = this;
      var $link    = $(e.currentTarget);
      var url      = $link.attr('href');

      $.ajax({
        url: url,
        beforeSend: function() {
          $link.html(theme.strings.loading || 'Loading');
        }
      })
      .done(function( data ) {
        var $dom = $(data);
        var $contentItems = $(selectors.contentGridItem, $dom);
        var $newNextPageLink = $(selectors.nextPageLink, $dom);

        $(selectors.contentGrid, self.$container).append($contentItems);

        if($newNextPageLink.length) {
          $link.replaceWith($newNextPageLink);
        }
        else {
          $(selectors.pagination, self.$container).remove();
        }
      });

    },
    onSeasonLinkClick: function(e) {
      e.preventDefault();  
      var targetSection = $(e.target).data('season');
      var $this = $("#season-" + targetSection).first();
      
      $('.porch-link', this.$container).removeClass('selected');
      $(e.target).addClass('selected');

      $('html, body').animate(
        {
          scrollTop: ($this.offset().top - 150),
        },{
          duration: 1000
        }
      )
    }
  });

  return Blog;
})(jQuery);

// prettier-ignore
/**
 * Blog Powered Section Script
 * ------------------------------------------------------------------------------
 *
 * These are pages with content pulled in through a single blog, organized by tag
 *
 * @namespace - blog
 */

theme.BlogPowered = (function ($) {

  var selectors = {
    tagBarLink: '[data-tag-link]',
    tagBarDropdown: '[data-tag-dropdown]',
    taggedContent: '[data-tagged-content]'
  };

  var classes = {
    linkActive: 'is-active'
  };

  function BlogPowered(container) {

    this.$container = $(container);

    this.name = 'blog';
    this.namespace = '.' + this.name;

    this.transitionDuration = slate.animations.getTransitionTimingDuration('base');
    this.currentTag = null;

    this.$taggedContent = $(selectors.taggedContent, this.$container);
    this.$tagLinks = $(selectors.tagBarLink, this.$container);
    this.$tagBarDropdown = $(selectors.tagBarDropdown, this.$container);

    this.$container.on('click', selectors.tagBarLink, this.onTagBarLinkClick.bind(this));
    this.$container.on('change', selectors.tagBarDropdown, this.onTagBarDropdownChange.bind(this));
  }

  BlogPowered.prototype = $.extend({}, BlogPowered.prototype, {

    switchToTag: function (tag) {

      var self = this;

      if (tag == this.currentTag) return;

      // Active stuff is what we're switching *to*
      // Inactive is what we're switching away from

      var $activeLink = this.$tagLinks.filter('[data-tag-link="' + tag + '"]');
      var $activeContent = this.$taggedContent; // This way if they click on "All" it will show everything

      if (tag.length != 0) {
        $activeContent = $activeContent.filter('[data-tagged-content="' + tag + '"]');
      }

      var $inactiveLinks = this.$tagLinks.not($activeLink);

      $inactiveLinks.parent().removeClass(classes.linkActive);
      $activeLink.parent().addClass(classes.linkActive);

      this.$tagBarDropdown.val(tag);
      this.$tagBarDropdown.trigger("chosen:updated");

      // Visibility filter so we don't call fadeout on elements that are already hidden
      // Reduces the number of times the callback is triggered
      var $inactiveContent = this.$taggedContent.not($activeContent).filter(':visible');

      if ($inactiveContent.length) {
        $inactiveContent.fadeOut(self.transitionDuration, function () {
          $activeContent.fadeIn(self.transitionDuration);
        });
      }
      else {
        $activeContent.fadeIn(self.transitionDuration);
      }

      this.currentTag = tag;
    },

    onTagBarDropdownChange: function (e) {
      e.preventDefault();
      this.switchToTag($(e.currentTarget).val());
    },

    onTagBarLinkClick: function (e) {
      e.preventDefault();
      this.switchToTag($(e.currentTarget).data('tag-link'));
    }
  });

  return BlogPowered;
})(jQuery);
// prettier-ignore-end

/**
 * ProductCarousel Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - ProductCarousel
 */

theme.ProductCarousel = (function($) {
  /**
   * ProductCarousel section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  //

  function ProductCarousel(container) {
    this.$container = $(container);

    this.productCarousel = new slate.models.ProductCarousel(this.$container);
  }

  ProductCarousel.prototype = $.extend({}, ProductCarousel.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(evt) {
      this.productCarousel.slideshow.goToSlideByBlockId(evt.detail.blockId);
      this.productCarousel.slideshow.pause();
    }
  });

  return ProductCarousel;
})(jQuery);

/**
 * Article Carousel Section Script
 * -----------------------------------------------------------------------------
 *
 * Carousel are slideshows with 2+ slidesToShow
 *
 * @namespace - ArticleCarousel
 */

theme.ArticleCarousel = (function($) {

  /**
   * Carousel section constructor
   *
   * @param {string} - container - selector for the section container DOM element
   */
  function ArticleCarousel(container) {
    this.$container = $(container);

    this.articleCarousel = new slate.models.ArticleCarousel(this.$container);
  }

  ArticleCarousel.prototype = $.extend({}, ArticleCarousel.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function (evt) {
      this.slideshow.goToSlideByBlockId(evt.detail.blockId);
      this.slideshow.pause();
    }
  });

  return ArticleCarousel;
})(jQuery);

/**
 * Video  Carousel Section Script
 * -----------------------------------------------------------------------------
 *
 * Carousel are slideshows with 2+ slidesToShow
 *
 * @namespace - Video Carousel
 */

theme.VideoCarousel = (function($) {
  var selectors = {
    slideshow: '[data-slideshow]',
    slide: '.content-grid__item'
  };

  var classes = {};

  /**
   * Carousel section constructor
   *
   * @param {string} - container - selector for the section container DOM element
   */
  function VideoCarousel(container) {
    this.$container = $(container);

    this.videoCarousel = new slate.models.VideoCarousel(this.$container);
  }

  VideoCarousel.prototype = $.extend({}, VideoCarousel.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function (evt) {
      this.slideshow.goToSlideByBlockId(evt.detail.blockId);
      this.slideshow.pause();
    }
  });

  return VideoCarousel;
})(jQuery);

/**
 * Search Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - search
 */

theme.Search = (function($) {

  var selectors = {
    pagination: '[data-search-pagination]',
    nextPageLink: '[data-next-page]',
    searchResultGrid: '[data-search-results]',
    searchResultGridItem: '[data-search-restul-item]',
    backInStockTrigger: '[data-back-in-stock-trigger]',
    backInStockTriggerInner: '[data-back-in-stock-trigger-inner]',
    slideshow: '[data-slideshow]'
  };

  var classes = {

  };

  function Search(container) {

    this.$container = $(container);

    this.name = 'search';
    this.namespace = '.'+this.name;

    this.$container.on('click', selectors.nextPageLink, this.onNextPageLinkClick.bind(this));

    this.$nextPageLink = $( selectors.nextPageLink, this.$container );

    var settings = {
      fade: false,
      dots: true,
      arrows: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      cssEase: slate.animations.getTransitionTimingFunction("inOutUI"),
      speed: slate.animations.getTransitionTimingDuration("slow"),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true
          }
        }
      ]
    };

    this.slideshow = new slate.models.Slideshow( $(selectors.slideshow, this.$container), settings);
  }

  Search.prototype = $.extend({}, Search.prototype, {

    onNextPageLinkClick: function(e) {

      e.preventDefault();
      var self     = this;
      var $link    = $(e.currentTarget);
      var url      = $link.attr('href');

      $.ajax({
        url: url,
        beforeSend: function() {
          $link.html(theme.strings.loading || 'Loading');
        }
      })
      .done(function( data ) {
        var $dom = $(data);
        var $contentItems = $(selectors.searchResultGridItem, $dom);
        var $newNextPageLink = $(selectors.nextPageLink, $dom);

        $(selectors.searchResultGrid, self.$container).append($contentItems);

        if($newNextPageLink.length) {
          $link.replaceWith($newNextPageLink);
        }
        else {
          $(selectors.pagination, self.$container).remove();
        }
      });

    }

  });

  return Search;
})(jQuery);

/**
 * CMS Page Section Script
 * ------------------------------------------------------------------------------
 *
 * Requires:
 * - slick.min.js
 * @namespace - cmsPage
 * 
 */

theme.CMSPage = (function($) {

  var $window = $(window);

  var selectors = {
    productCarousel: '[data-product-carousel]',
    bannerCarousel: '[data-banner-carousel]',
    articleCarousel: '[data-article-carousel]',
    videoCarousel: '[data-video-carousel]',
    collectionCarousel: '[data-collection-carousel]',
    secondaryMenu: '[data-secondary-menu]',
    header: '[data-collection-header]'
  };

  var classes = {

  };
  
  function CMSPage(container) {

    this.$container = $(container);

    this.name = 'cmsPage';
    this.namespace = '.'+this.name;

    this.events = {
      SCROLL: 'scroll' + this.namespace
    };

    this.$secondaryMenu = $(selectors.secondaryMenu, this.$container);

    // Props
    this.productCarousels = [];
    this.bannerCarousel = [];
    this.articleCarousel = [];
    this.videoCarousel = [];
    this.collectionCarousel = [];

    // Carousels
    this.$container.find(selectors.productCarousel).each(function(i, el) {
      var pc = new slate.models.ProductCarousel(el);
      this.productCarousels.push(pc);
    }.bind(this));

    this.$container.find(selectors.articleCarousel).each(function(i, el) {
      var ac = new slate.models.ArticleCarousel(el);
      this.articleCarousel.push(ac);
    }.bind(this));

    this.$container.find(selectors.videoCarousel).each(function(i, el) {
      var vc = new slate.models.VideoCarousel(el);
      this.videoCarousel.push(vc);
    }.bind(this));

    this.$container.find(selectors.collectionCarousel).each(function(i, el) {
      var cc = new slate.models.CollectionCarousel(el);
      this.collectionCarousel.push(cc);
    }.bind(this));

    this.$container.find(selectors.bannerCarousel).each(function(i, el) {
      var ss = new slate.models.BannerCarousel(el);
      this.bannerCarousel.push(ss);
    }.bind(this));

    $window.on(this.events.SCROLL, $.throttle(20, this.onScroll.bind(this)));
  }

  CMSPage.prototype = $.extend({}, CMSPage.prototype, {
    onScroll: function() {
      var scrollTop = $window.scrollTop();
      var headerHeight = $(selectors.header).outerHeight();
      if (this.$secondaryMenu.length) {
        var offset = this.$secondaryMenu.offset();
        var secondaryNavTop = offset.top;
  
        if (scrollTop + headerHeight > secondaryNavTop) {
          this.$secondaryMenu.addClass('is-fixed');
        } else {
          this.$secondaryMenu.removeClass('is-fixed');
        }
      }
    }
  });

  return CMSPage;

})(jQuery);

/**
 * Email Coupon Section Script
 * ------------------------------------------------------------------------------
 *
 * Details are dependent on:
 *  - Mailing list provider (See settings_schema.json)
 *  - 3rd party ajax / validation scripts
 *
 * @namespace - emailCoupon
 */

theme.EmailCoupon = (function($, slate) {

  var selectors = {
    klaviyoForm: 'form[data-klaviyo-list-id]',
    formContent: '[data-email-coupon-form-content]',
    formMessage: '[data-email-coupon-form-message]',
    emailCouponImage: '[data-email-coupon-image]',
    emailCouponTooltip: '[data-email-coupon-tooltip]'
  };

  var classes = {
    showMessage: 'show-message',
    showTooltip: 'show-tooltip'
  };

  /**
   * Email Coupon section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function EmailCoupon(container) {
    this.$container = $(container);

    this.name = 'emailCoupon';
    this.namespace = '.' + this.name;

    // DOM elements we'll need
    this.$formContent = $(selectors.formContent, this.$container);
    this.$formMessage = $(selectors.formMessage, this.$container);
    this.$klaviyoForm = $(selectors.klaviyoForm, this.$container);
    this.$emailCouponImage = $(selectors.emailCouponImage, this.$container);
    
    this.$emailCouponImage.on('click', this.imageClick.bind(this))

    this.ajaxKlaviyoForm = new slate.AjaxKlaviyoForm(this.$klaviyoForm, {
      listId: this.$klaviyoForm.data('klaviyo-list-id'),
      source: this.$klaviyoForm.data('klaviyo-source'),
      onSubscribeSuccess: this.onSubscribeSuccess.bind(this),
      onSubscribeFail: this.onSubscribeFail.bind(this),
      onSubmitFail: this.onSubmitFail.bind(this)
    });
  }

  EmailCoupon.prototype = $.extend({}, EmailCoupon.prototype, {
    imageClick: function() {
      $(selectors.emailCouponTooltip, this.$container).toggleClass(classes.showTooltip);
    },

    onSubscribeSuccess: function() {
      this.$formMessage.html(this.$formMessage.data('message-success'));
      this.$formContent.addClass(classes.showMessage);
    },

    onSubscribeFail: function() {
      this.$formMessage.html(this.$formMessage.data('message-fail'));
      this.$formContent.addClass(classes.showMessage);
      setTimeout(function() {
        this.$formContent.removeClass(classes.showMessage);
      }.bind(this), 5000);
    },

    onSubmitFail: function() {
      this.$formMessage.html(this.$formMessage.data('message-fail'));
      this.$formContent.addClass(classes.showMessage);
      setTimeout(function() {
        this.$formContent.removeClass(classes.showMessage);
      }.bind(this), 5000);
    },
  });

  return EmailCoupon;
})(jQuery, slate);

/**
 * Collection Ingredients Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - CollectionIngredients
 */

theme.CollectionIngredients = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]',
    slideshowBottom: '[data-slideshow-bottom]',
    mobileSlickDots: '.mobile-slick-dots'
  };

  var classes = {
    activeClass: 'slick-active'
  }

  /**
   * Collection Ingredients section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function CollectionIngredients(container) {
    this.$container = $(container);

    this.name = 'c-ingredients';
    this.namespace = '.' + this.name;

    var settings = {
      infinite: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            appendDots: $(selectors.mobileSlickDots, this.$container),
            nextArrow: $('.collection-ingredients__arrow--right'),
            prevArrow: $('.collection-ingredients__arrow--left'),
          }
        }
      ]
    };

    this.slideshow = new slate.models.Slideshow($(selectors.slideshow, this.$container), settings);

    var isFirstUndefined = true;
    var goToFirstSlide = false;
    var slidesToShow = $(selectors.slideshow, this.$container).data('slides-to-show');
    if ($(window).innerWidth() >= 751) {
      $(selectors.slideshow, this.$container).on("afterChange", function(event, slick, currentSlide) {
        var totalSlides = currentSlide + slidesToShow;
  
        if (goToFirstSlide) {
          slick.$slider.slick("slickGoTo", 0);
          goToFirstSlide = false;
          isFirstUndefined = false;
        }
  
        if (isFirstUndefined && totalSlides >= slick.slideCount) {
          goToFirstSlide = true;
        }
  
        if (!isFirstUndefined) {
          isFirstUndefined = true;
        }
      });
    }
  }

  CollectionIngredients.prototype = $.extend({}, CollectionIngredients.prototype, {
    /**
     * Theme Editor section events below
     */
  });

  return CollectionIngredients;
})(jQuery);

/**
 * Card Grid Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - CardGrid
 */

theme.CardGrid = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]',
    // slideshowBottom: '[data-enable-mobile-slideshow]',
    mobileSlickDots: '.mobile-slick-dots'
  };

  /**
   * Card Grid section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function CardGrid(container) {
    this.$container = $(container);
    var settings = {
      infinite: false,
      fade: false,
      equalHeight: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: true,
      appendDots: $(selectors.mobileSlickDots, this.$container),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };

    if ($(window).innerWidth() < 992 && this.$container.data('enableMobileSlideshow')) {
      this.slideshow = new slate.models.Slideshow($(selectors.slideshow, this.$container), settings);
    }
  }

  CardGrid.prototype = $.extend({}, CardGrid.prototype, {
    /**
     * Theme Editor section events below
     */
  });

  return CardGrid;
})(jQuery);

/**
 * Card Carousel Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - CardCarousel
 */

theme.CardCarousel = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]',
    slickDots: '.slick-dots'
  };

  /**
   * Card Grid section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function CardCarousel(container) {
    this.$container = $(container);
    var settings = {
      infinite: false,
      fade: false,
      // equalHeight: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      appendDots: $(selectors.slickDots, this.$container),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 998,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        }
      ]
    };

    this.slideshow = new slate.models.Slideshow($(selectors.slideshow, this.$container), settings);
  }

  CardCarousel.prototype = $.extend({}, CardCarousel.prototype, {
    /**
     * Theme Editor section events below
     */
  });

  return CardCarousel;
})(jQuery);

/**
 * ContentSlider Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - ContentSlider
 */

theme.ContentSlider = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]',
    imagesSlideshow: '[data-images-slideshow]',
    mobileSlickDots: '.mobile-slick-dots'
  };

  /**
   * Content Slider section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function ContentSlider(container) {
    this.$container = $(container);

    this.name = 'content-slider';
    this.namespace = '.' + this.name;

    var settings = {
      infinite: false,
      nextArrow: $('.content-slider__arrow--right'),
      prevArrow: $('.content-slider__arrow--left'),
      asNavFor: $(selectors.imagesSlideshow, this.$container),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            appendDots: $(selectors.mobileSlickDots, this.$container)
          }
        }
      ]
    };

    var imagesSettings = {
      infinite: false,
    }

    this.slideshow = new slate.models.Slideshow($(selectors.slideshow, this.$container), settings);
    this.imagesSlideshow = new slate.models.Slideshow($(selectors.imagesSlideshow, this.$container), imagesSettings);

    if ($(selectors.slideshow, this.$container).find('.single-slide').length == 1) {
      $(selectors.slideshow, this.$container).siblings('.mobile-slick-control').hide();
      $(selectors.slideshow, this.$container).siblings('.content-slider__arrow').hide();
    }
  }

  ContentSlider.prototype = $.extend({}, ContentSlider.prototype, {
    /**
     * Theme Editor section events below
     */
  });

  return ContentSlider;
})(jQuery);

/**
 * Sign Up Section Script
 * ------------------------------------------------------------------------------
 *
 * Details are dependent on:
 *  - Mailing list provider (See settings_schema.json)
 *  - 3rd party ajax / validation scripts
 *
 * @namespace - signUp
 */

theme.SignUp = (function($, slate) {

  var selectors = {
    klaviyoForm: 'form[data-klaviyo-list-id]',
    formContent: '[data-email-coupon-form-content]',
    formMessage: '[data-email-coupon-form-message]'
  };

  var classes = {
    showMessage: 'show-message',
    showTooltip: 'show-tooltip'
  };

  /**
   * Sign Up section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function SignUp(container) {
    this.$container = $(container);

    this.name = 'signUp';
    this.namespace = '.' + this.name;

    // DOM elements we'll need
    this.$formContent = $(selectors.formContent, this.$container);
    this.$formMessage = $(selectors.formMessage, this.$container);
    this.$klaviyoForm = $(selectors.klaviyoForm, this.$container);

    if (this.$klaviyoForm.length) {
      this.ajaxKlaviyoForm = new slate.AjaxKlaviyoForm(this.$klaviyoForm, {
        listId: this.$klaviyoForm.data('klaviyo-list-id'),
        source: this.$klaviyoForm.data('klaviyo-source'),
        onSubscribeSuccess: this.onSubscribeSuccess.bind(this),
        onSubscribeFail: this.onSubscribeFail.bind(this),
        onSubmitFail: this.onSubmitFail.bind(this)
      });
    }
  }

  SignUp.prototype = $.extend({}, SignUp.prototype, {
    onSubscribeSuccess: function() {
      this.$formMessage.html(this.$formMessage.data('message-success'));
      this.$formContent.addClass(classes.showMessage);
      this.$container.find('.sign-up__back-image-container').fadeOut();
      this.$container.find('.sign-up__front-image-container').fadeOut('400', function() {
        this.$container.find('.sign-up__success-image-container').fadeIn();
      }.bind(this));
    },

    onSubscribeFail: function() {
      this.$formMessage.html(this.$formMessage.data('message-fail'));
      this.$formContent.addClass(classes.showMessage);
      setTimeout(function() {
        this.$formContent.removeClass(classes.showMessage);
      }.bind(this), 5000);
    },

    onSubmitFail: function() {
      this.$formMessage.html(this.$formMessage.data('message-fail'));
      this.$formContent.addClass(classes.showMessage);
      setTimeout(function() {
        this.$formContent.removeClass(classes.showMessage);
      }.bind(this), 5000);
    },
  });

  return SignUp;
})(jQuery, slate);

/**
 * Featured Blogs Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - FeaturedBlogs
 */

theme.FeaturedBlogs = (function($) {

  var selectors = {
    blogsWrapper: '[data-blogs-wrapper]',
    singleBlog: '[data-single-blog]',
    loadMore: '[data-load-more]',
    showLess: '[data-show-less]',
    mobileSlickDots: '.mobile-slick-dots'
  };

  /**
   * Featured Blogs section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function FeaturedBlogs(container) {
    this.$container = $(container);

    this.name = 'featured-blogs';
    this.namespace = '.' + this.name;

    var settings = {
      infinite: false,
      mobileFirst: true,
      appendDots: $(selectors.mobileSlickDots, this.$container),
      nextArrow: $('.featured-blogs__arrow--right'),
      prevArrow: $('.featured-blogs__arrow--left'),
      responsive: [
        {
          breakpoint: 768,
          settings: 'unslick'
        }
      ]
    };

    this.blogsWrapper = new slate.models.Slideshow($(selectors.blogsWrapper, this.$container), settings);

    this.$singleBlog = $(selectors.singleBlog, this.$container);
    this.$loadMore = $(selectors.loadMore, this.$container);
    this.$showLess = $(selectors.showLess, this.$container);
    this.singleBlogsLength = this.$singleBlog.length;
    this.itemsToShow = 3;
    
    this.$showLess.hide();
    this.$singleBlog.slice(0, this.itemsToShow).show();

    this.$loadMore.on('click', this.loadMoreClick.bind(this));
    this.$showLess.on('click', this.showLessClick.bind(this));
  }

  FeaturedBlogs.prototype = $.extend({}, FeaturedBlogs.prototype, {
    /**
     * Theme Editor section events below
     */
    loadMoreClick: function() {
      var newItemsToShow = (this.itemsToShow + 3 <= this.singleBlogsLength) ? this.itemsToShow + 3 : this.singleBlogsLength;

      this.itemsToShow = newItemsToShow;
      this.$singleBlog.slice(0, newItemsToShow).show();
      this.$showLess.show();
      
      if (newItemsToShow == this.singleBlogsLength) {
        this.$loadMore.hide();
      }
    },

    showLessClick: function() {
      var newItemsToShow = (this.itemsToShow - 3 < 3) ? 3 : this.itemsToShow - 3;

      this.$singleBlog.hide();
      this.$singleBlog.slice(0, newItemsToShow).show();
      this.$loadMore.show();
      this.$showLess.show();

      if (newItemsToShow == 3) {
        this.$showLess.hide();
      }
    }
  });

  return FeaturedBlogs;
})(jQuery);

/**
 * Related Collections Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - RelatedCollections
 */

theme.RelatedCollections = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]'
  };

  /**
   * Related Collections section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function RelatedCollections(container) {
    this.$container = $(container);

    this.name = 'related-collections';
    this.namespace = '.' + this.name;

    var settings = {
      infinite: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: 'unslick'
        }
      ]
    };

    this.slideshow = new slate.models.Slideshow($(selectors.slideshow, this.$container), settings);
  }

  RelatedCollections.prototype = $.extend({}, RelatedCollections.prototype, {
    /**
     * Theme Editor section events below
     */
  });

  return RelatedCollections;
})(jQuery);

/**
 * Collection Products Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - CollectionProducts
 */

theme.CollectionProducts = (function($) {

  var selectors = {
    slideshow: '[data-slideshow]',
    slideshowBottom: '[data-slideshow-bottom]',
    mobileSlickDots: '.mobile-slick-dots'
  };

  var classes = {
    activeClass: 'slick-active'
  }

  /**
   * Collection Products section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function CollectionProducts(container) {
    this.$container = $(container);

    this.name = 'collection-products';
    this.namespace = '.' + this.name;

    var settings = {
      infinite: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    $(selectors.slideshow, this.$container).each(function(index, element) {
      this.slideshow = new slate.models.Slideshow(element, settings);
    }.bind(this));
  }

  CollectionProducts.prototype = $.extend({}, CollectionProducts.prototype, {
    /**
     * Theme Editor section events below
     */
  });

  return CollectionProducts;
})(jQuery);


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  var selectors = {
    addressNewToggle: '[data-address-new-toggle]',
    addressEditToggle: '[data-address-edit-toggle][data-form-id]',
    addressDelete: '[data-address-delete][data-form-id]'
  };

  // Toggle new/edit address forms
  $(selectors.addressNewToggle).on('click', function(e) {
    e.preventDefault();
    $newAddressForm.toggleClass('hide');
  });

  $(selectors.addressEditToggle).on('click', function(e) {
    e.preventDefault();
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $(selectors.addressDelete).on('click', function(e) {
    e.preventDefault();
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAccount
 */

theme.customerAccount = (function() {

  var $window = $(window);
  var $body   = $(document.body);

  var selectors = {
    purchaseHistory: '[data-purchase-history]',
    accountDetails: '[data-billing-information]',
    accountButton: '[data-account-button]',
    purchaseButton: '[data-orders-button]',
    mobileOrder: '[data-mobile-order]'
  };

})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
    $('#RecoverPassword').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/**
 * Styleguide Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the styleguide page template.
 *
 * Use this to hook up any JS necessary to show element functionality.
 */

 theme.styleguide = (function() {
  
  var $body = $(document.body);
  
  var selectors = {
    dot: '.dot'
  };

  if( !$body.is('.template-page-styles') ){
    return;
  }

  $body.on('click', selectors.dot, function(){
    $(this).toggleClass('is-active');
  });

  $body.on('click', 'a[href="#"]', function(){
    return false;
  });

})();

/**
 * Styleguide Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the components page template.
 *
 * Use this to hook up any JS necessary to show element functionality.
 */

 theme.components = (function() {
  
  var $body = $(document.body);
  
  var selectors = {
    slideupAlertForm: '[data-slideup-alert-form]',
    qaSetMax: '[data-qa-set-max]',
    qaToggleEnabled: '[data-qa-toggle-enabled]',
    qa: '[data-quantity-adjuster]'
  };

  if( !$body.is('.template-page-components') ){
    return;
  }

  $(selectors.slideupAlertForm).on('submit', function(e) {
    e.preventDefault();

    new slate.models.SlideupAlert({
      title: $(this).find('input[name="title"]').val(),
      text: $(this).find('input[name="text"]').val()
    });
  });

  // Quantity Adjuster
  $(selectors.qaSetMax).on('click', function(e) {
    $(selectors.qa).find('input[type="number"]').attr('max', $(e.currentTarget).data('qa-set-max'));
  });

  $(selectors.qaToggleEnabled).on('click', function(e) {
    var $qaInput = $(selectors.qa).find('input[type="number"]');
    $qaInput.attr('disabled', !$qaInput.is(':disabled'));
  });

  $body.on('click', 'a[href="#"]', function(){
    return false;
  });

})();


(function($) {

  var $window = $(window);
  var $document = $(document);
  var $body = $(document.body);

  $(document).ready(function() {
    var sections = new slate.Sections();
    sections.register('product', theme.Product);
    sections.register('collection', theme.Collection);
    sections.register('instagram-feed', theme.InstagramFeed);
    sections.register('slideshow', theme.Slideshow);
    sections.register('footer', theme.Footer);
    sections.register('cart', theme.Cart);
    sections.register('blog', theme.Blog);
    sections.register('blog-powered', theme.BlogPowered);
    sections.register('article-grid', theme.ArticleCarousel);
    sections.register('product-carousel', theme.ProductCarousel);
    sections.register('video-carousel', theme.VideoCarousel);
    sections.register('banner-carousel', theme.BannerCarousel);
    sections.register('search', theme.Search);
    sections.register('cms-page', theme.CMSPage);
    sections.register('email-coupon', theme.EmailCoupon);
    sections.register('c-ingredients', theme.CollectionIngredients);
    sections.register('card-grid', theme.CardGrid);
    sections.register('card-carousel', theme.CardCarousel);
    sections.register('content-slider', theme.ContentSlider);
    sections.register('sign-up', theme.SignUp);
    sections.register('featured-blogs', theme.FeaturedBlogs);
    sections.register('related-collections', theme.RelatedCollections);
    sections.register('collection-products', theme.CollectionProducts);
    sections.register('bundle-builder', theme.BundleBuilder);

    $("a.smooth-scroll").on('click', function(e) {
      e.preventDefault();
      $("html, body").animate({ scrollTop: $("div:visible[id*='" + $(this).attr("href").substring(1) + "']").offset().top }, 500);
    });

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    // Target tables to make them scrollable
    slate.rte.wrapTables({
      $tables: $('.rte table'),
      tableWrapperClass: 'table-responsive'
    });

    // Init Enllax (Parallax effect)
    $window.on('load', function() {
      $window.enllax();
    });

    // Target iframes to make them responsive
    var iframeSelectors =
      '.rte iframe[src*="youtube.com/embed"],' +
      '.rte iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({
      $iframes: $(iframeSelectors),
      iframeWrapperClass: 'rte__video-wrapper'
    });

    // Apply UA classes to the document
    slate.utils.userAgentBodyClass();

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.utils.cookiesEnabled()) {
      document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }

    // Chosen JS plugin for select boxes
    // slate.utils.chosenSelects();

    // Form event handling / validation
    slate.forms.initialize();

    // Cart
    var cart = new slate.Cart();

    cart.init();

    // START - Global handler for collapse plugin to add state class for open panels
    var panelIsOpenClass = 'is-open';

    $document.on('show.bs.collapse', '.collapse', function(e) {
      $(e.currentTarget).parents('.panel').addClass(panelIsOpenClass);
    });

    $document.on('hide.bs.collapse', '.collapse', function(e) {
      $(e.currentTarget).parents('.panel').removeClass(panelIsOpenClass);
    });

    $('.collapse.in').each(function() {
      $(this).parents('.panel').addClass(panelIsOpenClass);
    });
    // END - Global handler for collapse plugin to add state class for open panels
  });

  // Initialize popovers using data attributes
  $(function() {
    $('[data-toggle="popover"]').popover()
  });

}(jQuery));

$(document).ready(function(){
  function check(){
    if($(document).find('.rc_widget__price--subsave').hasClass('active')){ } else {
      var find_length =  $(document).find('.rc_widget__price--subsave').length;
      if(find_length === 1){
        // $(".payment-option").css('visibility','visible');
        setTimeout(function(){
          var findFirstValue = $(document).find('.rc-selling-plans__dropdown').find('option:first').data('plan-option');
          var textReplace = findFirstValue.replace("you e",'E');
          //var price = $(".rc_widget__price--subsave").text();
          var createUl = '';
          $(".rc_widget__option__plans__dropdown option").each(function(index){
            $(this).text($(this).text().replace("you e",'E'));
            var thisValue = $(this).val();
            if(index == 0){
              createUl += '<li class="selected" value="'+thisValue+'">'+$(this).text().replace("you e",'E')+'</li>';
            }else{
              createUl += '<li value="'+thisValue+'">'+$(this).text().replace("you e",'E')+'</li>';
            }
          }); 
          $(document).find('.rc-selling-plans__label').text(textReplace);
          $(document).find('.rc-selling-plans').append('<ul class="itg-custom-plan">'+createUl+'</ul>');
          $(document).find('.rc-selling-plans__label').append('<span class="subscription-banner">Modify or cancel any time. <a class="subscription_btn" href="javascript:void(0)">Subscription Details.<div class="subscription-popup"><strong>How Subscriptions Work</strong>Products are automatically delivered on your schedule. No obligation, modify or cancel your subscription anytime.<button data-subscription-href="https://www.sunbum.com/pages/subscription-policy">Learn more</button></div></a></span>');
        },500);               
        $(document).find('.rc_widget__price--subsave').addClass('active');
      }  	
    }
  }
  setInterval(function () {
    check();
  }, 500);   
  $(document).on("change",".rc_widget__option__plans__dropdown",function() {
    var selected_rc = $(".rc_widget__option__plans__dropdown option:selected").data("plan-option");      
    var finaltext  = selected_rc.replace('you',''); 	
    $('.rc-selling-plans__label').html(finaltext+'<span class="subscription-banner">Modify or cancel any time. <a class="subscription_btn" href="javascript:void(0)">Subscription Details.<div class="subscription-popup"><strong>How Subscriptions Work</strong>Products are automatically delivered on your schedule. No obligation, modify or cancel your subscription anytime.<button data-subscription-href="https://www.sunbum.com/pages/subscription-policy">Learn more</button></div></a></span>');
  });
  $(document).on("mousedown",".rc-selling-plans__label",function(event) {
    var getTarget = event.target.className;
    if(getTarget != 'subscription_btn'){
      $(document).find('.itg-custom-plan').toggleClass('active');     
    }
  });
  $(document).on("click touchstart",".itg-custom-plan>li",function() {
    $(document).find('.itg-custom-plan').removeClass('active'); 
    $(document).find('.itg-custom-plan>li').removeClass('selected');  
    $(this).addClass('selected');
    var thisValue = $(this).attr('value');
    var thisText = $(this).text();
    $(".rc_widget__option__plans__dropdown option").each(function(index){
      var sellingText = $(this).val();
      var selectChange = document.querySelector("select.rc_widget__option__plans__dropdown"); 
      if(thisValue === sellingText){
        $(document).find('.rc-selling-plans__label').html(thisText+'<span class="subscription-banner">Modify or cancel any time. <a class="subscription_btn" href="javascript:void(0)">Subscription Details.<div class="subscription-popup"><strong>How Subscriptions Work</strong>Products are automatically delivered on your schedule. No obligation, modify or cancel your subscription anytime.<button data-subscription-href="https://www.sunbum.com/pages/subscription-policy">Learn more</button></div></a></span>');
        selectChange.value = sellingText; 
        selectChange.dispatchEvent(new Event("change"));
      }
    });
  });
 
  $(document).on('click','button[data-subscription-href]',function(event){
    event.preventDefault();
    var subscriptionHref = $(this).data('subscription-href');
    window.location.href = subscriptionHref;
  });

  if($(document).find('.rc_subscription_next_charge_date').length){
    $(document).find('.rc_subscription_next_charge_date').each(function(){
      var getCancelButton = $(this).find('a').attr('href');
      var createCancelButton = getCancelButton.replace("?", "/cancel?");
      $(this).find('a').after('<div class="itg-custom-cancel"><button class="cancel_button rc_btn--secondary rc_btn--secondary--color" data-cancelation="'+createCancelButton+'">Cancel</button></div>')
    });
    $(document).on('click','.cancel_button',function(){
      var getUrl = $(this).data('cancelation');
      $.ajax({
        url: getUrl,
        type: "post",
        dataType: "json",
        data: {
          cancellation_reason: "cancellation_reason",
          cancellation_reason_comments: "additional comment",
        },
      }).done(function (response) {
        window.location.reload();
      })
      .fail(function (response) {
        alert("Something went wrong please try again later!");
      });
    });
  }

  $('.gwp-cart__form-wrapper .btn.btn-primary.btn-sm').click(function(){
    $(this).parents('.gwp-cart__form').hide();
    setTimeout(function(){
     location.reload();
      },1200);
  });
  $('#your-shopping-cart .quantity-adjuster button').click(function(){
    setTimeout(function(){
     location.reload();
    },1200);
  });

  let challengeText = $('.shopify-challenge__message');
  if (challengeText.length > 0) {
    challengeText = challengeText.text('Only humans beyond this point.\nLet us know you\'re real.').addClass('h3');
    challengeText.html(challengeText.html().replace(/\n/g,'<br/>'));
  }

  // make external links open in a new tab
  [...document.links].forEach(function(link){
    if (link.hostname && link.hostname !== window.location.hostname) {
      link.target = '_blank';
      link.rel = 'noreferrer noopener';
    }
  })

  $(document).on('click', '#popoverCouponButton', function(event){
    const text = 'Copied!';
    const $this = $(this);
    const cc = $this.text();
    if (cc !== text && copyContent($this.text())) {
      $this.text('Copied!');
      setTimeout(() => {$this.text(cc);}, 1400);
    }
  });  

  // $(document).on('click', '.user-nav__menu-item-desk-search > a', function(){
  //   $('#header-inner-div').addClass('search-open');
  //   $(this).parents('#header-inner-div').find('.utility-bar__search').addClass('is-active');
  // });  
  // $(document).on('click', '#header-inner-div .utility-bar__inner .utility-bar__search-close', function(){
  //   $('#header-inner-div').removeClass('search-open');
  // });  
  // $(document).on('click', '.header-search-span', function(){
  //   $('.header-search-wrapper').show();
  // });
  // $(document).on('click', '.header-search-wrapper .icon-close-btn, .snize-mobile-top-panel button.snize-close-button-arrow', function(){
  //   $('.header-search-wrapper').hide();
  // });
});

async function copyContent(text) {
  try {
    await navigator.clipboard.writeText(text);
    console.log('Content copied to clipboard');
    return true;
    /* Resolved - text copied to clipboard successfully */
  } catch (err) {
    console.error('Failed to copy: ', err);
    return false;
    /* Rejected - text failed to copy to the clipboard */
  }
}

// Account Template - section hash route
((w,d) => {
  if (d.location.pathname !== '/account') return;
  const details = d.querySelector('[id$="__main"].account-details');
  const orders = d.querySelector('[id$="__account-orders"].account-orders');
  if (!details || !orders) return;
  const detailsHeader = details.previousSibling;
  const ordersHeader = orders.previousSibling;
  
  const init = () => {
    // console.log(d.location.hash)
    // hide all sections
    details.style.display = 'none';
    detailsHeader.style.display = 'none';
    orders.style.display = 'none';
    ordersHeader.style.display = 'none';

    switch (d.location.hash) {
      case '#orders':
        orders.style.display = 'block';
        ordersHeader.style.display = 'block';
        break;
      default:
        details.style.display = 'block';
        detailsHeader.style.display = 'block';
        break;
    }
  }
  if (Shopify.designMode) return;
  init();
  w.addEventListener('hashchange', () => init(), false);
})(window,document);

// Card Showcase
((w,d) => {
  const startObserver = (observers) => observers.map(({observer, cards}) => [...cards].forEach((item) => observer.observe(item)));
  // const endObserver = () => observers.map(({observer, cards}) => [...cards].forEach((item) => observer.unobserve(item)));
  const options = { rootMargin: "0px 5px 0px 5px", threshold: 1 };
  const callback = (entries) => {
    entries.forEach(({intersectionRatio, target}) => {
      const id = target.dataset.id;
      const dot = d.querySelector(`button[data-id="${id}"]`);
      if (!dot) return;
      if (intersectionRatio === 1){
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.setAttribute('aria-current', 'false');
      }
    })
  };
  const clickHandler = ({currentTarget}) => {
    const id = currentTarget.dataset.id;
    const card = d.querySelector(`.card-showcase__card-wrapper[data-id="${id}"]`);
    const wrapper = currentTarget.closest('.card-showcase__controls').previousElementSibling;
    if (!card || !wrapper) return;
    wrapper.scrollTo({
      top: 0,
      left: card.offsetLeft,
      behavior: 'smooth'
    });
  };
  const init = () => {
    const observers = [];
    const card_showcase = d.querySelectorAll('.card-showcase__snap');
    if (!card_showcase.length) return;
    [...card_showcase].map(item => {
      observers.push({
        observer: new IntersectionObserver(callback, {...options, root: item }),
        cards: item.querySelectorAll('.card-showcase__card-wrapper')
      })
    })
  
    startObserver(observers);
    
    [...d.querySelectorAll('.card-showcase__controls button')].map(item => item.addEventListener('click', clickHandler));
  
    document.addEventListener('shopify:block:select', ({target}) => {
      target.closest('.card-showcase__snap').scrollTo({
        top: 0,
        left: target.offsetLeft
      });
    })
  }

  init();

  w.addCardShowcaseSection = (sectionElement) => {
    const card_showcase = sectionElement.querySelector('.card-showcase__snap');
    // console.log(sectionElement, card_showcase);
    if (!card_showcase) return;
    const observer = [{
      observer: new IntersectionObserver(callback, {...options, root: card_showcase }),
      cards: card_showcase.querySelectorAll('.card-showcase__card-wrapper')
    }];
  
    startObserver(observer);

    Array.from(sectionElement.querySelectorAll('.card-showcase__controls button')).map(item => item.addEventListener('click', clickHandler));
  }
})(window,document);

function throttle(callback) {
  let requestId = null, lastArgs;
  const later = (context) => () => {
    requestId = null;
    callback.apply(context, lastArgs);
  };
  const throttled = (...args) => {
    lastArgs = args;
    if (requestId === null) {
      requestId = requestAnimationFrame(later(this));
    }
  };
  throttled.cancel = () => {
    cancelAnimationFrame(requestId);
    requestId = null;
  };
  return throttled;
}
function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}
const d = document;
const w = window;

function waitForEvent(element, eventName) {
  return new Promise((resolve) => {
    const done = (event) => {
      if (event.target === element) {
        element.removeEventListener(eventName, done);
        resolve(event);
      }
    };
    element.addEventListener(eventName, done);
  });
}

class SiteNavigationState {
  constructor() {
    if (!SiteNavigationState.instance) {
      this.menus = [];
      this.active = [];
      this.timeOut = null;
      this.isActive = false;
      SiteNavigationState.instance = this;
    }

    return SiteNavigationState.instance;
  }
  show(menuId) {
    clearTimeout(this.timeOut);
    if (!this.isActive) this.isActive = true;
    this.menus.find(item => item.id === menuId)?.show();
    const prevId = this.active.pop();
    if (menuId !== prevId) this.menus.find(item => item.id === prevId)?.hide(true);
    this.active.push(menuId);
  }
  hide() {
    clearTimeout(this.timeOut);
    this.isActive = false;
    const prevId = this.active.pop();
    this.menus.find(item => item.id === prevId)?.hide();
  }
  focus() {
    clearTimeout(this.timeOut);
  }
  blur(delay = 1000) {
    this.timeOut = setTimeout(this.hide.bind(this), delay);
  }
  addMenu(element) {
    this.menus.push(element);
  }
  get data() {
    return this.menus;
  }
  get activeMenu() {
    return this.isActive;
  }
}
window.siteNavState = new SiteNavigationState();
Object.seal(window.siteNavState);

var HeightObserver = class extends HTMLElement {
  constructor() {
    super();
    if (window.ResizeObserver) {
      new ResizeObserver(this._updateCustomProperties.bind(this)).observe(this);
    }
  }
  connectedCallback() {
    if (!window.ResizeObserver) {
      document.documentElement.style.setProperty(`--${this.dataset.variable}-height`, `${this.clientHeight.toFixed(1)}px`);
    }
  }
  _updateCustomProperties(entries) {
    requestAnimationFrame(() => {
      entries.forEach((entry) => {
        if (entry.target === this) {

          const height = entry.borderBoxSize ? entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.borderBoxSize.blockSize : entry.target.clientHeight;
          document.documentElement.style.setProperty(`--${this.dataset.variable}-height`, `${Math.round(height)}px`);

          // console.log('testing', height, this, entry)
        }
      });
    });
  }
};
if (!window.customElements.get("height-observer")) {
  window.customElements.define("height-observer", HeightObserver);
}

var StoreHeader = class extends HTMLElement {
  connectedCallback() {
    const collapseElement = this.querySelector('[data-collapse]');
    const menuButtonElements = this.querySelectorAll('[data-mega-menu]');
    const megaMenuWrapperElement = this.querySelector('[data-mega-menu-wrapper]');
    const searchButtonElements = this.querySelectorAll('[data-search-toggle]');
    
    this._lastScrollTop = 0;
    this._isCollapse = false;
    this._scroll_collapse = Number(this.dataset.scrollCollapse) || 100;
    this._exitScroll = false;
    this._activeMenuState = [];
    this.holdTimer;
    this.time = 500;
    this._classToggle = 'store-header--active';
    this._classSearchToggle = 'header-search--active';

    this._menuState = window.siteNavState ? new Proxy(window.siteNavState, {
      set: (target, property, value) => {
        if (property === 'isActive') this._toggleMenuActive(value);
        target[property] = value;
        return true;
      }
    }) : false;

    window.addEventListener("scroll", throttle(this._onScroll.bind(this)));
    
    // event listeners    
    collapseElement?.addEventListener("transitionstart", () => this._exitScroll = true);
    collapseElement?.addEventListener("transitionend", this._onTransitionEnd.bind(this));
    megaMenuWrapperElement?.addEventListener('mouseenter', () => this._menuState.focus());
    megaMenuWrapperElement?.addEventListener('mouseleave', () => this._menuState.blur(250));
    Array.from(searchButtonElements).forEach(item => item.addEventListener('click', this._toggleSearch.bind(this)));
    Array.from(menuButtonElements).forEach(item => {
      const menuId = item.getAttribute('aria-controls');
      item?.addEventListener("click", ({currentTarget}) => {
        const isMobileToggle = currentTarget.classList.contains('store-header__utility--toggle');
        const isActive = currentTarget.getAttribute('aria-expanded') === 'true';

        if (isActive || isMobileToggle && this._menuState.activeMenu) {
          this._menuState.hide();
        } else {
          this._menuState.show(menuId);
        }
      });
      if (window.innerWidth > 991) {
        item?.addEventListener("mouseover", () => {
          const timeout = setTimeout(() => {
            // added a small delay to check if still in hover before taking action - solve for pass through actions
            if (item.matches(':hover')) this._menuState.show(menuId);
          }, 450);

          item.addEventListener("mouseout", () => {
            clearTimeout(timeout);
          });
        });
        item?.addEventListener("mouseleave", () => this._menuState.blur());
      }
    });
  }
  collapse() {
    if (!this._isCollapse) {
      this._isCollapse = true;
      this.classList.add('scroll-collapse');
      document.body.classList.add('scrolled');
    }
  }
  expand() {
    if (this._isCollapse) {
      this._isCollapse = false;
      this.classList.remove('scroll-collapse');
      document.body.classList.remove('scrolled');
    }
  }
  _toggleMenuActive(isActive) {
    if (isActive) {
      this.classList.add(this._classToggle);
      document.body.classList.add('menu-active');
    } else {
      this.classList.remove(this._classToggle);
      document.body.classList.remove('menu-active');
    }
  }
  _toggleSearch({currentTarget}) {
    const id = currentTarget.getAttribute('aria-controls');
    const isActive = currentTarget.getAttribute('aria-expanded') === 'true';
    const searchElement = id ? document.getElementById(id) : null;

    if (!searchElement) return;
    if (isActive) {
      searchElement.classList.remove(this._classSearchToggle);
    } else {
      searchElement.classList.add(this._classSearchToggle);
      searchElement.querySelector('input[type="search"]').focus();
    }
    Array.from(document.querySelectorAll(`[aria-controls="${id}"]`)).forEach(item => item.setAttribute('aria-expanded', isActive ? 'false' : 'true'))
  }
  _onTransitionEnd() {
    setTimeout(() => {
      this._exitScroll = false;
    }, 500);
  }
  _onScroll() {
    if (window.scrollY === 0) this.expand();
    if (window.scrollY < 0 || this._exitScroll) return;
    if (window.scrollY > this._scroll_collapse && this._lastScrollTop < window.scrollY) {
      this.collapse();
    } else {
      this.expand();
    }
    this._lastScrollTop = window.scrollY;
  }
};
if (!window.customElements.get("store-header")) {
  window.customElements.define("store-header", StoreHeader);
}

var MegaMenu = class extends HTMLElement {
  constructor() {
    super();
    this._inState = false;
    this._classToggle = 'mega-menu--active';
    this._classToggleSub = 'menu-level--active';
    this._classHoverActive = 'link-active';
    this._classPromoActive = 'promo-active';
  }
  connectedCallback() {
    if (window.siteNavState) {
      window.siteNavState.addMenu(this);
      this._inState = true;
    }
    if (window.megaMenuHeaderPromos?.length) {
      const promos = (this.id === 'mobile-mega-menu')
        ? window.megaMenuHeaderPromos.filter(({isMobile}) => isMobile)
        : window.megaMenuHeaderPromos.filter(({title}) => title === this.dataset.title);
      this._loadPromos(promos);
    }
    Array.from(this.querySelectorAll('[data-mega-sub-menu]')).forEach(item => {
      const menuId = item.getAttribute('aria-controls');
      item?.addEventListener("click", this.showSubMenu.bind(this, menuId, item));
    });
    Array.from(this.querySelectorAll('.menu-level-0 .mega-menu__link')).forEach(item => {
      item?.addEventListener('mouseover', this._handleMouseOver.bind(this));
    })
  }
  async _loadPromos(promos = []) {
    const promosWrapper = this.querySelector('.mega-menu__promo');
    const sections = promos.filter(({isSection}) => isSection);
    const rebuy = promos.filter(({isRebuy}) => isRebuy);
    if (sections.length) {
      const response = await fetch(`/?sections=${sections.map(item => item.id).join(',')}`, {method: 'GET'}).then(response => response.json());
      sections.forEach(({id,url}) => {
        const sectionEle = document.createElement('section');
        const parser = new DOMParser();
        let doc = parser.parseFromString(response[id].replace(/<!--(.*?)-->/gs, '$1'), "text/html");
        // Remove script tags
        Array.from(doc.getElementsByTagName('script')).forEach(script => {script.remove()});
        // Remove section tag
        const section = doc.querySelector('body > section');
        if (section) {
          // Replace section with its own children
          while (section.firstChild) {
            section.parentNode.insertBefore(section.firstChild, section);
          }
          section.remove();
        }
        sectionEle.setAttribute('data-url', url);
        if (!url) sectionEle.classList.add('promo-active');
        sectionEle.innerHTML = doc.body.innerHTML;
        window.addCardShowcaseSection(sectionEle);
        promosWrapper.prepend(sectionEle);
        doc = null;
      });
    }
    if (rebuy.length) {
      rebuy.forEach(({id,url,headline,style,link,link_text}) => {
        const template = `
          <div>
            <div class="promo-headline-wrapper">
              <h4 class="promo-headline">${headline}</h4>
              ${link && link_text ? `<a href="${link}" title="${link_text}">${link_text}</a>` : ''}
            </div>
            <div data-rebuy-id="${id}" class="rebuy-promo rebuy-promo--${style}"></div>
          </div>
        `;
        const sectionEle = document.createElement('section');
        sectionEle.setAttribute('data-url', url);
        if (!url) sectionEle.classList.add('promo-active');

        sectionEle.innerHTML = template;
        
        promosWrapper.prepend(sectionEle);
      });
    }
  }
  _handleMouseOver(event) {
    const {currentTarget} = event;
    const next = currentTarget.nextElementSibling;
    if (window.innerWidth > 991) {
      Array.from(this.querySelectorAll('.menu-level-0 .mega-menu__link')).forEach(item => item.classList.remove(this._classHoverActive));
      if (next) {
        const menuId = next.getAttribute('aria-controls');
        this.showSubMenu(menuId, currentTarget);
        currentTarget.classList.add(this._classHoverActive);
      } else {
        Array.from(this.querySelectorAll('.menu-level-1')).map(item => item.classList.remove(this._classToggleSub));
        Array.from(this.querySelectorAll('.menu-level-0')).map(item => item.classList.add(this._classToggleSub));
        Array.from(this.querySelectorAll('.mega-menu__promo > section')).map(item => (item.dataset.url === 'false') ? item.classList.add(this._classPromoActive) : item.classList.remove(this._classPromoActive));
        this.parentElement.style.removeProperty('--menu-sub-height');
      }
    }
  }
  showSubMenu(id, ele) {
    const buttons = this.querySelectorAll('[data-mega-sub-menu]');
    const menuIds = [];
    const showUrl = ele.tagName === 'BUTTON' ? ele.dataset.href : ele.getAttribute('href');
    Array.from(buttons)
      .filter(item => {
        const itemId = item.getAttribute('aria-controls');
        item.setAttribute('aria-expanded', 'false');
        menuIds.push(itemId);
        return itemId === id;
      })
      .forEach(item => item.setAttribute('aria-expanded', 'true'));
    [...new Set(menuIds)].forEach(item => this.querySelector(`#${item}`)?.classList.remove(this._classToggleSub));
    Array.from(this.querySelectorAll('.mega-menu__promo > section')).forEach(item => {
      const targetUrl = item.dataset.url;
      if (targetUrl === showUrl || showUrl === undefined && targetUrl === 'false') {
        item.classList.add(this._classPromoActive);
      } else {
        item.classList.remove(this._classPromoActive);
      }
    })
    this.querySelector(`#${id}`)?.classList.add(this._classToggleSub);
    if (window.innerWidth > 991) {
      this.parentElement.style.setProperty('--menu-sub-height', `${this.offsetHeight}px`);
    }
  }
  show() {
    Array.from(document.querySelectorAll(`[aria-controls="${this.id}"]`)).map(item => item.setAttribute('aria-expanded', 'true'));
    Array.from(this.querySelectorAll('.menu-level-1')).map(item => item.classList.remove(this._classToggleSub));
    Array.from(this.querySelectorAll('.menu-level-0')).map(item => item.classList.add(this._classToggleSub));
    this.classList.add(this._classToggle);
    // set height of menu on view
    const showHeight = window.innerWidth > 991
      ? `${this.offsetHeight}px`
      : `${window.innerHeight - this.parentElement.previousElementSibling.offsetHeight}px`;
    this.parentElement.style.setProperty('--menu-height', showHeight);
  }
  hide(isSwitch = false) {
    Array.from(document.querySelectorAll(`[aria-controls="${this.id}"]`)).map(item => item.setAttribute('aria-expanded', 'false'));
    this.classList.remove(this._classToggle);
    Array.from(this.querySelectorAll('.menu-level-1')).map(item => item.classList.remove(this._classToggleSub));
    Array.from(this.querySelectorAll('.menu-level-0')).map(item => item.classList.add(this._classToggleSub));
    Array.from(this.querySelectorAll('.menu-level-0 .mega-menu__link')).forEach(item => item.classList.remove(this._classHoverActive));
    Array.from(this.querySelectorAll('.mega-menu__promo > section')).map(item => (item.dataset.url === 'false') ? item.classList.add(this._classPromoActive) : item.classList.remove(this._classPromoActive));
    this.parentElement.style.removeProperty('--menu-sub-height');
    if (isSwitch) return;
    this.parentElement.style.setProperty('--menu-height', `0px`);
  }
};
if (!window.customElements.get("mega-menu")) {
  window.customElements.define("mega-menu", MegaMenu);
}